window.lpAccountStorageReady.then(function () {
  function lpNormaliseDiscordUsername(value) { return String(value || "").trim().replace(/^@/, ""); }
  function lpValidDiscordUsername(value) {
    var name = lpNormaliseDiscordUsername(value);
    return !name || (/^[A-Za-z0-9_.]{2,32}$/.test(name) && name.indexOf("..") < 0) || /^[^@#\s\u0000-\u001f\u007f]{2,32}#[0-9]{4}$/.test(name);
  }
  function lpUpdateDiscordUsername(value) {
    var name = lpNormaliseDiscordUsername(value);
    if (!lpValidDiscordUsername(name)) return false;
    window.lpAccountStorage.setItem("lp_discord_username_v1", name);
    window.dispatchEvent(new CustomEvent("lp-discord-username-change", { detail: { value: name } }));
    return true;
  }
  var lpDomReadyCallbacks = [];
  function lpWhenDomReady(callback) { lpDomReadyCallbacks.push(callback); }
  /* Rôles dont toutes les recommandations (stats, objectifs, plan, starter pack)
     ne proposent QUE du contenu taggé à ce rôle : ni fondamentaux, ni transversal. */
  var LP_RECO_ROLE_STRICT = ["jungle"];
  /* Starter pack « Par où commencer » de chaque rôle, dans l'ordre affiché.
     Remplace le champ starterpack des masterclass pour ces rôles (y compris la
     règle jungle stricte ci-dessus : cette liste est choisie à la main). */
  var LP_STARTER_PACKS = {
    jungle: [
      "88c8b7b0-5fcd-4e07-8382-70db491102b7",  // Perfectionner son premier clear
      "d96dcd08-6732-409b-9308-7d9bb1e1519b",  // Dominer les quatre premiers clears
      "721ab9e8-b880-41ac-8f7a-b016a71d6734",  // Les timings de gank en jungle
      "f9499cd4-5882-4f75-bd3b-59c8f82c3166",  // Les timings d'invade
      "23245488-22b7-4990-aa49-228e65262014",  // Tout savoir sur les timings de back
      "9693079b-8e3b-41de-9bd7-98be3c40bc72",  // Pressure la map grâce aux sidelanes en jungle
      "94f9cc7b-d0bb-4d5d-9294-1eb9f0e65116",  // Le cycle de tempo : FAKeR
      "b1d75c25-dd14-4392-a228-0b4703b8aef3"   // Les 4 manières de jouer un objectif neutre
    ],
    top: [
      "46ae719b-0183-4027-b7e1-c1b0d1ada009",  // FONDAMENTAUX #02 : Trade selon les runes
      "1b3c8ff1-7466-4cb7-8a7e-9e81e39cbfe6",  // FONDAMENTAUX #03 : Ne plus subir le passage lvl 2
      "c7ea55d5-f1c4-439d-8738-5401febf60b4",  // FONDAMENTAUX #04 : Wave management = kill
      "23245488-22b7-4990-aa49-228e65262014",  // Tout savoir sur les timings de back
      "7d419bb2-fa97-4799-b003-8a431cf08901",  // Avoir de l'impact en tant que toplaner
      "78e9f414-5385-42e5-87b4-f23844f54466",  // J'ai gagné ma lane... et maintenant ?
      "f7e586a4-f326-4662-bb04-b28658d65ae1",  // FONDAMENTAUX #05 : Le choix de lane en midgame
      "970ad2fc-ca2b-4944-81aa-e09eaa11de9d",  // FONDAMENTAUX #06 : Les trois zones en midgame
      "6c68fbe4-d555-424e-8dfa-2679c85a3f6a"   // Splitpush : le guide complet
    ],
    mid: [
      "8f18bfcb-afba-4047-9d01-55a18c82c9cd",  // Trading 101 (les bases du trading)
      "8bb494b5-5467-420f-89f1-c8ec064c1159",  // Comment jouer TOUS les matchups en midlane ?
      "46ae719b-0183-4027-b7e1-c1b0d1ada009",  // FONDAMENTAUX #02 : Trade selon les runes
      "1b3c8ff1-7466-4cb7-8a7e-9e81e39cbfe6",  // FONDAMENTAUX #03 : Ne plus subir le passage lvl 2
      "c7ea55d5-f1c4-439d-8738-5401febf60b4",  // FONDAMENTAUX #04 : Wave management = kill
      "ccca7334-a8a0-4322-9cd8-112dc5ca08f8",  // Le roaming en midlane
      "23245488-22b7-4990-aa49-228e65262014",  // Tout savoir sur les timings de back
      "f7e586a4-f326-4662-bb04-b28658d65ae1",  // FONDAMENTAUX #05 : Le choix de lane en midgame
      "970ad2fc-ca2b-4944-81aa-e09eaa11de9d"   // FONDAMENTAUX #06 : Les trois zones en midgame
    ],
    adc: [
      "3fb3880b-16a2-4f2a-b8ce-4ba96914147f",  // Scale en tant qu'ADC (et l'aider à scale)
      "46ae719b-0183-4027-b7e1-c1b0d1ada009",  // FONDAMENTAUX #02 : Trade selon les runes
      "1b3c8ff1-7466-4cb7-8a7e-9e81e39cbfe6",  // FONDAMENTAUX #03 : Ne plus subir le passage lvl 2
      "c7ea55d5-f1c4-439d-8738-5401febf60b4",  // FONDAMENTAUX #04 : Wave management = kill
      "9935188f-332e-4145-ae25-5c17734f5770",  // Comment jouer avec un mauvais support ?
      "23245488-22b7-4990-aa49-228e65262014",  // Tout savoir sur les timings de back
      "3cb7b000-2850-4f38-ae8a-2f819081686b",  // Les bases de la macro en ADC
      "9217443c-4ade-4f0b-a926-079ccf5a938c"   // Bien teamfight en ADC
    ],
    support: [
      "46ae719b-0183-4027-b7e1-c1b0d1ada009",  // FONDAMENTAUX #02 : Trade selon les runes
      "1b3c8ff1-7466-4cb7-8a7e-9e81e39cbfe6",  // FONDAMENTAUX #03 : Ne plus subir le passage lvl 2
      "b1607833-bbf7-41f1-b601-266479948227",  // L'impact sur la map en support
      "23245488-22b7-4990-aa49-228e65262014",  // Tout savoir sur les timings de back
      "9392a204-4f8c-4f54-b059-86a0f152fbc8",  // Comment warder efficacement ?
      "d1023e2e-320e-42a6-afe9-85d135eb71f1"   // Les cycles de jeu en support
    ]
  };
  function lpRecoCardPourRole(card, role) {
    if (LP_RECO_ROLE_STRICT.indexOf(role) < 0) return true;
    return (card.dataset.role || "").trim().toLowerCase() === role;
  }
/* Legends Path, espace membre (dashboard). Nécessite les constantes LP_* définies dans le template. */


  // Lien du suivi : metafield posé par le coach, sinon lien relié par l'élève.
  window.lpGetSheetUrl = function () {
    if (LP_SHEET_URL) return LP_SHEET_URL;
    try {
      return window.lpAccountStorage.getItem(LP_SHEET_KEY) || "";
    } catch (e) {
      return "";
    }
  };

  function lpHasLocalFreeUnlock() {
    try {
      return window.lpAccountStorage.getItem(LP_FREE_UNLOCK_STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function lpSetLocalFreeUnlock() {
    try {
      window.lpAccountStorage.setItem(LP_FREE_UNLOCK_STORAGE_KEY, "1");
    } catch (e) {}
  }

  function lpHasFreeMasterclassAccess() {
    return LP_SERVER_FREE_MASTERCLASS_ACCESS || lpHasLocalFreeUnlock();
  }

  function lpGetWatchedMasterclasses() {
    try {
      const raw = window.lpAccountStorage.getItem(LP_WATCHED_MASTERCLASS_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function lpIsMasterclassWatched(cardId) {
    if (!cardId) return false;
    return lpGetWatchedMasterclasses().includes(cardId);
  }

  function lpSetMasterclassWatched(cardId) {
    if (!cardId) return;

    try {
      const watched = lpGetWatchedMasterclasses();
      if (!watched.includes(cardId)) {
        watched.push(cardId);
        window.lpAccountStorage.setItem(LP_WATCHED_MASTERCLASS_STORAGE_KEY, JSON.stringify(watched));
      }
    } catch (e) {}
  }

  function lpUnsetMasterclassWatched(cardId) {
    if (!cardId) return;

    try {
      const watched = lpGetWatchedMasterclasses().filter((id) => id !== cardId);
      window.lpAccountStorage.setItem(LP_WATCHED_MASTERCLASS_STORAGE_KEY, JSON.stringify(watched));
    } catch (e) {}
  }

  function lpToggleMasterclassWatched(cardId) {
    if (lpIsMasterclassWatched(cardId)) {
      lpUnsetMasterclassWatched(cardId);
    } else {
      lpSetMasterclassWatched(cardId);
    }
  }

  window.lpRefreshWatchedMasterclassesUI = function () {
    const cards = document.querySelectorAll("#lpMasterclassCards .card, #lpStarterCards .card");
    if (!cards.length) return;

    let watchedCount = 0;

    cards.forEach((card) => {
      const imageWrap = card.querySelector(".card-image");
      if (!imageWrap) return;

      let badge = card.querySelector(".card-watched-badge");
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "card-watched-badge";
        badge.textContent = "✓ Déjà regardée";
        imageWrap.appendChild(badge);
      }

      let toggle = card.querySelector(".lp-watch-toggle");
      if (!toggle) {
        toggle = document.createElement("button");
        toggle.type = "button";
        toggle.className = "lp-watch-toggle";
        imageWrap.appendChild(toggle);
      }

      const watched = lpIsMasterclassWatched(card.id);
      if (watched) watchedCount++;

      card.classList.toggle("is-watched", watched);
      badge.style.display = watched ? "inline-flex" : "none";
      toggle.setAttribute("aria-pressed", watched ? "true" : "false");
      toggle.title = watched ? "Retirer des masterclass vues" : "Marquer comme vue";
    });

    const countEl = document.getElementById("lpWatchProgressCount");
    const fillEl = document.getElementById("lpWatchProgressFill");

    if (countEl) {
      countEl.textContent = watchedCount + " / " + cards.length + " vues";
    }

    if (fillEl) {
      fillEl.style.width = cards.length
        ? Math.round((watchedCount / cards.length) * 100) + "%"
        : "0%";
    }
  };

  window.lpSyncPresentationVideos = function () {
    const frames = document.querySelectorAll("iframe[data-lp-video]");

    frames.forEach((frame) => {
      const onboarding = frame.closest("#lpOnboarding");
      const panel = frame.closest(".lp-panel");
      const benefitPanel = frame.closest(".lp-benefits__panel");

      let visible = true;

      if (onboarding) {
        visible = onboarding.style.display !== "none";
      } else if (panel) {
        visible = panel.classList.contains("is-active");
      }

      if (visible && benefitPanel) {
        visible = benefitPanel.classList.contains("is-active");
      }

      const src = frame.dataset.src || "";

      if (visible) {
        if (src && frame.getAttribute("src") !== src) {
          frame.setAttribute("src", src);
        }
      } else if (frame.getAttribute("src")) {
        frame.setAttribute("src", "about:blank");
      }
    });

    const vodPanel = document.getElementById("lpPanelVod");

    if (vodPanel && !vodPanel.classList.contains("is-active")) {
      vodPanel.querySelectorAll("video").forEach((v) => {
        try {
          v.pause();
        } catch (e) {}
      });
    }
  };

  (function () {
    const modal = document.getElementById("lpLockModal");
    const closeBtn = document.getElementById("lpLockModalClose");

    if (!modal) return;

    window.lpOpenLockModal = function () {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
    };

    window.lpCloseLockModal = function () {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
    };

    if (closeBtn) {
      closeBtn.addEventListener("click", window.lpCloseLockModal);
    }

    modal.addEventListener("click", function (e) {
      if (e.target === modal) window.lpCloseLockModal();
    });

    // Vidéos de présentation verrouillées (non-abonnés) → modale d'abonnement
    document.addEventListener("click", function (e) {
      if (e.target.closest(".lp-video-locked")) {
        window.lpOpenLockModal();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        window.lpCloseLockModal();

        if (window.lpCloseFreeUnlockModal) window.lpCloseFreeUnlockModal();
        if (window.lpCloseChoiceModal) window.lpCloseChoiceModal();
        if (window.lpCloseBaselineModal) window.lpCloseBaselineModal();
        if (window.lpCloseGameModal) window.lpCloseGameModal();
        if (window.lpCloseSheetLinkModal) window.lpCloseSheetLinkModal();

        const vc = document.querySelector(".video-container");
        if (vc && vc.classList.contains("is-open")) {
          vc.classList.remove("is-open");
          vc.style.transform = "translate(0, 100vh)";
          const upsell = document.getElementById("lpVideoUpsell");
          if (upsell) upsell.style.display = "none";

          setTimeout(() => {
            const vp = document.getElementById("videoPlayer");
            if (vp) vp.src = "";
          }, 600);
        }
      }
    });
  })();

  (function () {
    const modal = document.getElementById("lpFreeUnlockModal");
    const closeBtn = document.getElementById("lpFreeUnlockModalClose");
    const form =
      document.getElementById("lpFreeUnlockForm") || modal.querySelector("form");
    const statusEl = document.getElementById("lpFreeUnlockStatus");
    const submitBtn = document.getElementById("lpFreeUnlockSubmit");
    const openBtn = document.getElementById("lpFreeUnlockBtn");

    if (!modal) return;

    window.lpOpenFreeUnlockModal = function () {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
    };

    window.lpCloseFreeUnlockModal = function () {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      if (statusEl) statusEl.textContent = "";
    };

    if (closeBtn) {
      closeBtn.addEventListener("click", window.lpCloseFreeUnlockModal);
    }

    modal.addEventListener("click", function (e) {
      if (e.target === modal) window.lpCloseFreeUnlockModal();
    });

    if (openBtn) {
      openBtn.addEventListener("click", function () {
        if (lpHasFreeMasterclassAccess()) {
          const card = document.querySelector('#lpMasterclassCards .card[data-free-masterclass="true"], #lpStarterCards .card[data-free-masterclass="true"]');
          if (card) {
            card.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return;
        }

        window.lpOpenFreeUnlockModal();
      });
    }

    if (!form) return;

    async function handleUnlockSubmit(e) {
      if (e && e.preventDefault) e.preventDefault();

      const emailInput = document.getElementById("lpFreeUnlockEmail");
      const email = ((emailInput && emailInput.value) || "").trim();

      if (!email) {
        statusEl.textContent = "Renseigne un email valide.";
        return;
      }

      submitBtn.disabled = true;
      statusEl.textContent = "Déblocage en cours…";

      lpSetLocalFreeUnlock();

      if (window.lpRefreshFreeMasterclassAccessUI) {
        window.lpRefreshFreeMasterclassAccessUI();
      }

      statusEl.textContent = "Masterclass débloquée.";
      submitBtn.textContent = "Masterclass débloquée";

      setTimeout(function () {
        window.lpCloseFreeUnlockModal();
        const card = document.querySelector('#lpMasterclassCards .card[data-free-masterclass="true"], #lpStarterCards .card[data-free-masterclass="true"]');
        if (card) {
          card.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 700);

      /* Même raison que pour l'onboarding : seul un envoi natif passe le
         reCAPTCHA de Shopify. L'aide est définie plus bas dans le fichier,
         d'où l'appel par window au moment du clic. */
      try {
        if (window.lpEnvoiFormulaireClient) {
          window.lpEnvoiFormulaireClient(form);
        }
      } catch (err) {
        console.warn("Envoi marketing impossible, mais masterclass débloquée localement.");
      } finally {
        submitBtn.disabled = false;
      }
    }

    if (submitBtn) submitBtn.addEventListener("click", handleUnlockSubmit);
    form.addEventListener("submit", handleUnlockSubmit);
    modal.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target && e.target.tagName === "INPUT") handleUnlockSubmit(e);
    });
  })();

  /* L'espace membre s'ouvre directement sur le dashboard. Une étoile signale
     la Présentation tant qu'elle n'a pas été ouverte une première fois -
     une invitation, plus un passage obligé. */
  (function () {
    if (!LP_IS_SUBSCRIBER) return;
    const KEY = "lp_presentation_seen_v1";
    const star = document.getElementById("lpPresentationStar");
    const tab = document.querySelector('.lp-tab[data-target="lpPanelPresentation"]');
    if (!star || !tab) return;

    let vu = true;
    try {
      vu = window.lpAccountStorage.getItem(KEY) === "1";
    } catch (e) {}

    star.hidden = vu;

    tab.addEventListener("click", function () {
      star.hidden = true;
      try {
        window.lpAccountStorage.setItem(KEY, "1");
      } catch (e) {}
    });
  })();

  (function () {
    const dash = document.getElementById("lpDashboard");
    if (!dash) return;

    // Seuls les onglets avec une cible sont des onglets de navigation
    // (le bouton "Outils" déplie son groupe, il n'a pas de data-target).
    const tabs = Array.from(document.querySelectorAll(".lp-sidebar .lp-tab")).filter(
      (t) => t.dataset.target
    );
    const panels = dash.querySelectorAll(".lp-panel");
    const KEY = "lp_active_tab_v1";
    const titleEl = document.getElementById("lpTopbarTitle");

    const TAB_TITLES = {
      lpPanelSynthese: "Synthèse",
      lpPanelObjectifs: "Objectifs",
      lpPanelPresentation: "Présentation",
      lpPanelMasterclass: "Masterclass",
      lpPanelSmurf: "Smurf commentaries",
      lpPanelCollectifs: (window.lpSubscriberWelcomeLabels && window.lpSubscriberWelcomeLabels.coaching) || "Coaching",
      lpPanelVod: "Review VOD",
      lpPanelStats: "Suivi de statistiques",
      lpPanelMental: "Mental",
      lpPanelOutils: "Outils"
    };

    const toolsGroup = document.getElementById("lpToolsGroup");
    const toolsHead = document.getElementById("lpToolsGroupHead");
    const subtabs = document.querySelectorAll(".lp-subtab");

    function activate(id) {
      tabs.forEach((t) => t.classList.toggle("active", t.dataset.target === id));
      panels.forEach((p) => p.classList.toggle("is-active", p.id === id));

      if (toolsHead) toolsHead.classList.toggle("active", id === "lpPanelOutils");
      if (id !== "lpPanelOutils") {
        subtabs.forEach((s) => s.classList.remove("active"));
      }

      if (titleEl && TAB_TITLES[id]) {
        titleEl.textContent = TAB_TITLES[id];
      }

      if (window.lpSyncPresentationVideos) window.lpSyncPresentationVideos();

      try {
        sessionStorage.setItem(KEY, id);
      } catch (e) {}

      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    if (toolsHead) {
      toolsHead.addEventListener("click", () => {
        // En barre mobile, "Outils" est un onglet direct ; en desktop il se déplie
        if (window.innerWidth < 1024) {
          activate("lpPanelOutils");
          return;
        }
        toolsGroup.classList.toggle("is-open");
      });
    }

    subtabs.forEach((s) => {
      s.addEventListener("click", () => {
        activate("lpPanelOutils");
        subtabs.forEach((x) => x.classList.toggle("active", x === s));

        const anchor = document.getElementById(s.dataset.toolAnchor);
        if (anchor) {
          setTimeout(() => {
            anchor.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 120);
        }
      });
    });

    window.lpActivateDashboardTab = activate;

    function handleReviewClick(btn) {
      if (btn.dataset.locked === "true") {
        if (window.lpOpenLockModal) {
          window.lpOpenLockModal();
        }
        return;
      }

      if (window.lpOpenChoiceModal) {
        window.lpOpenChoiceModal();
      }
    }

    const topBtn = document.getElementById("lpRequestReviewTop");
    if (topBtn) {
      topBtn.addEventListener("click", () => handleReviewClick(topBtn));
    }

    const sideBtn = document.getElementById("lpRequestReviewSide");
    if (sideBtn) {
      sideBtn.addEventListener("click", () => handleReviewClick(sideBtn));
    }

    let initial = "lpPanelSynthese";

    try {
      const saved = sessionStorage.getItem(KEY);
      if (saved && dash.querySelector("#" + saved)) {
        const linkedTab = Array.from(tabs).find((t) => t.dataset.target === saved);
        if (linkedTab && linkedTab.dataset.locked !== "true") {
          initial = saved;
        }
      }
    } catch (e) {}

    tabs.forEach((t) => {
      t.addEventListener("click", () => {
        if (t.dataset.locked === "true") {
          window.lpOpenLockModal();
          return;
        }
        activate(t.dataset.target);
      });
    });

    activate(initial);
  })();

  (function () {
    const app = document.querySelector(".lp-app");
    const btn = document.getElementById("lpSidebarCollapse");
    if (!app || !btn) return;

    const KEY = "lp_sidebar_collapsed_v1";

    function apply(on) {
      app.classList.toggle("is-collapsed", on);
    }

    let saved = false;
    try {
      saved = window.lpAccountStorage.getItem(KEY) === "1";
    } catch (e) {}
    apply(saved);

    btn.addEventListener("click", function () {
      const on = !app.classList.contains("is-collapsed");
      apply(on);
      try {
        window.lpAccountStorage.setItem(KEY, on ? "1" : "0");
      } catch (e) {}
    });
  })();

  // Onglet Importer : "Voir le guide" ouvre la Présentation sur la vidéo
  // "Legends Path Importer" (3e entrée des avantages).
  (function () {
    document.querySelectorAll(".lp-importer-guide").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (typeof window.lpActivateDashboardTab === "function") {
          window.lpActivateDashboardTab("lpPanelPresentation");
        }
        setTimeout(function () {
          const tab = document.querySelector('#lpPanelPresentation .lp-benefits__tab[data-benefit-index="2"]');
          if (tab) {
            tab.click();
            tab.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 250);
      });
    });
  })();

  lpWhenDomReady(function () {
    const modules = document.querySelectorAll("[data-lp-benefits]");
    if (!modules.length) return;

    modules.forEach((module) => {
      const tabs = module.querySelectorAll(".lp-benefits__tab");
      const panels = module.querySelectorAll(".lp-benefits__panel");

      function activate(index) {
        tabs.forEach((btn) =>
          btn.classList.toggle("active", btn.dataset.benefitIndex === String(index))
        );
        panels.forEach((panel) =>
          panel.classList.toggle("is-active", panel.dataset.benefitPanel === String(index))
        );

        if (window.lpSyncPresentationVideos) window.lpSyncPresentationVideos();
      }

      tabs.forEach((btn) => {
        btn.addEventListener("click", function () {
          activate(btn.dataset.benefitIndex || "0");
        });
      });

      activate("0");
    });
  });




  function sortCardsPinnedThenDate(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const items = Array.from(container.children);

    items.forEach((el, i) => {
      el.dataset.idx = i;
    });

    items.sort((a, b) => {
      const aFreeUnlocked =
        !LP_IS_SUBSCRIBER && a.dataset.freeMasterclass === "true" ? 1 : 0;

      const bFreeUnlocked =
        !LP_IS_SUBSCRIBER && b.dataset.freeMasterclass === "true" ? 1 : 0;

      if (bFreeUnlocked !== aFreeUnlocked) {
        return bFreeUnlocked - aFreeUnlocked;
      }

      const wa = parseInt(a.dataset.pinWeight || "0", 10) || 0;
      const wb = parseInt(b.dataset.pinWeight || "0", 10) || 0;

      if (wb !== wa) {
        return wb - wa;
      }

      const aIsFondamentaux = (a.dataset.categories || "")
        .toLowerCase()
        .includes("fondamentaux")
        ? 1
        : 0;

      const bIsFondamentaux = (b.dataset.categories || "")
        .toLowerCase()
        .includes("fondamentaux")
        ? 1
        : 0;

      if (bIsFondamentaux !== aIsFondamentaux) {
        return bIsFondamentaux - aIsFondamentaux;
      }

      const ha = parseInt(a.dataset.hasDate || "0", 10) || 0;
      const hb = parseInt(b.dataset.hasDate || "0", 10) || 0;

      if (hb !== ha) {
        return hb - ha;
      }

      if (ha === 1 && hb === 1) {
        const da = parseInt(a.dataset.dateTs || "0", 10) || 0;
        const db = parseInt(b.dataset.dateTs || "0", 10) || 0;

        if (db !== da) {
          return db - da;
        }
      }

      return (parseInt(a.dataset.idx, 10) || 0) - (parseInt(b.dataset.idx, 10) || 0);
    });

    items.forEach((el) => container.appendChild(el));
  }

  window.lpRefreshFreeMasterclassAccessUI = function () {
    const unlocked = lpHasFreeMasterclassAccess();

    const freeCards = document.querySelectorAll(
      '#lpMasterclassCards .card[data-free-masterclass="true"], #lpStarterCards .card[data-free-masterclass="true"]'
    );

    freeCards.forEach((card) => {
      const badge = card.querySelector(".card-lock-badge");

      if (LP_IS_SUBSCRIBER || unlocked || card.dataset.serverFreeAccess === "true") {
        card.dataset.locked = "false";
        card.classList.remove("is-locked");
        card.classList.add("card--exclusive-unlocked");
        if (badge) badge.textContent = "Débloquée";
      } else if (!LP_IS_SUBSCRIBER) {
        card.dataset.locked = "true";
        card.classList.add("is-locked");
        card.classList.remove("card--exclusive-unlocked");
        if (badge) badge.textContent = "Gratuit par email";
      }
    });

    const banner = document.getElementById("lpFreeUnlockBanner");
    const bannerBtn = document.getElementById("lpFreeUnlockBtn");
    const bannerText = document.getElementById("lpFreeUnlockText");

    if (banner && !LP_IS_SUBSCRIBER && unlocked) {
      if (bannerBtn) bannerBtn.textContent = "Masterclass débloquée";
      if (bannerText) {
        bannerText.innerHTML =
          `Tu peux maintenant regarder <strong>${LP_FREE_MASTERCLASS_TITLE}</strong>. ` +
          `Toutes les autres masterclass restent réservées aux abonnés.`;
      }
    }

    /* Le repère « 1 offerte » de l onglet n a plus lieu d etre une fois pris. */
    var mcBadge = document.querySelector('[data-target="lpPanelMasterclass"] .lp-tab__badge');
    if (mcBadge && unlocked) mcBadge.remove();

    sortCardsPinnedThenDate("lpMasterclassCards");

    if (window.lpApplyMasterclassFilters) {
      window.lpApplyMasterclassFilters();
    }

    if (window.lpRefreshWatchedMasterclassesUI) {
      window.lpRefreshWatchedMasterclassesUI();
    }
  };

  lpWhenDomReady(function () {
    let selectedRole = null;
    const selectedCats = new Set();
    let searchQuery = "";
    let watchedFilter = null;
    let modeFondamentaux = false;

    const rolesImages = document.querySelectorAll("#lpPanelMasterclass .filter-roles img");
    const catChips = document.querySelectorAll("#lpPanelMasterclass .filter-cats .chip");
    const watchChips = document.querySelectorAll("#lpPanelMasterclass .filter-watch .chip");
    const cards = document.querySelectorAll("#lpMasterclassCards .card");
    const searchInput = document.querySelector("#lpPanelMasterclass .search-input");
    const starterSection = document.getElementById("lpStarterSection");
    const starterCardsWrap = document.getElementById("lpStarterCards");
    const starterSectionTitle = document.getElementById("lpStarterSectionTitle");
    const mainCardsWrap = document.getElementById("lpMasterclassCards");
    const starterSectionSub = document.getElementById("lpStarterSectionSub");
    const starterDivider = starterSection ? starterSection.querySelector(".lp-starter-section__divider span") : null;
    const texteSubRole = starterSectionSub ? starterSectionSub.textContent : "";
    const texteDividerRole = starterDivider ? starterDivider.textContent : "";

    // Ordre d'origine du template, pour départager deux cartes sans date.
    cards.forEach((card, i) => {
      card.dataset.ordre = String(i);
    });

    const roleLabels = {
      top: "Top",
      jungle: "Jungle",
      mid: "Mid",
      adc: "ADC",
      support: "Support"
    };

    function normalizeText(value) {
      return (value || "").trim().toLowerCase();
    }

    function normalizeList(csv) {
      if (!csv) return [];
      return csv
        .split(",")
        .map((x) => x.trim().toLowerCase())
        .filter(Boolean);
    }

    function starterMetaRole(role) {
      return role === "support" ? "supp" : role;
    }

    function starterPackListe(role) {
      return Object.prototype.hasOwnProperty.call(LP_STARTER_PACKS, role) ? LP_STARTER_PACKS[role] : null;
    }

    function cardIsInStarterPack(card, role) {
      if (!role) return false;
      const liste = starterPackListe(role);
      if (liste) return liste.indexOf(card.id.split("?")[0]) > -1;
      const packs = normalizeList(card.dataset.starterpack || "");
      return packs.includes(starterMetaRole(role)) && lpRecoCardPourRole(card, role);
    }

    /* Série « FONDAMENTAUX #01 », « #02 »… : son numéro, lu dans le titre. */
    function numeroFondamental(card) {
      const m = (card.dataset.title || "").match(/fondamentaux\s*#\s*0*(\d+)/i);
      return m ? parseInt(m[1], 10) : null;
    }

    function parNumero(a, b) {
      return numeroFondamental(a) - numeroFondamental(b);
    }

    function parDate(a, b) {
      const ha = parseInt(a.dataset.hasDate || "0", 10) || 0;
      const hb = parseInt(b.dataset.hasDate || "0", 10) || 0;
      if (hb !== ha) return hb - ha;
      const da = parseInt(a.dataset.dateTs || "0", 10) || 0;
      const db = parseInt(b.dataset.dateTs || "0", 10) || 0;
      if (db !== da) return db - da;
      return (parseInt(a.dataset.ordre, 10) || 0) - (parseInt(b.dataset.ordre, 10) || 0);
    }

    function aucunFiltre() {
      return !selectedRole && selectedCats.size === 0 && !searchQuery && !watchedFilter;
    }

    function retireUne() {
      cards.forEach((card) => {
        card.classList.remove("is-une", "lp-apres-une");
        delete card.dataset.une;
      });
    }

    /* Bibliothèque sans aucun filtre : dernier patch et dernière masterclass
       seuls sur la première ligne, puis la série Fondamentaux de 1 à 10, puis
       tout le reste par date. Les cartes restent dans la même grille : seul
       leur ordre change, le reste du fichier les retrouve comme avant. */
    function ordreAccueil() {
      const items = Array.from(mainCardsWrap.children).filter((c) => c.classList.contains("card"));
      const epinglee = (poids) =>
        items.filter((c) => (parseInt(c.dataset.pinWeight || "0", 10) || 0) === poids).sort(parDate)[0] || null;
      const patch = epinglee(3);
      const master = epinglee(2);
      const une = [patch, master].filter(Boolean);
      const serie = items.filter((c) => une.indexOf(c) < 0 && numeroFondamental(c) !== null).sort(parNumero);
      const reste = items.filter((c) => une.indexOf(c) < 0 && serie.indexOf(c) < 0).sort(parDate);

      une.concat(serie, reste).forEach((c) => mainCardsWrap.appendChild(c));

      if (patch) {
        patch.classList.add("is-une");
        patch.dataset.une = "Dernier patch";
      }
      if (master) {
        master.classList.add("is-une");
        master.dataset.une = "Dernière masterclass";
      }
      const suivante = serie[0] || reste[0];
      if (une.length && suivante) suivante.classList.add("lp-apres-une");
    }

    function updateStarterPack() {
      if (!starterSection || !starterCardsWrap || !mainCardsWrap) return;

      Array.from(starterCardsWrap.children).forEach((card) => {
        mainCardsWrap.appendChild(card);
      });
      retireUne();
      modeFondamentaux = false;

      if (selectedRole) {
        const liste = starterPackListe(selectedRole);
        if (liste) {
          /* Ordre de la liste, pas celui de la page. */
          liste.forEach((id) => {
            const card = Array.from(cards).find((c) => c.id.split("?")[0] === id);
            if (card) starterCardsWrap.appendChild(card);
          });
        } else {
          cards.forEach((card) => {
            if (cardIsInStarterPack(card, selectedRole)) {
              starterCardsWrap.appendChild(card);
            }
          });
        }

        if (starterSectionTitle) {
          const label = roleLabels[selectedRole] || selectedRole;
          starterSectionTitle.textContent = "Par où commencer, " + label;
        }
        if (starterSectionSub) starterSectionSub.textContent = texteSubRole;
        if (starterDivider) starterDivider.textContent = texteDividerRole;
      } else if (selectedCats.has("fondamentaux")) {
        /* Fondamentaux sans rôle : la série #01, #02… en starter pack, dans
           l'ordre ; les autres fondamentaux restent en dessous. */
        modeFondamentaux = true;
        Array.from(cards)
          .filter((card) => numeroFondamental(card) !== null)
          .sort(parNumero)
          .forEach((card) => starterCardsWrap.appendChild(card));

        if (starterSectionTitle) starterSectionTitle.textContent = "Par où commencer, Fondamentaux";
        if (starterSectionSub) starterSectionSub.textContent = "La série Fondamentaux, à regarder dans l'ordre.";
        if (starterDivider) starterDivider.textContent = "Les autres fondamentaux";
      }

      if (aucunFiltre()) ordreAccueil();
      else sortCardsPinnedThenDate("lpMasterclassCards");
    }

    function cardMatchesRole(card) {
      const cardRole = normalizeText(card.dataset.role);
      const isFill = cardRole === "fill";
      return isFill || !selectedRole || cardRole === selectedRole;
    }

    function cardMatchesCats(card) {
      if (selectedCats.size === 0) return true;

      const cardCats = new Set(normalizeList(card.dataset.categories || ""));
      if (cardCats.size === 0) return false;

      for (const wanted of selectedCats) {
        if (!cardCats.has(wanted)) return false;
      }

      return true;
    }

    function cardMatchesWatch(card) {
      if (!watchedFilter) return true;

      const watched = lpIsMasterclassWatched(card.id);
      return watchedFilter === "watched" ? watched : !watched;
    }

    function cardMatchesSearch(card) {
      if (!searchQuery) return true;
      const title = normalizeText(card.dataset.title || "");
      return title.includes(searchQuery);
    }

    function applyFilters() {
      updateStarterPack();

      let starterVisible = 0;

      cards.forEach((card) => {
        const inStarter = starterCardsWrap ? starterCardsWrap.contains(card) : false;
        const roleOk = inStarter ? true : cardMatchesRole(card);
        const visible =
          roleOk && cardMatchesCats(card) && cardMatchesSearch(card) && cardMatchesWatch(card);

        card.style.display = visible ? "block" : "none";

        if (inStarter && visible) starterVisible++;
      });

      if (starterSection) {
        starterSection.style.display = (selectedRole || modeFondamentaux) && starterVisible > 0 ? "block" : "none";
      }
    }

    window.lpApplyMasterclassFilters = applyFilters;

    function handleClickRole(img) {
      const isSelected = img.classList.contains("selected");

      if (isSelected) {
        img.classList.remove("selected");
        selectedRole = null;
      } else {
        rolesImages.forEach((r) => r.classList.remove("selected"));
        img.classList.add("selected");
        selectedRole = normalizeText(img.alt || "");
      }

      applyFilters();
    }

    rolesImages.forEach((img) => img.addEventListener("click", () => handleClickRole(img)));

    function handleClickCat(chip) {
      const cat = normalizeText(chip.dataset.cat || "");
      if (!cat) return;

      if (chip.classList.contains("selected")) {
        chip.classList.remove("selected");
        selectedCats.delete(cat);
      } else {
        chip.classList.add("selected");
        selectedCats.add(cat);
      }

      applyFilters();
    }

    catChips.forEach((chip) => chip.addEventListener("click", () => handleClickCat(chip)));

    watchChips.forEach((chip) => {
      chip.addEventListener("click", () => {
        const mode = chip.dataset.watch || null;

        if (watchedFilter === mode) {
          watchedFilter = null;
          chip.classList.remove("selected");
        } else {
          watchedFilter = mode;
          watchChips.forEach((c) => c.classList.remove("selected"));
          chip.classList.add("selected");
        }

        applyFilters();
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", function (e) {
        searchQuery = normalizeText(e.target.value || "");
        applyFilters();
      });
    }

    sortCardsPinnedThenDate("lpMasterclassCards");
    applyFilters();
    window.lpRefreshFreeMasterclassAccessUI();
    window.lpRefreshWatchedMasterclassesUI();
  });

  lpWhenDomReady(function () {
    let selectedRole = null;
    let searchQuery = "";

    const rolesImages = document.querySelectorAll("#lpPanelSmurf .filter-roles img");
    const cards = document.querySelectorAll("#lpSmurfCards .card");
    const searchInput = document.getElementById("lpSmurfSearch");

    function apply() {
      cards.forEach((card) => {
        const isFill = (card.dataset.role || "").trim().toLowerCase() === "fill";
        const roleOk = isFill || !selectedRole || card.dataset.role === selectedRole;
        const titleOk =
          !searchQuery || (card.dataset.title || "").toLowerCase().includes(searchQuery);

        card.style.display = roleOk && titleOk ? "block" : "none";
      });
    }

    function handleClickRole(img) {
      const isSelected = img.classList.contains("selected");

      if (isSelected) {
        img.classList.remove("selected");
        selectedRole = null;
      } else {
        rolesImages.forEach((r) => r.classList.remove("selected"));
        img.classList.add("selected");
        selectedRole = (img.alt || "").trim().toLowerCase();
      }

      apply();
    }

    rolesImages.forEach((img) => img.addEventListener("click", () => handleClickRole(img)));

    if (searchInput) {
      searchInput.addEventListener("input", (e) => {
        searchQuery = (e.target.value || "").trim().toLowerCase();
        apply();
      });
    }

    sortCardsPinnedThenDate("lpSmurfCards");
    apply();
  });

  /* --------------------------------------------------------------------------
     Coachings collectifs

     Le planning et la prochaine session vivent ici, à partir de
     LP_CC_SESSIONS (gabarit). Tipo n'entre en jeu qu'au moment de réserver :
     la page ne dépend plus de son widget pour afficher quoi que ce soit.
     Tout est calculé à l'heure de Paris, celle des sessions.
     -------------------------------------------------------------------------- */
  lpWhenDomReady(function () {
    var liste = document.getElementById("lpCcJours");
    var quandEl = document.getElementById("lpCcQuand");
    if (!liste || !quandEl) return;

    var sessions = (typeof LP_CC_SESSIONS !== "undefined" && LP_CC_SESSIONS.length ? LP_CC_SESSIONS : []).slice();
    if (!sessions.length) return;

    var DUREE = typeof LP_CC_DUREE_MIN === "number" ? LP_CC_DUREE_MIN : 90;
    var JOURS = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    var COULEURS = { sprray: "#e3fc02", pop: "#4cc2ff", breniak: "#b78bfa" };

    var avecEl = document.getElementById("lpCcAvec");
    var delaiEl = document.getElementById("lpCcDelai");
    var noteEl = document.getElementById("lpCcNote");
    var bouton = document.getElementById("lpCcReserver");
    var priseEl = document.getElementById("lpCcPrise");
    var ordre = [];

    function couleurCoach(nom) {
      return COULEURS[String(nom || "").toLowerCase()] || "#9aa3ae";
    }

    /* Minute de la semaine à Paris : le calcul ne dépend ni du fuseau ni de
       l'heure du visiteur. */
    function minuteParis() {
      var parts = {};
      new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Paris", weekday: "short", hour: "2-digit", minute: "2-digit", hour12: false
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      var index = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[parts.weekday];
      if (index === undefined) return null;
      var heure = parseInt(parts.hour, 10) % 24;
      return index * 1440 + heure * 60 + parseInt(parts.minute, 10);
    }

    function minuteSession(s) {
      return s.jour * 1440 + s.heure * 60 + (s.minute || 0);
    }

    /* ---- Présence notée par l'élève ----
       Un simple repère personnel : il clique sur un jour pour noter qu'il y
       sera. Aucun lien avec les réservations Tipo, que la page ne peut pas
       connaître. Retenu par navigateur, oublié une fois la session passée. */

    var K_PLACES = "lp_cc_places_v1";
    var K_DISCORD = "lp_discord_username_v1";
    var programmes = Object.create(null);
    var programmeCharge = false;
    var programmeMisAJour = null;
    var programmeExpirationTimer = null;
    var discordInput = document.getElementById("lpCcDiscordUsername");
    var discordStatus = document.getElementById("lpCcDiscordStatus");
    var discordTimer = null;

    function echappeProgramme(value) {
      return String(value || "").replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
    }

    function programmeFrais() {
      var instant = typeof programmeMisAJour === "string" ? Date.parse(programmeMisAJour) : NaN;
      return programmeCharge && !isNaN(instant) && instant >= Date.now() - 180000 && instant <= Date.now() + 300000;
    }

    function programmeHtml(s) {
      if (!programmeFrais()) return '<span class="lp-cc__programme">Programme en cours de mise à jour.</span>';
      var programme = programmes[cleOccurrence(s)];
      var reservations = programme && Array.isArray(programme.bookings) ? programme.bookings : [];
      if (!reservations.length) return '<span class="lp-cc__programme">Aucune réservation pour le moment.</span>';
      return '<span class="lp-cc__programme">' + reservations.map(function (r) {
        var instant = new Date(r.start);
        var heure = isNaN(instant.getTime()) ? "" : new Intl.DateTimeFormat("fr-FR", { timeZone: "Europe/Paris", hour: "2-digit", minute: "2-digit" }).format(instant);
        var sujets = [r.role, r.rank].filter(Boolean).join(" · ");
        return '<span>' + echappeProgramme(heure + (sujets ? " — " + sujets : "")) + '</span>';
      }).join("") + '</span>';
    }

    function chargeProgramme() {
      if (document.hidden) return;
      dessine();
      window.fetch("/apps/lp-dashboard/coachings", { method: "GET", credentials: "same-origin", cache: "no-store", redirect: "error", headers: { Accept: "application/json" } })
        .then(function (response) { if (!response.ok) throw new Error("planning_unavailable"); return response.json(); })
        .then(function (result) {
          if (!result || !Array.isArray(result.sessions)) throw new Error("invalid_planning");
          var next = Object.create(null);
          result.sessions.forEach(function (s) { if (s && typeof s.occurrenceKey === "string" && Array.isArray(s.bookings)) next[s.occurrenceKey] = s; });
          programmes = next;
          programmeMisAJour = result.planningStale === false ? (result.confirmedAt || null) : null;
          programmeCharge = true;
          if (programmeExpirationTimer) { clearTimeout(programmeExpirationTimer); programmeExpirationTimer = null; }
          if (programmeFrais()) programmeExpirationTimer = setTimeout(function () { programmeExpirationTimer = null; dessine(); }, Date.parse(programmeMisAJour) + 180001 - Date.now());
          dessine();
        }).catch(function () { programmeCharge = true; dessine(); });
    }

    if (discordInput) {
      discordInput.value = window.lpAccountStorage.getItem(K_DISCORD) || "";
      var enregistreDiscord = function () {
        if (discordTimer) { clearTimeout(discordTimer); discordTimer = null; }
        var value = discordInput.value.trim().replace(/^@/, "");
        if (!lpValidDiscordUsername(value)) { if (discordStatus) discordStatus.textContent = "Utilise ton nom d’utilisateur Discord exact, sans email."; return; }
        discordInput.value = value;
        if (window.lpAccountStorage.getItem(K_DISCORD) === value) return;
        lpUpdateDiscordUsername(value);
        if (discordStatus) discordStatus.textContent = "Enregistrement…";
        Promise.resolve(window.lpAccountStorage.flush()).then(function (status) {
          if (discordStatus) discordStatus.textContent = status.dirtyCount ? "Enregistrement en attente." : (value ? "Nom enregistré." : "Nom Discord effacé.");
        }).catch(function () { if (discordStatus) discordStatus.textContent = "Enregistrement en attente."; });
      };
      discordInput.addEventListener("input", function () { clearTimeout(discordTimer); discordTimer = setTimeout(enregistreDiscord, 500); });
      discordInput.addEventListener("blur", enregistreDiscord);
      window.addEventListener("lp-discord-username-change", function (event) { discordInput.value = event.detail.value; });
      discordInput.addEventListener("keydown", function (event) { if (event.key === "Enter") { event.preventDefault(); enregistreDiscord(); } });
    }

    function dateParis() {
      var p = {};
      new Intl.DateTimeFormat("en-CA", {
        timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit"
      }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { a: parseInt(p.year, 10), m: parseInt(p.month, 10), j: parseInt(p.day, 10) };
    }

    /* Date de la prochaine occurrence d'une session : "AAAA-MM-JJ-HH". */
    function cleOccurrence(s) {
      var maintenant = minuteParis();
      if (maintenant === null) return null;
      var jourActuel = Math.floor(maintenant / 1440);
      var ecart = (s.jour - jourActuel + 7) % 7;
      if (ecart === 0 && maintenant - minuteSession(s) >= DUREE) ecart = 7;
      var d = dateParis();
      var date = new Date(Date.UTC(d.a, d.m - 1, d.j + ecart)).toISOString().slice(0, 10);
      return date + "-" + ("0" + s.heure).slice(-2);
    }

    function litPlaces() {
      try {
        var brut = JSON.parse(window.lpAccountStorage.getItem(K_PLACES) || "[]");
        if (!Array.isArray(brut)) return [];
        var d = dateParis();
        var aujourdhui = new Date(Date.UTC(d.a, d.m - 1, d.j)).toISOString().slice(0, 10);
        // Les créneaux passés ne servent plus à rien.
        return brut.filter(function (c) { return typeof c === "string" && c.slice(0, 10) >= aujourdhui; });
      } catch (e) {
        return [];
      }
    }

    function ecritPlaces(places) {
      try { window.lpAccountStorage.setItem(K_PLACES, JSON.stringify(places)); } catch (e) {}
    }

    function estInscrit(s) {
      var cle = cleOccurrence(s);
      return !!cle && litPlaces().indexOf(cle) > -1;
    }

    function basculeInscription(s, valeur) {
      var cle = cleOccurrence(s);
      if (!cle) return;
      var places = litPlaces();
      var i = places.indexOf(cle);
      var veut = valeur === undefined ? i < 0 : valeur;
      if (veut && i < 0) places.push(cle);
      if (!veut && i > -1) places.splice(i, 1);
      ecritPlaces(places);
      dessine();
    }

    function heureTexte(s) {
      return s.heure + " h" + (s.minute ? " " + ("0" + s.minute).slice(-2) : "");
    }

    /* Prochaine session : la plus proche dans la semaine, ou celle en cours. */
    function prochaine() {
      var maintenant = minuteParis();
      if (maintenant === null) return { session: sessions[0], attente: null, enCours: false };

      var meilleure = null;
      sessions.forEach(function (s) {
        var depuis = (maintenant - minuteSession(s) + 10080) % 10080;
        if (depuis < DUREE) meilleure = { session: s, attente: 0, enCours: true };
      });
      if (meilleure) return meilleure;

      sessions.forEach(function (s) {
        var attente = (minuteSession(s) - maintenant + 10080) % 10080;
        if (!meilleure || attente < meilleure.attente) meilleure = { session: s, attente: attente, enCours: false };
      });
      return meilleure;
    }

    function texteQuand(p) {
      if (p.enCours) return "En ce moment";
      var jourActuel = Math.floor(minuteParis() / 1440);
      var jourSession = p.session.jour;
      var ecartJours = (jourSession - jourActuel + 7) % 7;
      var prefixe = ecartJours === 0 ? "Ce soir" : ecartJours === 1 ? "Demain" : JOURS[jourSession];
      return prefixe + " à " + heureTexte(p.session);
    }

    function texteDelai(p) {
      if (p.enCours) return "La session a commencé.";
      if (p.attente === null) return "";
      var h = Math.floor(p.attente / 60);
      var m = p.attente % 60;
      if (p.attente < 60) return "Dans " + m + " min";
      if (h < 24) return "Dans " + h + " h" + (m ? " " + ("0" + m).slice(-2) : "");
      var jours = Math.round(p.attente / 1440);
      return "Dans " + jours + (jours > 1 ? " jours" : " jour");
    }

    function dessine() {
      var p = prochaine();
      if (priseEl) priseEl.hidden = !(LP_IS_SUBSCRIBER && estInscrit(p.session));

      quandEl.textContent = texteQuand(p);
      if (avecEl) {
        avecEl.innerHTML =
          '<span class="lp-cc__initiale" style="--lp-coach:' + couleurCoach(p.session.coach) + '">' +
          String(p.session.coach || "?").slice(0, 1).toUpperCase() + "</span>" +
          "<span>avec " + (p.session.coach || "ton coach") + "</span>";
      }
      if (delaiEl) delaiEl.textContent = texteDelai(p);

      // Mardi d'abord, comme le rythme de la semaine.
      var ordonnees = sessions.slice().sort(function (a, b) {
        return ((a.jour + 5) % 7) - ((b.jour + 5) % 7);
      });

      liste.dataset.eleve = LP_IS_SUBSCRIBER ? "1" : "0";
      liste.innerHTML = ordonnees.map(function (s, i) {
        var actif = s === p.session;
        var inscrit = LP_IS_SUBSCRIBER && estInscrit(s);
        return '<li class="lp-cc__jour' + (actif ? " is-prochaine" : "") + (inscrit ? " is-inscrit" : "") + '"' +
          ' data-index="' + i + '"' +
          (LP_IS_SUBSCRIBER ? ' title="' + (inscrit ? "Retirer ta présence" : "Noter que tu y seras") + '"' : "") + ">" +
          '<span class="lp-cc__nom">' + JOURS[s.jour] + "</span>" +
          (inscrit ? '<span class="lp-cc__marque">J\'y serai</span>' : "") +
          '<span class="lp-cc__heure">' + heureTexte(s) + "</span>" +
          '<span class="lp-cc__pastille">' +
          '<span class="lp-cc__initiale" style="--lp-coach:' + couleurCoach(s.coach) + '">' +
          String(s.coach || "?").slice(0, 1).toUpperCase() + "</span>" +
          (s.coach || "") + "</span>" + programmeHtml(s) + "</li>";
      }).join("");

      // Le clic sur un jour marque ou retire la place, pour les élèves.
      liste.dataset.ordre = ordonnees.map(function (s) { return s.jour; }).join(",");
      ordre = ordonnees;
    }

    ecritPlaces(litPlaces()); // oublie les créneaux passés
    dessine();
    setInterval(dessine, 60000);
    chargeProgramme();
    setInterval(chargeProgramme, 60000);
    document.addEventListener("visibilitychange", function () { if (!document.hidden) chargeProgramme(); });

    // Marquer sa place depuis le planning (élèves).
    liste.addEventListener("click", function (e) {
      if (!LP_IS_SUBSCRIBER) return;
      var ligne = e.target && e.target.closest ? e.target.closest(".lp-cc__jour") : null;
      if (!ligne) return;
      var s = ordre[parseInt(ligne.dataset.index, 10)];
      if (s) basculeInscription(s);
    });

    /* Réservation : le widget Tipo ne s'ouvre qu'ici, et la page ne suppose
       rien de ce qui s'y passe. */
    if (bouton) {
      bouton.addEventListener("click", function () {
        if (!LP_IS_SUBSCRIBER) {
          if (window.lpOpenLockModal) window.lpOpenLockModal();
          return;
        }
        // Formule Novice : séances en observateur, pas de réservation.
        if (typeof LP_IS_NOVICE !== "undefined" && LP_IS_NOVICE) return;
        var id = typeof LP_CC_TIPO !== "undefined" ? LP_CC_TIPO : null;
        if (id && window.Tipo && window.Tipo.Booking && typeof window.Tipo.Booking.openWidget === "function") {
          window.Tipo.Booking.openWidget(id);
          if (window.lpTrack) window.lpTrack("collectif_reservation", { coach: prochaine().session.coach });
          if (noteEl) noteEl.hidden = true;
          return;
        }
        if (noteEl) {
          noteEl.textContent = "Le calendrier n'a pas pu s'ouvrir. Recharge la page et réessaie.";
          noteEl.hidden = false;
        }
      });
    }
  });

  (function () {
  const modal = document.getElementById("lpChoiceModal");
  const closeBtn = document.getElementById("lpChoiceModalClose");
  const collectifBtn = document.getElementById("lpChoiceCollectifBtn");
  const lockedButtons = modal ? modal.querySelectorAll("[data-lp-choice-lock]") : [];

  if (!modal) return;

  window.lpOpenChoiceModal = function () {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
  };

  window.lpCloseChoiceModal = function () {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
  };

  if (closeBtn) {
    closeBtn.addEventListener("click", window.lpCloseChoiceModal);
  }

  modal.addEventListener("click", function (e) {
    if (e.target === modal) window.lpCloseChoiceModal();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      window.lpCloseChoiceModal();
    }
  });

  lockedButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      window.lpCloseChoiceModal();
      if (window.lpOpenLockModal) {
        window.lpOpenLockModal();
      }
    });
  });

  if (collectifBtn) {
    collectifBtn.addEventListener("click", function () {
      window.lpCloseChoiceModal();

      /* On envoie vers l'onglet des coachings collectifs : l'élève y voit le
         coach du jour et la prochaine session avant de réserver. */
      if (typeof window.lpActivateDashboardTab === "function") {
        window.lpActivateDashboardTab("lpPanelCollectifs");
      }

      setTimeout(function () {
        const target = document.getElementById("lpPanelCollectifs");

        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 120);
    });
  }
})();

  lpWhenDomReady(function () {
    const videoContainer = document.querySelector(".video-container");
    const arrowDown = document.querySelector(".arrow-down");
    const minBtn = document.getElementById("lpPlayerMin");

    function minimizeVideo() {
      if (videoContainer) videoContainer.classList.add("is-mini");
    }

    function expandVideo() {
      if (videoContainer) videoContainer.classList.remove("is-mini");
    }

    function openVideo(clickedCard) {
      if (clickedCard.dataset.locked === "true") {
        if (clickedCard.dataset.freeMasterclass === "true" && !LP_IS_SUBSCRIBER) {
          window.lpOpenFreeUnlockModal();
        } else {
          window.lpOpenLockModal();
        }
        return;
      }

      const videoPrefix = "https://iframe.mediadelivery.net/embed/381804/";
      const videoInfoTitle = document.getElementById("videoInfoTitle");
      const videoPlayer = document.getElementById("videoPlayer");
      const videoTitle = clickedCard.dataset.title || "";
      const videoUpsell = document.getElementById("lpVideoUpsell");

      expandVideo();

      videoPlayer.src = videoPrefix.concat(clickedCard.id);
      videoInfoTitle.textContent = videoTitle;
      videoContainer.classList.add("is-open");
      videoContainer.style.transform = "translate(0, 0)";

      if (clickedCard.closest("#lpMasterclassCards") || clickedCard.closest("#lpStarterCards")) {
        lpSetMasterclassWatched(clickedCard.id);
        if (window.lpRefreshWatchedMasterclassesUI) {
          window.lpRefreshWatchedMasterclassesUI();
        }
      }

      if (videoUpsell) {
        const shouldShowUpsell =
          clickedCard.dataset.freeMasterclass === "true" && !LP_IS_SUBSCRIBER;
        videoUpsell.style.display = shouldShowUpsell ? "block" : "none";
      }
    }

    window.lpOpenVideoFromCard = openVideo;

    function closeVideo() {
      const upsell = document.getElementById("lpVideoUpsell");

      videoContainer.classList.remove("is-open");
      videoContainer.style.transform = "translate(0, 100vh)";
      if (upsell) upsell.style.display = "none";

      setTimeout(() => {
        const vp = document.getElementById("videoPlayer");
        if (vp) vp.src = "";
        expandVideo();
      }, 600);
    }

    if (arrowDown) {
      arrowDown.addEventListener("click", function (e) {
        e.stopPropagation();
        closeVideo();
      });
    }

    if (minBtn) {
      minBtn.addEventListener("click", function (e) {
        e.stopPropagation();

        if (videoContainer && videoContainer.classList.contains("is-mini")) {
          expandVideo();
        } else {
          minimizeVideo();
        }
      });
    }

    if (videoContainer) {
      videoContainer.addEventListener("click", function (e) {
        if (videoContainer.classList.contains("is-mini")) {
          if (!e.target.closest(".lp-player-bar")) expandVideo();
          return;
        }

        if (e.target === videoContainer) closeVideo();
      });
    }

    document.addEventListener("click", function (e) {
      const toggle = e.target.closest(".lp-watch-toggle");

      if (toggle) {
        e.stopPropagation();
        const card = toggle.closest(".card");

        if (card && card.dataset.locked !== "true") {
          lpToggleMasterclassWatched(card.id);
          if (window.lpRefreshWatchedMasterclassesUI) window.lpRefreshWatchedMasterclassesUI();
          if (window.lpApplyMasterclassFilters) window.lpApplyMasterclassFilters();
        }
        return;
      }

      const card = e.target.closest(".card");
      if (card) openVideo(card);
    });
  });

  (function () {
    const KEY = "lp_grid_cols_v1";
    const libraries = document.querySelectorAll(".lp-library");
    const buttons = document.querySelectorAll(".lp-density__btn");

    if (!libraries.length || !buttons.length) return;

    function apply(cols) {
      libraries.forEach((lib) => {
        if (cols) {
          lib.setAttribute("data-cols", cols);
        } else {
          lib.removeAttribute("data-cols");
        }
      });

      buttons.forEach((btn) => {
        btn.classList.toggle("selected", btn.dataset.cols === cols);
      });
    }

    let saved = null;
    try {
      saved = window.lpAccountStorage.getItem(KEY);
    } catch (e) {}

    if (saved) apply(saved);

    buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const cols = btn.dataset.cols;
        const next = btn.classList.contains("selected") ? null : cols;

        apply(next);

        try {
          if (next) {
            window.lpAccountStorage.setItem(KEY, next);
          } else {
            window.lpAccountStorage.removeItem(KEY);
          }
        } catch (e) {}
      });
    });
  })();


  /* ==========================================================================
     SYNTHÈSE, rank, moyennes et recommandations, construits game par game.

     Deux sources :
       - manuel : boutons Victoire/Défaite + formulaire "Ajouter une game" ;
       - automatique (élèves) : lecture du suivi de stats Google Sheets
         (metafield custom.stats_sheet_url, onglet "Games").

     Le rank évolue selon les LP réglés (gain/perte par game). Les moyennes
     reprennent les stats trackées dans le suivi : winrate, CS/min, KDA,
     KP (%), dégâts/min, golds/min, % de wins early game.
     ========================================================================== */
  (function () {

    var K_MODE = "lp_synth_mode_v2";        // "manual" | "auto"
    var K_BASE = "lp_synth_base_v2";        // {tier, div, lp, anchor}
    var K_MMR = "lp_synth_mmr_v2";          // {gain, loss}
    var K_ROLE = "lp_synth_role_v2";        // "top"...
    var K_GAMES = "lp_synth_games_v2";      // games saisies à la main
    var K_BASELINE = "lp_synth_baseline_v2"; // moyennes de la saison (OP.GG)
    var K_LEDGER = "lp_synth_sheet_ledger_v1"; // archive des games du suivi
    var K_HISTORY = "lp_synth_history_v1";  // courbe de progression
    var K_RIOT = "lp_synth_riot_v1";        // Riot ID + dernier relevé (bouton Mettre à jour)
    var K_SAISON = "lp_synth_saison_v1";    // moyennes de saison au dernier relevé

    /* ------------------------------------------------------------------
       RÉFÉRENTIELS DE SEUILS, VERSION TEST À AJUSTER
       Mêmes stats que le suivi Legends Path. verdict "good" si ≥ good,
       "warn" entre warn et good, "bad" en dessous de warn.
       ------------------------------------------------------------------ */
    var LP_RECO_THRESHOLDS = {
      top:     { csMin: { good: 6.5, warn: 5.5 }, kda: { good: 2.5, warn: 1.8 }, kp: { good: 45, warn: 38 }, dpm: { good: 500, warn: 380 }, gpm: { good: 390, warn: 340 }, early: { good: 52, warn: 42 } },
      jungle:  { csMin: { good: 5.0, warn: 4.2 }, kda: { good: 3.0, warn: 2.2 }, kp: { good: 60, warn: 50 }, dpm: { good: 420, warn: 320 }, gpm: { good: 370, warn: 320 }, early: { good: 52, warn: 42 } },
      mid:     { csMin: { good: 6.8, warn: 5.8 }, kda: { good: 3.0, warn: 2.2 }, kp: { good: 55, warn: 47 }, dpm: { good: 560, warn: 440 }, gpm: { good: 400, warn: 350 }, early: { good: 52, warn: 42 } },
      adc:     { csMin: { good: 7.2, warn: 6.2 }, kda: { good: 3.0, warn: 2.2 }, kp: { good: 55, warn: 47 }, dpm: { good: 620, warn: 480 }, gpm: { good: 420, warn: 370 }, early: { good: 52, warn: 42 } },
      support: { csMin: null,                      kda: { good: 3.0, warn: 2.2 }, kp: { good: 60, warn: 52 }, dpm: { good: 260, warn: 180 }, gpm: { good: 270, warn: 230 }, early: { good: 52, warn: 42 } }
    };

    /* ------------------------------------------------------------------
       RÈGLES DE RECOMMANDATION, VERSION TEST
       Métrique en zone warn/bad → masterclass à proposer. Les cartes sont
       retrouvées par id, puis par titre en secours.
       ------------------------------------------------------------------ */
    var LP_RECO_RULES = [
      {
        metric: "csMin",
        roles: ["top", "mid", "adc"],
        label: "Farm",
        why: "Ton CS/min est sous le repère de ton rôle.",
        recos: [
          { t: "Les bases du wave management", id: "987973a7-3a2f-498b-ba17-5c62820bd165" },
          { t: "FONDAMENTAUX #04 : Wave management = kill", id: "4eacbe2d-a756-43f0-9867-07178eb2d453" },
          { t: "FONDAMENTAUX #08 : Punir les last hit", id: "1de6321d-4786-4b9e-b907-c980932922ea" }
        ]
      },
      {
        metric: "csMin",
        roles: ["jungle"],
        label: "Farm jungle",
        why: "Ton farm jungle est sous le repère.",
        recos: [
          { t: "Perfectionner son premier clear", id: "88c8b7b0-5fcd-4e07-8382-70db491102b7" },
          { t: "Dominer les quatre premiers clears", id: "d96dcd08-6732-409b-9308-7d9bb1e1519b" },
          { t: "La quête jungle en S16", id: "72f36ef1-d9e5-42d7-a286-2943e01e858c" }
        ]
      },
      {
        metric: "kda",
        label: "KDA",
        why: "Ton KDA est sous le repère de ton rang.",
        recos: [
          { t: "FONDAMENTAUX #09 : Jouer de devant vs jouer de derrière", id: "33ec5b49-80c0-45b1-af6f-a03096db0e8b" },
          { t: "Reprendre sa garde : méthode contre l'autopilte", id: "f9c67b3c-86b8-40a8-9c46-73df909c960d" }
        ]
      },
      {
        metric: "kp",
        roles: ["top"],
        label: "Impact",
        why: "Ta participation aux kills est trop basse : ton lead ne se transforme pas.",
        recos: [
          { t: "Avoir de l'impact en tant que toplaner", id: "7d419bb2-fa97-4799-b003-8a431cf08901?autoplay=0" },
          { t: "J'ai gagné ma lane... et maintenant ?", id: "78e9f414-5385-42e5-87b4-f23844f54466" }
        ]
      },
      {
        metric: "kp",
        roles: ["jungle"],
        label: "Impact",
        why: "Ta participation aux kills est trop basse pour un jungler.",
        recos: [
          { t: "Les timings de gank en jungle", id: "721ab9e8-b880-41ac-8f7a-b016a71d6734" },
          { t: "Pressure la map grâce aux sidelanes en jungle", id: "9693079b-8e3b-41de-9bd7-98be3c40bc72" }
        ]
      },
      {
        metric: "kp",
        roles: ["mid"],
        label: "Impact",
        why: "Ta participation aux kills est trop basse : travaille tes roams.",
        recos: [
          { t: "Le roaming en midlane", id: "ccca7334-a8a0-4322-9cd8-112dc5ca08f8" },
          { t: "FONDAMENTAUX #06 : Les trois zones en midgame", id: "970ad2fc-ca2b-4944-81aa-e09eaa11de9d" }
        ]
      },
      {
        metric: "kp",
        roles: ["adc"],
        label: "Impact",
        why: "Ta participation aux kills est trop basse pour un ADC.",
        recos: [
          { t: "Les bases de la macro en ADC", id: "3cb7b000-2850-4f38-ae8a-2f819081686b" },
          { t: "Bien teamfight en ADC", id: "9217443c-4ade-4f0b-a926-079ccf5a938c" }
        ]
      },
      {
        metric: "kp",
        roles: ["support"],
        label: "Impact",
        why: "Ta participation aux kills est trop basse pour un support.",
        recos: [
          { t: "L'impact sur la map en support", id: "b1607833-bbf7-41f1-b601-266479948227" },
          { t: "Les cycles de jeu en support", id: "d1023e2e-320e-42a6-afe9-85d135eb71f1" }
        ]
      },
      {
        metric: "dpm",
        label: "Dégâts",
        why: "Tes dégâts par minute sont sous le repère de ton rôle.",
        recos: [
          { t: "Les 2 types de focus en teamfight", id: "c02658fb-5862-441c-9263-3d8e906fac06" },
          { t: "Comment bien itemiser ?", id: "441a04dd-edb0-44df-9f62-5c0ccd0e2948" }
        ]
      },
      {
        metric: "gpm",
        label: "Golds",
        why: "Tes golds par minute sont sous le repère : trop de temps mort.",
        recos: [
          { t: "Tout savoir sur les timings de back", id: "23245488-22b7-4990-aa49-228e65262014" },
          { t: "FONDAMENTAUX 10 : Jouer VITE", id: "41f9760d-a179-4d5f-9347-2e90de6a4df9" }
        ]
      },
      {
        metric: "early",
        label: "Early game",
        why: "Tu perds trop souvent ton early game.",
        recos: [
          { t: "FONDAMENTAUX #02 : Trade selon les runes", id: "490026a8-a9bd-46d6-85dc-31e0e14a5e62" },
          { t: "FONDAMENTAUX #03 : Ne plus subir le passage lvl 2", id: "2f80b67c-9cc1-4efa-9347-ed9b5eb79d1d" },
          { t: "Trading 101 (les bases du trading)", id: "8f18bfcb-afba-4047-9d01-55a18c82c9cd" }
        ]
      },
      {
        metric: "winrate",
        label: "Winrate",
        why: "Ton winrate est sous 48 % : prends du recul sur tes parties.",
        recos: [
          { t: "Analyser ses replays", id: "5600b02f-3b96-48f7-89b2-ef0274071e43" },
          { t: "La psychologie dans l'e-sport", id: "350be0ef-24fa-439e-8e5b-322fabca15f9" }
        ]
      },
      /* Jungle : uniquement du contenu taggé jungle (voir LP_RECO_ROLE_STRICT). */
      {
        metric: "kda",
        roles: ["jungle"],
        label: "KDA",
        why: "Ton KDA est sous le repère : sache où est le jungler adverse avant d'engager.",
        recos: [
          { t: "Le jungle tracking en early game", id: "150ebb0f-bddc-4691-bd46-589736820dfe" },
          { t: "Les timings d'invade", id: "f9499cd4-5882-4f75-bd3b-59c8f82c3166" }
        ]
      },
      {
        metric: "dpm",
        roles: ["jungle"],
        label: "Dégâts",
        why: "Tes dégâts par minute sont sous le repère : tes ganks et tes skirmishes doivent peser plus.",
        recos: [
          { t: "Les timings de gank en jungle", id: "721ab9e8-b880-41ac-8f7a-b016a71d6734" },
          { t: "Les timings d'invade", id: "f9499cd4-5882-4f75-bd3b-59c8f82c3166" }
        ]
      },
      {
        metric: "gpm",
        roles: ["jungle"],
        label: "Golds",
        why: "Tes golds par minute sont sous le repère : optimise tes clears et ta pression sur la map.",
        recos: [
          { t: "Perfectionner son premier clear", id: "88c8b7b0-5fcd-4e07-8382-70db491102b7" },
          { t: "Dominer les quatre premiers clears", id: "d96dcd08-6732-409b-9308-7d9bb1e1519b" },
          { t: "Pressure la map grâce aux sidelanes en jungle", id: "9693079b-8e3b-41de-9bd7-98be3c40bc72" }
        ]
      },
      {
        metric: "early",
        roles: ["jungle"],
        label: "Early game",
        why: "Tu perds trop souvent ton early game en jungle.",
        recos: [
          { t: "Le jungle tracking en early game", id: "150ebb0f-bddc-4691-bd46-589736820dfe" },
          { t: "Perfectionner son premier clear", id: "88c8b7b0-5fcd-4e07-8382-70db491102b7" },
          { t: "Les timings d'invade", id: "f9499cd4-5882-4f75-bd3b-59c8f82c3166" }
        ]
      },
      {
        metric: "winrate",
        roles: ["jungle"],
        label: "Winrate",
        why: "Ton winrate est sous 48 % : reprends le contrôle de la map.",
        recos: [
          { t: "Le jungle tracking en early game", id: "150ebb0f-bddc-4691-bd46-589736820dfe" },
          { t: "Pressure la map grâce aux sidelanes en jungle", id: "9693079b-8e3b-41de-9bd7-98be3c40bc72" }
        ]
      }
    ];

    /* ------------------------------------------------------------------
       COHÉRENCE DU POOL, champion → [lane, style]. Pool parfait :
       2 champions, même style, même lane. Champions absents = neutres.
       ------------------------------------------------------------------ */
    var LP_CHAMPION_STYLES = {
      Aatrox: ["top", "juggernaut"], Ambessa: ["top", "skirmisher"], Camille: ["top", "splitpusher"],
      Darius: ["top", "juggernaut"], Fiora: ["top", "splitpusher"], Gangplank: ["top", "splitpusher"],
      Garen: ["top", "juggernaut"], Gnar: ["top", "tank"], Gwen: ["top", "skirmisher"],
      Illaoi: ["top", "juggernaut"], Irelia: ["top", "skirmisher"], Jax: ["top", "splitpusher"],
      Jayce: ["top", "poke"], KSante: ["top", "tank"], Kled: ["top", "juggernaut"],
      Malphite: ["top", "tank"], Mordekaiser: ["top", "juggernaut"], Olaf: ["top", "juggernaut"],
      Ornn: ["top", "tank"], Poppy: ["top", "tank"], Renekton: ["top", "juggernaut"],
      Riven: ["top", "skirmisher"], Rumble: ["top", "poke"], Sett: ["top", "juggernaut"],
      Shen: ["top", "tank"], Sion: ["top", "tank"], TahmKench: ["top", "tank"],
      Tryndamere: ["top", "splitpusher"], Urgot: ["top", "juggernaut"], Volibear: ["top", "juggernaut"],
      Yorick: ["top", "splitpusher"],

      Amumu: ["jungle", "jungle-gank"], Belveth: ["jungle", "skirmisher"], Diana: ["jungle", "assassin"],
      Ekko: ["jungle", "assassin"], Elise: ["jungle", "jungle-gank"], Evelynn: ["jungle", "assassin"],
      Graves: ["jungle", "jungle-carry"], Hecarim: ["jungle", "jungle-gank"], JarvanIV: ["jungle", "jungle-gank"],
      Karthus: ["jungle", "jungle-carry"], Kayn: ["jungle", "assassin"], Khazix: ["jungle", "assassin"],
      Kindred: ["jungle", "jungle-carry"], LeeSin: ["jungle", "skirmisher"], Lillia: ["jungle", "jungle-carry"],
      Maokai: ["jungle", "tank"], MasterYi: ["jungle", "jungle-carry"], Nidalee: ["jungle", "jungle-carry"],
      Nocturne: ["jungle", "jungle-gank"], Nunu: ["jungle", "jungle-gank"], Rammus: ["jungle", "tank"],
      RekSai: ["jungle", "jungle-gank"], Sejuani: ["jungle", "tank"], Shaco: ["jungle", "assassin"],
      Shyvana: ["jungle", "jungle-carry"], Skarner: ["jungle", "tank"], Udyr: ["jungle", "jungle-gank"],
      Vi: ["jungle", "jungle-gank"], Viego: ["jungle", "skirmisher"], Warwick: ["jungle", "jungle-gank"],
      XinZhao: ["jungle", "jungle-gank"], Zac: ["jungle", "tank"],

      Ahri: ["mid", "mage-burst"], Akali: ["mid", "assassin"], Anivia: ["mid", "mage-controle"],
      Annie: ["mid", "mage-burst"], Aurora: ["mid", "mage-burst"], Azir: ["mid", "mage-controle"],
      Cassiopeia: ["mid", "mage-controle"], Corki: ["mid", "poke"], Fizz: ["mid", "assassin"],
      Galio: ["mid", "tank"], Hwei: ["mid", "mage-controle"], Kassadin: ["mid", "assassin"],
      Katarina: ["mid", "assassin"], Leblanc: ["mid", "assassin"], Lissandra: ["mid", "mage-controle"],
      Malzahar: ["mid", "mage-controle"], Naafiri: ["mid", "assassin"], Orianna: ["mid", "mage-controle"],
      Qiyana: ["mid", "assassin"], Ryze: ["mid", "mage-controle"], Sylas: ["mid", "skirmisher"],
      Syndra: ["mid", "mage-burst"], Taliyah: ["mid", "mage-controle"], Talon: ["mid", "assassin"],
      Veigar: ["mid", "mage-burst"], Vex: ["mid", "mage-burst"], Viktor: ["mid", "mage-controle"],
      Vladimir: ["mid", "mage-controle"], Yasuo: ["mid", "skirmisher"], Yone: ["mid", "skirmisher"],
      Zed: ["mid", "assassin"], Zoe: ["mid", "poke"],

      Aphelios: ["adc", "adc-scaling"], Ashe: ["adc", "adc-agressif"], Caitlyn: ["adc", "adc-agressif"],
      Draven: ["adc", "adc-agressif"], Ezreal: ["adc", "adc-scaling"], Jhin: ["adc", "adc-agressif"],
      Jinx: ["adc", "adc-scaling"], Kaisa: ["adc", "adc-scaling"], Kalista: ["adc", "adc-agressif"],
      KogMaw: ["adc", "adc-scaling"], Lucian: ["adc", "adc-agressif"], MissFortune: ["adc", "adc-agressif"],
      Nilah: ["adc", "adc-agressif"], Samira: ["adc", "adc-agressif"], Sivir: ["adc", "adc-scaling"],
      Smolder: ["adc", "adc-scaling"], Tristana: ["adc", "adc-agressif"], Twitch: ["adc", "adc-scaling"],
      Varus: ["adc", "adc-agressif"], Vayne: ["adc", "adc-scaling"], Xayah: ["adc", "adc-scaling"],
      Zeri: ["adc", "adc-scaling"],

      Alistar: ["support", "support-engage"], Bard: ["support", "support-engage"], Blitzcrank: ["support", "support-engage"],
      Braum: ["support", "support-engage"], Janna: ["support", "enchanteur"], Karma: ["support", "enchanteur"],
      Leona: ["support", "support-engage"], Lulu: ["support", "enchanteur"], Milio: ["support", "enchanteur"],
      Morgana: ["support", "enchanteur"], Nami: ["support", "enchanteur"], Nautilus: ["support", "support-engage"],
      Pyke: ["support", "support-engage"], Rakan: ["support", "support-engage"], Rell: ["support", "support-engage"],
      Renata: ["support", "enchanteur"], Senna: ["support", "enchanteur"], Seraphine: ["support", "enchanteur"],
      Sona: ["support", "enchanteur"], Soraka: ["support", "enchanteur"], Thresh: ["support", "support-engage"],
      Yuumi: ["support", "enchanteur"], Zyra: ["support", "poke"]
    };

    // Index normalisé (sans espaces / apostrophes) pour retrouver un champion saisi
    var CHAMP_INDEX = {};
    Object.keys(LP_CHAMPION_STYLES).forEach(function (k) {
      CHAMP_INDEX[k.toLowerCase()] = k;
    });

    function normChampName(input) {
      var key = String(input || "").toLowerCase().replace(/[\s'.]/g, "");
      return CHAMP_INDEX[key] || (input ? String(input).trim() : null);
    }

    /* ------------------------------------------------------------------ */

    function readJson(key, fallback) {
      try {
        var raw = window.lpAccountStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (e) {
        return fallback;
      }
    }

    function writeJson(key, value) {
      try {
        window.lpAccountStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    }

    var TIERS = ["IRON", "BRONZE", "SILVER", "GOLD", "PLATINUM", "EMERALD", "DIAMOND", "MASTER", "GRANDMASTER", "CHALLENGER"];
    var TIER_FR = { IRON: "FER", BRONZE: "BRONZE", SILVER: "ARGENT", GOLD: "OR", PLATINUM: "PLATINE", EMERALD: "ÉMERAUDE", DIAMOND: "DIAMANT", MASTER: "MAÎTRE", GRANDMASTER: "GRAND MAÎTRE", CHALLENGER: "CHALLENGER" };
    var DIVS = { IV: 0, III: 1, II: 2, I: 3 };
    var DIV_NAMES = ["IV", "III", "II", "I"];

    // Seuils LP des paliers Maître+ (LP au-dessus de Maître 0, éditables)
    var LP_GM_OFFSET = 1750;
    var LP_CHALL_OFFSET = 2400;

    function lpScore(tier, division, lp) {
      var t = String(tier || "").toUpperCase();
      var ti = TIERS.indexOf(t);
      if (ti < 0) return null;
      var points = parseInt(lp, 10) || 0;
      if (t === "MASTER") return 7 * 400 + points;
      if (t === "GRANDMASTER") return 7 * 400 + LP_GM_OFFSET + points;
      if (t === "CHALLENGER") return 7 * 400 + LP_CHALL_OFFSET + points;
      var di = DIVS[String(division || "IV").toUpperCase()] || 0;
      return ti * 400 + di * 100 + points;
    }

    function scoreToRank(score) {
      score = Math.max(0, Math.round(score));
      if (score >= 2800 + LP_CHALL_OFFSET) return { tier: "CHALLENGER", div: "", lp: score - 2800 - LP_CHALL_OFFSET };
      if (score >= 2800 + LP_GM_OFFSET) return { tier: "GRANDMASTER", div: "", lp: score - 2800 - LP_GM_OFFSET };
      if (score >= 2800) return { tier: "MASTER", div: "", lp: score - 2800 };
      var ti = Math.min(6, Math.floor(score / 400));
      var rest = score - ti * 400;
      var di = Math.min(3, Math.floor(rest / 100));
      return { tier: TIERS[ti], div: DIV_NAMES[di], lp: rest - di * 100 };
    }

    function formatRank(tier, division, lp) {
      var t = String(tier || "").toUpperCase();
      if (!t || TIERS.indexOf(t) < 0) return "Non classé";
      var label = TIER_FR[t] || t;
      if (TIERS.indexOf(t) >= 7) return label;
      return label + " " + (division || "");
    }

    var ROLE_LABELS = { top: "Top", jungle: "Jungle", mid: "Mid", adc: "ADC", support: "Support" };
    var CHAMP_COLORS = ["#4cc2ff", "#b78bfa", "#f5a524", "#34d399", "#ff5d5d", "#9aa3ae"];

    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    /* ---------------- État ---------------- */

    var state = {
      mode: readJson(K_MODE, null),           // "manual" | "auto"
      base: readJson(K_BASE, null),           // {tier, div, lp, anchor}
      mmr: readJson(K_MMR, { gain: 25, loss: 20 }),
      role: readJson(K_ROLE, "mid"),
      manualGames: readJson(K_GAMES, []),
      baseline: readJson(K_BASELINE, null),   // {games, wr, cs, kda, kp, dpm, gpm, early}
      ledger: readJson(K_LEDGER, { frozen: [], live: [] }), // games du suivi (archivées + cycle courant)
      synced: false
    };

    /* Au-delà de 5000, ce ne sont pas des dégâts par minute mais des dégâts
       totaux : games archivées avant la correction de la colonne Y. */
    function dpmPlausible(v) {
      return typeof v === "number" && v > 5000 ? null : v;
    }
    [state.ledger && state.ledger.frozen, state.ledger && state.ledger.live, state.manualGames].forEach(function (liste) {
      if (!Array.isArray(liste)) return;
      liste.forEach(function (g) {
        if (g && typeof g.dpm === "number" && g.dpm > 5000) g.dpm = null;
      });
    });

    function currentGames() {
      if (state.mode === "auto") {
        return state.ledger.frozen.concat(state.ledger.live);
      }
      /* Relais branché : hors suivi de stats, tout vient de l'API, il n'y a
         plus de saisie à la main. Les games saisies avant restent stockées
         mais ne sont plus lues. */
      if (MAJ_ENDPOINT) return [];
      return state.manualGames;
    }

    // Les games déjà comptées ne disparaissent jamais : si le tableau du suivi
    // est vidé ou raccourci (reset hebdomadaire), le cycle courant est archivé
    // dans `frozen` avant d'être remplacé.
    function signatureGame(g) {
      return [g.w, g.champ, g.cs, g.k, g.d, g.a, g.kp, g.dpm, g.gpm, g.early].join("|");
    }

    /* Même période du suivi tant qu'au moins une des premières games est
       identique : corriger ou supprimer quelques lignes ne change rien.
       Toutes différentes, ou tableau vidé : nouvelle période. */
    function memePeriode(ancien, nouveau) {
      var n = Math.min(ancien.length, nouveau.length, 5);
      if (!n) return false;
      for (var i = 0; i < n; i++) {
        if (signatureGame(ancien[i]) === signatureGame(nouveau[i])) return true;
      }
      return false;
    }

    function updateLedger(newGames) {
      var led = state.ledger;
      var id = sheetId();

      /* Un autre suivi que celui archivé (autre élève sur ce navigateur, lien
         changé) : on repart de zéro plutôt que de mélanger deux joueurs. */
      if (led.sheet && id && led.sheet !== id) {
        led = state.ledger = { frozen: [], live: [] };
      }
      if (id) led.sheet = id;
      var premierPassage = !led.frozen.length && !led.live.length;

      /* Nouvelle période : l'ancien tableau est archivé. Une game supprimée
         ou corrigée ne change pas de période, donc rien n'est archivé en
         double ; une nouvelle période plus longue que l'ancienne est bien
         détectée, donc rien n'est perdu. */
      var nouvellePeriode = led.live.length > 0 && !memePeriode(led.live, newGames);
      if (nouvellePeriode) led.frozen = led.frozen.concat(led.live);

      /* Date d'arrivée de chaque game dans le suivi, pour les stats des 30
         derniers jours. 0 = inconnue : tout ce qui était déjà là au premier
         passage n'est pas daté. */
      var maintenant = Date.now();
      newGames.forEach(function (g, i) {
        var ancienne = nouvellePeriode ? null : led.live[i];
        if (ancienne && signatureGame(ancienne) === signatureGame(g)) g.vu = ancienne.vu || 0;
        else g.vu = premierPassage ? 0 : maintenant;
      });

      led.live = newGames;
      writeJson(K_LEDGER, led);
    }

    function currentScore() {
      if (!state.base) return null;
      var score = lpScore(state.base.tier, state.base.div, state.base.lp);
      if (score === null) return null;
      /* Suivi de stats avec rank lu par l'API : on affiche le rank réel du
         dernier relevé, sans y ajouter les games du suivi. Une game jouée
         avant le relevé mais importée après serait sinon comptée deux fois. */
      if (state.mode === "auto" && MAJ_ENDPOINT && (readJson(K_RIOT, null) || {}).rangLu) {
        return Math.max(0, score);
      }
      var games = currentGames();
      for (var i = state.base.anchor || 0; i < games.length; i++) {
        score += games[i].w ? state.mmr.gain : -state.mmr.loss;
      }
      return Math.max(0, score);
    }

    /* ---------------- Moyennes depuis les games ---------------- */

    function computeMetrics(games) {
      var m = { games: games.length, wins: 0, csMin: null, kda: null, kp: null, dpm: null, gpm: null, early: null, byChampion: {}, results: [] };
      var s = { cs: [], kp: [], dpm: [], gpm: [], k: 0, d: 0, a: 0, kdaGames: 0, earlyWin: 0, earlyTotal: 0 };

      games.forEach(function (g) {
        if (g.w) m.wins++;
        m.results.push(g.w ? 1 : 0);
        if (g.cs !== null && g.cs !== undefined) s.cs.push(g.cs);
        if (g.kp !== null && g.kp !== undefined) s.kp.push(g.kp);
        if (g.dpm !== null && g.dpm !== undefined) s.dpm.push(g.dpm);
        if (g.gpm !== null && g.gpm !== undefined) s.gpm.push(g.gpm);
        if (g.k !== null && g.k !== undefined && g.d !== null && g.a !== null && g.a !== undefined) {
          s.k += g.k; s.d += g.d; s.a += g.a; s.kdaGames++;
        }
        if (g.early === 1 || g.early === 0) {
          s.earlyTotal++;
          if (g.early === 1) s.earlyWin++;
        }
        if (g.champ) {
          var name = normChampName(g.champ);
          if (!m.byChampion[name]) m.byChampion[name] = { games: 0, wins: 0, k: 0, d: 0, a: 0, results: [] };
          var c = m.byChampion[name];
          c.games++;
          if (g.w) c.wins++;
          c.k += g.k || 0; c.d += g.d || 0; c.a += g.a || 0;
          c.results.push(g.w ? 1 : 0);
        }
      });

      function avg(arr) {
        if (!arr.length) return null;
        return arr.reduce(function (a, b) { return a + b; }, 0) / arr.length;
      }

      m.csMin = avg(s.cs);
      m.kp = avg(s.kp);
      m.dpm = avg(s.dpm);
      m.gpm = avg(s.gpm);
      if (s.kdaGames > 0) m.kda = s.d > 0 ? (s.k + s.a) / s.d : s.k + s.a;
      if (s.earlyTotal > 0) m.early = (s.earlyWin / s.earlyTotal) * 100;

      return m;
    }

    // Le point de départ (moyennes de la saison, OP.GG onglet « Champions »)
    // compte comme un paquet de N games dans les moyennes affichées.
    function combineWithBaseline(m, source) {
      var b = source || state.baseline;
      if (!b || !b.games) return m;

      var out = {};
      Object.keys(m).forEach(function (k) { out[k] = m[k]; });

      var n0 = b.games, n1 = m.games;
      out.games = n0 + n1;
      out.wins = Math.round(n0 * (b.wr || 0) / 100) + m.wins;

      function mix(field, bVal) {
        if (bVal === null || bVal === undefined) return;
        if (m[field] === null || m[field] === undefined) { out[field] = bVal; return; }
        out[field] = (bVal * n0 + m[field] * n1) / (n0 + n1);
      }
      mix("csMin", b.cs);
      mix("kda", b.kda);
      mix("kp", b.kp);
      mix("dpm", b.dpm);
      mix("gpm", b.gpm);
      mix("early", b.early);

      return out;
    }

    // Tendance par stat : games récentes vs point de départ (ou, sans point
    // de départ, seconde moitié des games vs première moitié).
    function trendFor(ref, cur) {
      if (ref === null || ref === undefined || cur === null || cur === undefined) return null;
      if (ref === 0) return cur > 0 ? "up" : "flat";
      var r = cur / ref;
      if (r >= 1.02) return "up";
      if (r <= 0.98) return "down";
      return "flat";
    }

    function computeTrends(recent) {
      var t = {};
      var b = state.baseline;

      if (b && b.games) {
        t.winrate = trendFor(b.wr, recent.games ? (recent.wins / recent.games) * 100 : null);
        t.csMin = trendFor(b.cs, recent.csMin);
        t.kda = trendFor(b.kda, recent.kda);
        t.kp = trendFor(b.kp, recent.kp);
        t.dpm = trendFor(b.dpm, recent.dpm);
        t.gpm = trendFor(b.gpm, recent.gpm);
        t.early = trendFor(b.early, recent.early);
        return t;
      }

      var games = currentGames();
      if (games.length >= 6) {
        var half = Math.floor(games.length / 2);
        var m1 = computeMetrics(games.slice(0, half));
        var m2 = computeMetrics(games.slice(half));
        t.winrate = trendFor(m1.games ? (m1.wins / m1.games) * 100 : null, m2.games ? (m2.wins / m2.games) * 100 : null);
        t.csMin = trendFor(m1.csMin, m2.csMin);
        t.kda = trendFor(m1.kda, m2.kda);
        t.kp = trendFor(m1.kp, m2.kp);
        t.dpm = trendFor(m1.dpm, m2.dpm);
        t.gpm = trendFor(m1.gpm, m2.gpm);
        t.early = trendFor(m1.early, m2.early);
      }
      return t;
    }

    /* ---------------- Verdicts + scores ---------------- */

    function verdictFor(metric, value, role) {
      if (value === null || value === undefined || isNaN(value)) return "na";
      var t = (LP_RECO_THRESHOLDS[role] || LP_RECO_THRESHOLDS.mid)[metric];
      if (!t) return "na";
      if (value >= t.good) return "good";
      if (value >= t.warn) return "warn";
      return "bad";
    }

    function computePoolScore(byChampion) {
      var pool = Object.keys(byChampion || {}).map(function (name) {
        var c = byChampion[name];
        return { name: name, games: c.games, wr: c.games ? c.wins / c.games : 0 };
      }).filter(function (c) { return c.games >= 2; })
        .sort(function (a, b) { return b.games - a.games; })
        .slice(0, 6);

      if (pool.length < 2) return null;

      var deductions = [];

      var extra = Math.min(32, Math.max(0, pool.length - 2) * 8);
      if (extra) deductions.push({ pts: extra, label: "trop de champions joués (" + pool.length + " au lieu de 2)" });

      var styles = {}, lanes = {};
      pool.forEach(function (c) {
        var meta = LP_CHAMPION_STYLES[c.name];
        if (meta) { lanes[meta[0]] = 1; styles[meta[1]] = 1; }
      });
      var nStyles = Object.keys(styles).length;
      var nLanes = Object.keys(lanes).length;
      if (nStyles > 1) deductions.push({ pts: Math.min(30, (nStyles - 1) * 10), label: "styles de jeu trop éloignés (" + nStyles + " styles différents)" });
      if (nLanes > 1) deductions.push({ pts: Math.min(24, (nLanes - 1) * 12), label: nLanes + " lanes différentes dans ton pool" });

      var solid = pool.filter(function (c) { return c.games >= 3; });
      if (solid.length >= 2) {
        var wrs = solid.map(function (c) { return c.wr * 100; });
        var gap = Math.max.apply(null, wrs) - Math.min.apply(null, wrs);
        if (gap > 25) deductions.push({ pts: 15, label: "performances trop inégales (" + Math.round(gap) + " pts de winrate d'écart)" });
        else if (gap > 15) deductions.push({ pts: 8, label: "performances inégales (" + Math.round(gap) + " pts de winrate d'écart)" });
      }

      var total = deductions.reduce(function (a, d) { return a + d.pts; }, 0);
      deductions.sort(function (a, b) { return b.pts - a.pts; });

      return {
        score: Math.max(5, 100 - total),
        mainReason: deductions.length ? deductions[0].label : null
      };
    }

    function computePerfScore(metrics, role, winrate) {
      var map = { good: 100, warn: 55, bad: 15 };
      var pts = [];

      ["csMin", "kda", "kp", "dpm", "gpm", "early"].forEach(function (m) {
        var v = verdictFor(m, metrics ? metrics[m] : null, role);
        if (map[v] !== undefined) pts.push(map[v]);
      });

      if (winrate !== null && winrate !== undefined) {
        pts.push(map[winrate >= 52 ? "good" : winrate >= 48 ? "warn" : "bad"]);
      }

      if (!pts.length) return null;
      var base = pts.reduce(function (a, b) { return a + b; }, 0) / pts.length;

      var results = (metrics && metrics.results) || [];
      if (results.length >= 8) {
        var maxLossStreak = 0, cur = 0;
        results.forEach(function (r) {
          if (!r) { cur++; if (cur > maxLossStreak) maxLossStreak = cur; } else { cur = 0; }
        });
        var reg = maxLossStreak >= 3 ? Math.max(20, 100 - (maxLossStreak - 2) * 20) : 100;
        base = base * 0.8 + reg * 0.2;
      }

      return Math.round(Math.max(0, Math.min(100, base)));
    }

    /* Passe ouvert=true. Existe pour que les autres appels restent
       inchangés et continuent de tout flouter. */
    function renderScoreCardOuverte(cardEl, name, score, verdictText, whyHtml) {
      return renderScoreCard(cardEl, name, score, verdictText, whyHtml, true);
    }

    function renderScoreCard(cardEl, name, score, verdictText, whyHtml, ouvert) {
      if (!cardEl) return;

      if (score === null || score === undefined) {
        cardEl.style.display = "none";
        return;
      }
      cardEl.style.display = "";

      var C = 2 * Math.PI * 15.9;
      var dash = (score / 100) * C;
      var color = score >= 70 ? "#2ecc80" : score >= 45 ? "#f0a32e" : "#f26d6d";
      // Non-élève : la raison reste brouillée, toujours. C'est elle qui dit
      // quoi corriger, donc c'est elle qui a de la valeur.
      // Les cartes marquées « ouvert » montrent en revanche le verdict, la
      // note et la jauge : le visiteur repart en sachant où il en est, ce
      // qui est précisément ce qui donne envie de savoir pourquoi.
      var libre = LP_IS_SUBSCRIBER || ouvert === true;
      var blurCls = libre ? "" : " lp-blur-val";
      var blurWhy = LP_IS_SUBSCRIBER ? "" : " lp-blur-val";
      var pill = LP_IS_SUBSCRIBER ? "" : '<span class="lp-members-pill">LP</span>';

      cardEl.innerHTML =
        '<div style="min-width:0;">' +
        '<div class="lp-score-card__head"><span class="lp-score-card__name">' + esc(name) + "</span>" + pill + "</div>" +
        '<div class="lp-score-card__verdict' + blurCls + '">' + esc(verdictText) +
        '<span class="lp-score-card__note">' + score + "/100</span></div>" +
        (whyHtml ? '<div class="lp-score-card__why' + blurWhy + '">' + whyHtml + "</div>" : "") +
        "</div>" +
        '<div class="lp-score-gauge' + blurCls + '"><svg viewBox="0 0 42 42">' +
        '<circle cx="21" cy="21" r="15.9" fill="none" stroke="var(--lp-surface-3)" stroke-width="5"></circle>' +
        '<circle cx="21" cy="21" r="15.9" fill="none" stroke="' + color + '" stroke-width="5" stroke-linecap="round" stroke-dasharray="' + dash.toFixed(1) + " " + (C - dash).toFixed(1) + '"></circle>' +
        '</svg><span class="lp-score-gauge__val">' + score + "</span></div>";
    }

    /* ---------------- Recommandations ---------------- */

    function findCardFor(reco) {
      var card = document.getElementById(reco.id);
      if (card && card.classList.contains("card")) return card;
      var all = document.querySelectorAll("#lpMasterclassCards .card, #lpStarterCards .card");
      for (var i = 0; i < all.length; i++) {
        if ((all[i].dataset.title || "") === reco.t) return all[i];
      }
      return null;
    }

    function buildRecos(metrics, role, winrate) {
      var found = [];
      var sevRank = { bad: 0, warn: 1 };

      LP_RECO_RULES.forEach(function (rule) {
        if (rule.roles && rule.roles.indexOf(role) < 0) return;

        var verdict;
        if (rule.metric === "winrate") {
          verdict = winrate === null || winrate === undefined ? "na" : winrate < 44 ? "bad" : winrate < 48 ? "warn" : "good";
        } else {
          verdict = verdictFor(rule.metric, metrics ? metrics[rule.metric] : null, role);
        }

        if (verdict !== "bad" && verdict !== "warn") return;

        rule.recos.forEach(function (r) {
          var card = findCardFor(r);
          if (!card || !lpRecoCardPourRole(card, role)) return;
          if (found.some(function (f) { return f.card === card; })) return;
          found.push({ card: card, title: r.t, label: rule.label, why: rule.why, sev: sevRank[verdict] });
        });
      });

      found.sort(function (a, b) { return a.sev - b.sev; });
      return found.slice(0, 5);
    }

    function goToCard(card) {
      if (typeof window.lpActivateDashboardTab === "function") {
        window.lpActivateDashboardTab("lpPanelMasterclass");
      }
      setTimeout(function () {
        card.scrollIntoView({ behavior: "smooth", block: "center" });
        card.classList.remove("is-highlighted");
        void card.offsetWidth;
        card.classList.add("is-highlighted");
        setTimeout(function () { card.classList.remove("is-highlighted"); }, 2600);
      }, 200);
    }

    /* ------------------------------------------------------------------
       MES OBJECTIFS

       Une seule idée : transformer le diagnostic en une chose à faire.
       L'analyse dit ce qui ne va pas ; les objectifs disent quoi viser,
       combien ça rapporte et combien de temps ça prend.

       L'ordre est celui de l'écart au repère du rôle : la métrique la plus
       en retard passe en premier. Les suivantes restent visibles dans le
       carrousel, c'est ce qui donne la suite du chemin sans avoir à
       l'écrire.

       Les durées sont volontairement larges. Annoncer trois semaines et en
       prendre huit, c'est fabriquer de la déception ; annoncer deux mois et
       y arriver en six semaines, c'est l'inverse.
       ------------------------------------------------------------------ */

    var OBJ_METRIQUES = [
      { cle: "csMin", nom: "CS par minute",          unite: "",   dec: 1, lp: 380 },
      { cle: "gpm",   nom: "Golds par minute",       unite: "",   dec: 0, lp: 340 },
      { cle: "kda",   nom: "KDA",                    unite: "",   dec: 1, lp: 300 },
      { cle: "early", nom: "Early game gagné",       unite: " %", dec: 0, lp: 280 },
      { cle: "kp",    nom: "Participation aux kills", unite: " %", dec: 0, lp: 260 },
      { cle: "dpm",   nom: "Dégâts par minute",      unite: "",   dec: 0, lp: 240 }
    ];

    var OBJ_MIN_GAMES = 5;

    function objArrondi(v, dec) {
      var f = Math.pow(10, dec);
      return (Math.round(v * f) / f).toLocaleString("fr-FR");
    }

    /* Les masterclass déjà associées à cette métrique dans les règles de
       recommandation : rien à redéfinir, on réutilise la même table. */
    function objMasterclass(cle, role) {
      var out = [];
      LP_RECO_RULES.forEach(function (regle) {
        if (regle.metric !== cle) return;
        if (regle.roles && regle.roles.indexOf(role) < 0) return;
        regle.recos.forEach(function (r) {
          if (out.length >= 2) return;
          var card = findCardFor(r);
          if (card && lpRecoCardPourRole(card, role) && !out.some(function (o) { return o.card === card; })) {
            out.push({ card: card, titre: r.t });
          }
        });
      });
      return out;
    }

    function objDepuis(m, v, t, cible, role, etire) {
      var palier = t.good - t.warn;
      var plancher = Math.max(0, Math.min(v, t.warn - palier));
      var avance = (v - plancher) / Math.max(0.0001, cible - plancher);
      var reste = Math.max(0, Math.min(1, 1 - avance));

      return {
        cle: m.cle,
        nom: m.nom,
        unite: m.unite,
        dec: m.dec,
        actuel: v,
        cible: cible,
        ratio: v / cible,
        progression: Math.max(0, Math.min(100, avance * 100)),
        /* Le gain dépend du poids de la métrique et de l'écart restant. */
        lp: Math.round((m.lp * (etire ? 0.35 : 0.45 + 0.55 * reste)) / 10) * 10,
        /* Large à dessein : annoncer court et tenir long fabrique de la
           déception, l'inverse fabrique de la satisfaction. */
        duree: etire || v < t.warn ? "3 à 4 mois" : v < (t.warn + t.good) / 2 ? "2 à 3 mois" : "6 à 8 semaines",
        masterclass: objMasterclass(m.cle, role)
      };
    }

    function construitObjectifs(metrics, role) {
      if (!metrics || metrics.games < OBJ_MIN_GAMES) return [];
      var seuils = LP_RECO_THRESHOLDS[role] || LP_RECO_THRESHOLDS.mid;
      var out = [];

      /* Les paliers d'une métrique, du bas vers le haut :

           warn     le minimum acceptable pour le rôle
           milieu   (warn + good) / 2, LA cible de référence
           good     le repère haut du rôle

         Maître s'atteint quand toutes les métriques sont AU MILIEU de leur
         plage, pas à leur minimum : promettre Maître à quelqu'un qui joue
         tout juste correctement n'aurait pas tenu. Celui qui dépasse déjà
         le milieu vise le repère haut, et arrive donc au-dessus de Maître. */
      OBJ_METRIQUES.forEach(function (m) {
        var t = seuils[m.cle];
        if (!t) return;
        var v = metrics[m.cle];
        if (v === null || v === undefined || isNaN(v)) return;
        if (v >= t.good) return;               // au repère haut : traité en étirement
        var milieu = (t.warn + t.good) / 2;
        out.push(objDepuis(m, v, t, v < milieu ? milieu : t.good, role, false));
      });

      /* Personne ne doit se retrouver sans objectif. Quelqu'un dont tout est
         déjà au niveau reçoit des cibles au-dessus du repère : sans rien à
         viser, il n'a plus de raison de revenir. */
      if (!out.length) {
        OBJ_METRIQUES.forEach(function (m) {
          var t = seuils[m.cle];
          if (!t) return;
          var v = metrics[m.cle];
          if (v === null || v === undefined || isNaN(v)) return;
          out.push(objDepuis(m, v, t, v + (t.good - t.warn) * 0.6, role, true));
        });
      }

      out.sort(function (a, b) { return a.ratio - b.ratio; });
      out = out.slice(0, 4);
      repartitLp(out);
      return out;
    }

    /* Le total des objectifs vaut la distance jusqu'au palier visé, et les
       poids par métrique ne servent plus qu'à répartir ce total. Atteindre
       tout ce qui est demandé mène donc à Maître, quel que soit le rang de
       départ. Au-delà de Maître, on vise le palier suivant. */
    var LP_MASTER = 7 * 400;

    function paliersVises(depart) {
      if (depart < LP_MASTER) return LP_MASTER - depart;
      if (depart < LP_MASTER + LP_GM_OFFSET) return LP_MASTER + LP_GM_OFFSET - depart;
      if (depart < LP_MASTER + LP_CHALL_OFFSET) return LP_MASTER + LP_CHALL_OFFSET - depart;
      return 400;
    }

    function repartitLp(objs) {
      if (!objs.length) return;
      var depart = currentScore();
      if (depart === null) return;              // sans rang connu, on garde les poids bruts

      /* Plancher : quelqu'un déjà tout près de Maître se voyait proposer
         quatre objectifs à quinze LP pièce, un chiffre risible pour un
         travail bien réel. En dessous de 300, on promet 300 : l'élève
         arrive alors au-delà du palier, la promesse reste donc vraie. */
      var total = Math.max(300, paliersVises(depart));
      var poids = objs.map(function (o) { return Math.max(1, o.lp); });
      var somme = poids.reduce(function (a, b) { return a + b; }, 0);

      var cumul = 0;
      objs.forEach(function (o, i) {
        if (i === objs.length - 1) {
          /* Le dernier absorbe l'arrondi : la somme doit tomber juste,
             sinon la projection n'atteint pas le palier annoncé. */
          o.lp = Math.max(10, total - cumul);
        } else {
          o.lp = Math.max(10, Math.round((total * poids[i]) / somme / 10) * 10);
          cumul += o.lp;
        }
      });
    }

    /* ------------------------------------------------------------------
       La courbe : où en est la stat, et où il faut l'amener.
       On lisse par moyenne glissante, game par game, le bruit est tel
       qu'aucune tendance n'est lisible.
       ------------------------------------------------------------------ */

    function serieMetrique(games, cle) {
      var out = [];
      games.forEach(function (g) {
        var v = null;
        if (cle === "csMin") v = g.cs;
        else if (cle === "kp") v = g.kp;
        else if (cle === "dpm") v = g.dpm;
        else if (cle === "gpm") v = g.gpm;
        else if (cle === "early") v = g.early === null || g.early === undefined ? null : g.early * 100;
        else if (cle === "kda") {
          if (g.k !== null && g.k !== undefined && g.a !== null && g.a !== undefined && g.d !== null && g.d !== undefined) {
            v = (g.k + g.a) / Math.max(1, g.d);
          }
        }
        if (v !== null && v !== undefined && !isNaN(v)) out.push(v);
      });
      return out;
    }

    function moyenneGlissante(v, fenetre) {
      if (v.length <= fenetre) return v.slice();
      var out = [];
      for (var i = fenetre - 1; i < v.length; i++) {
        var s = 0;
        for (var j = i - fenetre + 1; j <= i; j++) s += v[j];
        out.push(s / fenetre);
      }
      return out;
    }

    function courbeObjectif(brut, cible, flou) {
      if (brut.length < 4) return "";
      var serie = moyenneGlissante(brut, Math.max(3, Math.round(brut.length / 8)));
      if (serie.length < 2) return "";

      var W = 100, H = 40;
      /* Cadrage serré sur la courbe elle-même. Englober la cible dans le
         calcul de l'échelle écrasait le tracé dès qu'elle était loin, et
         donnait l'impression de ne jamais bouger. La cible est ensuite
         ramenée dans le cadre, avec une marge minimale. */
      var sLo = Math.min.apply(null, serie), sHi = Math.max.apply(null, serie);
      var amplitude = sHi - sLo;
      if (amplitude < Math.abs(cible) * 0.04) amplitude = Math.abs(cible) * 0.04 || 1;
      var lo = Math.min(sLo - amplitude * 0.3, cible - amplitude * 0.18);
      var hi = Math.max(sHi + amplitude * 0.3, cible + amplitude * 0.18);

      var px = function (i) { return (i / (serie.length - 1)) * W; };
      var py = function (v) { return H - ((v - lo) / (hi - lo)) * H; };

      var pts = serie.map(function (v, i) { return px(i).toFixed(2) + "," + py(v).toFixed(2); }).join(" ");
      var aire = "0," + H + " " + pts + " " + W + "," + H;
      var yc = py(cible).toFixed(2);
      var dernier = serie[serie.length - 1];
      var pctDot = ((py(dernier) / H) * 100).toFixed(2);
      var pctGoal = ((py(cible) / H) * 100).toFixed(2);

      return (
        '<div class="lp-obj__chart' + flou + '">' +
        '<div class="lp-obj__chart-box">' +
        '<svg viewBox="0 0 ' + W + " " + H + '" preserveAspectRatio="none" role="img" aria-label="Évolution de la statistique et objectif">' +
        '<defs><linearGradient id="lpObjFill" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0%" stop-color="var(--lp-volt)" stop-opacity="0.18"/>' +
        '<stop offset="100%" stop-color="var(--lp-volt)" stop-opacity="0"/>' +
        "</linearGradient></defs>" +
        '<polygon points="' + aire + '" fill="url(#lpObjFill)"/>' +
        '<line x1="0" y1="' + yc + '" x2="' + W + '" y2="' + yc +
        '" stroke="var(--lp-volt)" stroke-width="0.4" stroke-dasharray="1.6 2.2" opacity="0.65"/>' +
        '<polyline points="' + pts + '" fill="none" stroke="var(--lp-volt)" stroke-width="1" ' +
        'stroke-linejoin="round" stroke-linecap="round" vector-effect="non-scaling-stroke"/>' +
        "</svg>" +
        '<span class="lp-obj__chart-dot" style="top:' + pctDot + '%"></span>' +
        '<span class="lp-obj__chart-goal" style="top:' + pctGoal + '%">objectif</span>' +
        "</div>" +
        "</div>"
      );
    }

    /* Trois chiffres qui répondent aux trois questions qu'on se pose devant
       un objectif : est-ce que j'en suis capable, où j'en suis en ce moment,
       et à partir de quand c'est bon. */
    function reperesObjectif(brut, o, seuils, flou) {
      if (!brut.length) return "";
      var record = Math.max.apply(null, brut);
      var recents = brut.slice(-10);
      var forme = recents.reduce(function (s, x) { return s + x; }, 0) / recents.length;

      return (
        '<div class="lp-obj__stats">' +
        '<div class="lp-obj__stat"><span class="lp-obj__stat-k">Ton record</span>' +
        '<span class="lp-obj__stat-v' + flou + '">' + objArrondi(record, o.dec) + o.unite + "</span></div>" +
        '<div class="lp-obj__stat"><span class="lp-obj__stat-k">Sur ' + recents.length + ' games</span>' +
        '<span class="lp-obj__stat-v' + flou + '">' + objArrondi(forme, o.dec) + o.unite + "</span></div>" +
        '<div class="lp-obj__stat"><span class="lp-obj__stat-k">Repère du rôle</span>' +
        '<span class="lp-obj__stat-v' + flou + '">' + objArrondi(seuils.warn, o.dec) + " · " +
        objArrondi(seuils.good, o.dec) + o.unite + "</span></div>" +
        "</div>"
      );
    }

    /* La projection : ce que vaut l'ensemble des objectifs, traduit en rang.
       C'est le seul endroit du tableau de bord qui montre où l'élève peut
       arriver, et pas seulement ce qui ne va pas. */
    function projectionRang(objs, flou) {
      var total = 0;
      objs.forEach(function (o) { total += o.lp; });
      if (!total) return "";

      var depart = currentScore();
      var corps;
      if (depart === null) {
        corps = '<span class="lp-obj__proj-lp">+' + total + " LP au total · estimation sur ton profil</span>";
      } else {
        var d = scoreToRank(depart), a = scoreToRank(depart + total);
        corps =
          '<span class="lp-obj__proj-rank">' +
          '<span class="lp-obj__proj-from' + flou + '">' + esc(formatRank(d.tier, d.div, d.lp)) + "</span>" +
          '<span class="lp-obj__proj-arrow" aria-hidden="true">→</span>' +
          '<span class="lp-obj__proj-to' + flou + '">' + esc(formatRank(a.tier, a.div, a.lp)) + "</span>" +
          "</span>" +
          '<span class="lp-obj__proj-lp">+' + total + " LP sur " + objs.length +
          (objs.length > 1 ? " objectifs" : " objectif") + " · estimation sur ton profil</span>";
      }

      return (
        '<div class="lp-obj__proj">' +
        '<span class="lp-obj__proj-head">Si tu atteins tout</span>' +
        corps +
        "</div>"
      );
    }

    /* ------------------------------------------------------------------
       Deux modules sous les objectifs.

       Le premier remet la stat travaillée dans l'ensemble : on ne voit
       qu'un objectif à la fois, il faut bien pouvoir situer le reste.
       Le second traduit le rang en quelque chose de faisable ce soir -
       un objectif à trois mois ne suffit pas à faire lancer une game.
       ------------------------------------------------------------------ */

    /* ------------------------------------------------------------------
       LE COACHING ADAPTÉ AU PROFIL

       Trois critères, dans cet ordre d'autorité :

         1. Le rang, qui fixe la formule de base. Les plages annoncées sur
            la page d'offres se chevauchent volontairement (Fer→Platine,
            Or→Diamant, Émeraude→GrandMaster) : c'est exactement dans ces
            zones de recouvrement que les deux autres critères tranchent.

         2. L'objectif déclaré à l'entrée. « Être coaché » monte d'un cran,
            « Jouer sans prise de tête » descend d'un cran.

         3. Les stats face au repère du rôle. Nettement en dessous, on
            descend ; au niveau ou au-dessus, on monte.

       Les deux décalages se cumulent mais ne peuvent pas déplacer de plus
       d'un cran au total : le rang reste dominant, et personne ne se voit
       proposer une formule à deux crans de son niveau réel.

       LE CALCUL DU GAIN

       Les +400 LP annoncés sur la home sont une moyenne du PREMIER mois,
       pas un rythme tenu. Lisser 400 par mois sur trois mois donnerait
       1200 LP, ce que personne ne croirait, et à raison.

       Le modèle décroît donc : un premier mois fort, où l'on corrige les
       erreurs les plus coûteuses, puis un régime de croisière beaucoup
       plus lent. La suite dépend des stats : celui qui part de bas a plus
       de marge à récupérer que celui qui plafonne déjà.

       Le total tombe entre 600 et 900 LP sur trois mois, jamais au-delà.
       mois1 et les paliers de suite sont les seuls chiffres de ce fichier
       qui ne sortent pas des données de l'élève. Ils se règlent ici.
       ------------------------------------------------------------------ */

    /* Les CTA pointent tous vers la page d'offres ; au clic, le bloc
       « PAGE D'OFFRES » en fin de fichier y ajoute la formule recommandée,
       ou envoie vers le quiz de la home quand le profil est inconnu. */
    var LP_PAGE_OFFRES = "/pages/tableau-offres";
    var LP_CLE_RECO = "lp_offre_reco_v1";

    var LP_OFFRES = [
      { cle: "novice",        nom: "Coaching Novice",        prix: "39,90 €",  mois1: 350 },
      { cle: "intermediaire", nom: "Coaching Intermédiaire", prix: "69,90 €",  mois1: 400 },
      { cle: "excellence",    nom: "Coaching Excellence",    prix: "129,90 €", mois1: 450 }
    ];

    /* Le rythme des mois 2 et 3. Plus les stats sont basses, plus il reste
       de marge évidente à récupérer ; celui qui est déjà au repère avance
       nécessairement plus lentement. */
    function suiteMensuelle(ratio) {
      if (ratio === null || ratio === undefined) return 175;
      if (ratio <= 0.8) return 225;
      if (ratio <= 0.95) return 175;
      return 125;
    }

    function objectifDeclare() {
      try {
        return (JSON.parse(window.lpAccountStorage.getItem("lp_ob_v1") || "{}") || {}).objectif || null;
      } catch (e) {
        return null;
      }
    }

    function recommandeOffre(metrics, role) {
      /* 1. Le rang */
      var tier = state.base ? TIERS.indexOf(String(state.base.tier || "").toUpperCase()) : -1;
      var base = tier < 0 ? 1 : tier <= 3 ? 0 : tier <= 5 ? 1 : 2;

      /* 2. L'objectif déclaré */
      var obj = objectifDeclare();
      var dObj = obj === "etre-coache" ? 1 : obj === "plaisir" ? -1 : 0;

      /* 3. Les stats face au repère */
      var dStat = 0, ratio = null;
      if (metrics && metrics.games >= OBJ_MIN_GAMES) {
        var seuils = LP_RECO_THRESHOLDS[role] || LP_RECO_THRESHOLDS.mid;
        var somme = 0, n = 0;
        OBJ_METRIQUES.forEach(function (m) {
          var t = seuils[m.cle];
          if (!t) return;
          var v = metrics[m.cle];
          if (v === null || v === undefined || isNaN(v)) return;
          somme += v / t.good;
          n++;
        });
        if (n) {
          ratio = somme / n;
          dStat = ratio >= 0.95 ? 1 : ratio <= 0.8 ? -1 : 0;
        }
      }

      var d = Math.max(-1, Math.min(1, dObj + dStat));
      var idx = Math.max(0, Math.min(LP_OFFRES.length - 1, base + d));

      return { offre: LP_OFFRES[idx], idx: idx, base: base, dObj: dObj, dStat: dStat, ratio: ratio };
    }

    function projectionOffre(offre, ratio) {
      var suite = suiteMensuelle(ratio);
      var gain = offre.mois1 + suite * 2;
      var depart = currentScore();
      var arrivee = null;
      if (depart !== null) {
        var r = scoreToRank(depart + gain);
        arrivee = {
          de: formatRank(scoreToRank(depart).tier, scoreToRank(depart).div, 0),
          vers: formatRank(r.tier, r.div, 0)
        };
      }
      return { gain: gain, mois1: offre.mois1, suite: suite, arrivee: arrivee };
    }

    /* variante : "sidebar" pour la carte de la barre latérale, sinon le
       bloc autonome. */
    function blocOffre(metrics, role, source, variante) {
      var reco = recommandeOffre(metrics, role);
      var o = reco.offre;
      var p = projectionOffre(o, reco.ratio);
      var suivi = esc(source) + "-" + o.cle;

      if (variante === "sidebar") {
        return (
          '<span class="lp-sidebar__promo-text">' +
          '<span class="lp-members-pill">LP</span><br>' +
          esc(o.nom) + "<br>+" + p.gain + " LP estimés sur ton profil" +
          "</span>" +
          '<span class="lp-sidebar__promo-chev">›</span>'
        );
      }

      return (
        '<a class="lp-offre" href="' + LP_PAGE_OFFRES + '" data-lp-offers-cta="' + suivi + '">' +
        '<span class="lp-offre__head">Recommandé pour toi</span>' +
        '<span class="lp-offre__line">' +
        '<span class="lp-offre__name">' + esc(o.nom) + "</span>" +
        '<span class="lp-offre__gain">+' + p.gain + " LP sur 3 mois</span>" +
        "</span>" +
        (p.arrivee
          ? '<span class="lp-offre__rank">' + esc(p.arrivee.de) + " → " + esc(p.arrivee.vers) + "</span>"
          : "") +
        '<span class="lp-offre__foot">' +
        '<span class="lp-offre__btn">Découvrir</span>' +
        '<span class="lp-offre__sub">Estimation sur ton profil · Progression ou remboursé · Sans engagement</span>' +
        "</span>" +
        "</a>"
      );
    }

    /* La formule recommandée est retenue pour les liens vers la page
       d'offres. Seulement quand le rang est connu : sans lui, la
       recommandation n'est qu'une valeur par défaut, et le visiteur ira
       plutôt répondre au quiz de la home. */
    function memoriseReco(metrics, role) {
      try {
        if (state.base && state.base.tier) {
          var cle = recommandeOffre(metrics, role).offre.cle;
          window.lpAccountStorage.setItem(LP_CLE_RECO, JSON.stringify({ cle: cle, t: Date.now() }));
        } else {
          window.lpAccountStorage.removeItem(LP_CLE_RECO);
        }
      } catch (e) {}
    }

    /* Remplit tous les emplacements qui attendent la recommandation. */
    function placeOffres(metrics, role) {
      if (LP_IS_SUBSCRIBER) return;   // déjà élève : pas d'offre à lui vendre
      memoriseReco(metrics, role);
      var cibles = document.querySelectorAll("[data-lp-offre]");
      for (var i = 0; i < cibles.length; i++) {
        var el = cibles[i];
        el.innerHTML = blocOffre(
          metrics,
          role,
          el.getAttribute("data-lp-offre") || "dashboard",
          el.getAttribute("data-lp-offre-variante") || "plein"
        );
        el.hidden = false;
      }
    }

    function renderObjModules(metrics, role, actifCle) {
      var hote = document.getElementById("lpObjMore");
      if (!hote) return;
      if (!metrics || metrics.games < OBJ_MIN_GAMES) { hote.innerHTML = ""; return; }

      var flou = LP_IS_SUBSCRIBER ? "" : " lp-blur-val";
      var seuils = LP_RECO_THRESHOLDS[role] || LP_RECO_THRESHOLDS.mid;
      var html = "";

      /* --- Toutes les stats face au repère du rôle --- */
      var lignes = "";
      OBJ_METRIQUES.forEach(function (m) {
        var t = seuils[m.cle];
        if (!t) return;
        var v = metrics[m.cle];
        if (v === null || v === undefined || isNaN(v)) return;

        var palier = t.good - t.warn;
        var plancher = Math.max(0, t.warn - palier);
        var pct = Math.max(2, Math.min(100, ((v - plancher) / Math.max(0.0001, t.good - plancher)) * 100));
        var etat = v >= t.good ? "good" : v >= t.warn ? "warn" : "bad";

        lignes +=
          '<div class="lp-objm__row' + (m.cle === actifCle ? " is-on" : "") + '">' +
          '<span class="lp-objm__name">' + esc(m.nom) + "</span>" +
          '<span class="lp-objm__track"><span class="lp-objm__fill is-' + etat +
          '" style="width:' + pct.toFixed(0) + '%"></span></span>' +
          '<span class="lp-objm__val' + flou + '">' + objArrondi(v, m.dec) + o_unite(m) + "</span>" +
          "</div>";
      });

      if (lignes) {
        html +=
          '<div class="lp-objm">' +
          '<span class="lp-objm__head">Toutes tes stats face au repère ' +
          esc(ROLE_LABELS[role] || role) + "</span>" +
          lignes +
          "</div>";
      }

      /* --- Le palier suivant, en victoires --- */
      var depart = currentScore();
      if (depart !== null) {
        var manque, vers;
        if (depart < LP_MASTER) {
          var seuil = (Math.floor(depart / 100) + 1) * 100;
          manque = seuil - depart;
          var r = scoreToRank(seuil);
          vers = formatRank(r.tier, r.div, 0);
        } else {
          manque = paliersVises(depart);
          vers = depart < LP_MASTER + LP_GM_OFFSET ? "Grand Maître" : "Challenger";
        }
        var gain = (state.mmr && state.mmr.gain) || 25;
        var vict = Math.max(1, Math.ceil(manque / gain));

        html +=
          '<div class="lp-objm lp-objm--step">' +
          '<span class="lp-objm__head">Le palier suivant</span>' +
          '<div class="lp-objm__step">' +
          '<span class="lp-objm__step-v' + flou + '">' + vict + "</span>" +
          '<span class="lp-objm__step-k">' + (vict > 1 ? "victoires nettes" : "victoire nette") +
          " pour " + esc(vers) + "</span>" +
          "</div>" +
          '<span class="lp-objm__step-sub' + flou + '">' + manque + " LP à prendre, au rythme de " +
          gain + " LP par victoire</span>" +
          "</div>";
      }

      hote.innerHTML = html;
    }

    function o_unite(m) {
      return m.unite || "";
    }

    function carteObjectif(o, rang, games, seuils, objs) {
      var flou = LP_IS_SUBSCRIBER ? "" : " lp-blur-val";
      var brut = serieMetrique(games || [], o.cle);
      var mcs = o.masterclass.map(function (m, i) {
        return '<button type="button" class="lp-obj__mc' + flou + '" data-obj-mc="' + i + '">' +
          esc(m.titre) + "</button>";
      }).join("");

      return (
        '<article class="lp-obj__main">' +

        '<div class="lp-obj__lead">' +
        '<span class="lp-obj__rank">Priorité ' + (rang + 1) + "</span>" +
        '<h3 class="lp-obj__name">' + esc(o.nom) + "</h3>" +
        '<div class="lp-obj__figures">' +
        '<span class="lp-obj__now' + flou + '">' + objArrondi(o.actuel, o.dec) + "</span>" +
        '<span class="lp-obj__arrow" aria-hidden="true">→</span>' +
        '<span class="lp-obj__goal' + flou + '">' + objArrondi(o.cible, o.dec) + o.unite + "</span>" +
        "</div>" +
        '<div class="lp-obj__bar' + flou + '"><span style="width:' + o.progression.toFixed(0) + '%"></span></div>' +
        '<div class="lp-obj__meta">' +
        '<span class="lp-obj__lp">+' + o.lp + " LP estimés</span>" +
        '<span class="lp-obj__time">' + esc(o.duree) + "</span>" +
        "</div>" +
        courbeObjectif(brut, o.cible, flou) +
        "</div>" +

        '<aside class="lp-obj__side">' +
        reperesObjectif(brut, o, seuils, flou) +
        projectionRang(objs, flou) +
        (mcs
          ? '<div class="lp-obj__mcs"><span class="lp-obj__mcs-head">Pour y arriver</span>' + mcs + "</div>"
          : "") +
        "</aside>" +

        "</article>"
      );
    }

    function carteSuivante(o, index) {
      var flou = LP_IS_SUBSCRIBER ? "" : " lp-blur-val";
      return (
        '<button type="button" class="lp-obj__next" data-obj-go="' + index + '">' +
        '<span class="lp-obj__next-rank">' + (index + 1) + "</span>" +
        '<span class="lp-obj__next-name">' + esc(o.nom) + "</span>" +
        '<span class="lp-obj__next-goal' + flou + '">' + objArrondi(o.cible, o.dec) + o.unite + "</span>" +
        '<span class="lp-obj__next-lp">+' + o.lp + " LP</span>" +
        "</button>"
      );
    }

    /* actif : lequel des objectifs occupe la place centrale. Les autres ne
       sont là que pour montrer qu'il y a une suite, et se prennent d'un clic. */
    function renderObjectifs(metrics, role, games, actif) {
      var hote = document.getElementById("lpObjectifs");
      if (!hote) return;

      placeOffres(metrics, role);

      var objs = construitObjectifs(metrics, role);

      if (!objs.length) {
        hote.innerHTML =
          '<div class="lp-obj__empty">Il faut au moins ' + OBJ_MIN_GAMES +
          " games enregistrées pour fixer un objectif.</div>";
        return;
      }

      var i = typeof actif === "number" && objs[actif] ? actif : 0;
      var suivants = [];
      objs.forEach(function (o, k) { if (k !== i) suivants.push({ o: o, k: k }); });
      var seuils = (LP_RECO_THRESHOLDS[role] || LP_RECO_THRESHOLDS.mid)[objs[i].cle];
      renderObjModules(metrics, role, objs[i].cle);

      hote.innerHTML =
        carteObjectif(objs[i], i, games, seuils, objs) +
        (suivants.length
          ? '<div class="lp-obj__next-block">' +
            '<span class="lp-obj__next-head">' +
            (suivants.length === 1 ? "Ton prochain objectif" : "Ensuite") + "</span>" +
            '<div class="lp-obj__next-row">' +
            suivants.map(function (x) { return carteSuivante(x.o, x.k); }).join("") +
            "</div></div>"
          : "") +
        (LP_IS_SUBSCRIBER ? "" : blocOffre(metrics, role, "objectifs", "plein"));

      /* Masterclass : même chemin que les recommandations, verrou compris. */
      var mcs = hote.querySelectorAll("[data-obj-mc]");
      for (var a = 0; a < mcs.length; a++) {
        (function (btn) {
          btn.addEventListener("click", function () {
            var cible = (objs[i].masterclass[+btn.getAttribute("data-obj-mc")] || {}).card;
            if (!cible) return;
            if (cible.dataset.locked === "true") {
              if (window.lpOpenLockModal) window.lpOpenLockModal();
              return;
            }
            goToCard(cible);
          });
        })(mcs[a]);
      }

      /* Un objectif suivant prend la place centrale. */
      var gos = hote.querySelectorAll("[data-obj-go]");
      for (var b = 0; b < gos.length; b++) {
        (function (btn) {
          btn.addEventListener("click", function () {
            renderObjectifs(metrics, role, games, +btn.getAttribute("data-obj-go"));
          });
        })(gos[b]);
      }
    }


    /* ---- Objectifs écrits par le coach dans le suivi ----
       Onglet « objectifs », cellules B16 et suivantes. Le bloc n'existe
       que s'il y a quelque chose dedans. */
    function renderObjPerso(liste) {
      var el = document.getElementById("lpObjPerso");
      if (!el) return;
      liste = (liste || []).filter(function (x) { return x && x.length > 1; }).slice(0, 5);
      if (!liste.length) { el.hidden = true; return; }

      el.innerHTML =
        '<span class="lp-obj-perso__head">Fixés par ton coach</span>' +
        '<ul class="lp-obj-perso__list">' +
        liste.map(function (o) { return '<li>' + esc(o) + "</li>"; }).join("") +
        "</ul>";
      el.hidden = false;
    }

    function renderRecos(metrics, role, winrate) {
      var list = document.getElementById("lpRecoList");
      if (!list) return;

      if (!metrics || metrics.games === 0) {
        list.innerHTML = '<div class="lp-reco-empty">Ajoute tes premières games pour recevoir tes recommandations.</div>';
        return;
      }

      var recos = buildRecos(metrics, role, winrate);

      if (!recos.length) {
        var roleLabel = ROLE_LABELS[role] || role;
        list.innerHTML =
          '<div class="lp-reco-empty">Aucun point faible net détecté<br>' +
          'Continue avec le <button type="button" class="lp-reco-starter" style="border:0;background:none;padding:0;color:var(--lp-amber);font-weight:600;cursor:pointer;text-decoration:underline;">starter pack ' + esc(roleLabel) + "</button>.</div>";

        var starterBtn = list.querySelector(".lp-reco-starter");
        if (starterBtn) {
          starterBtn.addEventListener("click", function () {
            if (typeof window.lpActivateDashboardTab === "function") {
              window.lpActivateDashboardTab("lpPanelMasterclass");
            }
            setTimeout(function () {
              var img = document.querySelector('#lpPanelMasterclass .filter-roles img[alt="' + role + '"]');
              if (img && !img.classList.contains("selected")) img.click();
            }, 150);
          });
        }
        return;
      }

      list.innerHTML = "";
      recos.forEach(function (r, index) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "lp-reco";

        /* Valeur en avance : la première recommandation est lisible et
           cliquable même sans abonnement. Le visiteur repart avec une chose
           à appliquer le soir même, ce qui est précisément ce qui donne
           envie de débloquer la suivante. Les autres restent floutées. */
        var ouverte = LP_IS_SUBSCRIBER || index === 0;

        var titleHtml = ouverte
          ? esc(r.title)
          : '<span class="lp-blur-val">' + esc(r.title) + "</span>";
        var goHtml = ouverte ? "→" : "<svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\"><rect x=\"5\" y=\"11\" width=\"14\" height=\"9\" rx=\"2\"/><path d=\"M8 11V7a4 4 0 0 1 8 0v4\"/></svg>";

        btn.innerHTML =
          '<span class="lp-reco__badge">' + esc(r.label) + "</span>" +
          '<span class="lp-reco__body"><span class="lp-reco__title">' + titleHtml + "</span><br>" +
          '<span class="lp-reco__why">' + esc(r.why) + "</span></span>" +
          '<span class="lp-reco__go">' + goHtml + "</span>";

        btn.addEventListener("click", function () {
          if (!ouverte) {
            if (window.lpOpenLockModal) window.lpOpenLockModal();
            return;
          }
          if (!LP_IS_SUBSCRIBER && window.lpTrack) {
            window.lpTrack("reco_offerte_ouverte", { titre: r.title, carte: r.card });
          }
          goToCard(r.card);
        });
        list.appendChild(btn);
      });
    }

    /* ------------------------------------------------------------------
       TA MASTERCLASS À REGARDER, en haut de la synthèse

       Une seule masterclass, tirée de l'objectif principal : la réponse à
       « je fais quoi maintenant ? », sans rien à trier.

       Le déroulé, objectif par objectif :
         1. la première masterclass de l'objectif principal ;
         2. une fois regardée, la seconde ;
         3. une fois regardée aussi, elle reste affichée, avec une ligne qui
            dit qu'elle reste la priorité tant que la stat ne monte pas ;
         4. dès que la stat est nettement en hausse, on passe à l'objectif
            suivant et on recommence en 1.

       Pourquoi ne pas rester sur le premier objectif jusqu'au bout : un
       élève qui voit la même consigne pendant des mois finit par se dire
       qu'il n'a que ça à travailler, ou qu'il n'avance pas. Passer à la
       suite dès qu'un vrai progrès est là lui donne une raison de revenir.

       L'objectif est figé au moment où il est choisi : recalculé à chaque
       game, il changerait au gré des soirées et le plan ne voudrait plus
       rien dire. La hausse se mesure sur les games jouées DEPUIS ce moment,
       comparées au niveau de départ. Il en faut assez pour que ce ne soit
       pas du bruit, et une hausse franche : on ne valide pas un objectif
       sur une bonne soirée.
       ------------------------------------------------------------------ */

    var K_PLAN = "lp_synth_plan_mc_v1";
    var PLAN_HAUSSE = 0.25;    // hausse exigée par rapport au départ : +25 %
    var PLAN_MIN_GAMES = 10;   // games mesurées depuis le départ, au minimum
    var planDernier = null;

    function planEnHausse(plan, games) {
      var nouvelles = games.slice(plan.n0);
      if (serieMetrique(nouvelles, plan.cle).length < PLAN_MIN_GAMES) return false;
      var actuel = computeMetrics(nouvelles)[plan.cle];
      if (actuel === null || actuel === undefined || isNaN(actuel)) return false;
      if (!(plan.depart > 0)) return actuel > 0;
      return actuel / plan.depart - 1 >= PLAN_HAUSSE;
    }

    function renderPlanMc(metrics, role, games) {
      var hote = document.getElementById("lpPlanMc");
      if (!hote) return;
      planDernier = { metrics: metrics, role: role, games: games };

      /* L'objectif principal est le premier de la liste, qui est triée du
         plus en retard au moins en retard. Seuls comptent ceux qui ont une
         masterclass associée. */
      var objs = construitObjectifs(metrics, role).filter(function (o) {
        return o.masterclass.length > 0;
      });
      if (!objs.length) {
        hote.hidden = true;
        hote.innerHTML = "";
        return;
      }

      var plan = readJson(K_PLAN, null);
      if (plan && plan.role !== role) plan = null;   // changement de rôle : autre plan

      /* Suivi vidé ou source changée : on mesure à partir de maintenant. */
      if (plan && games.length < plan.n0) {
        plan.n0 = games.length;
        writeJson(K_PLAN, plan);
      }

      var courant = plan ? objs.filter(function (o) { return o.cle === plan.cle; })[0] : null;

      if (!plan || !courant || planEnHausse(plan, games)) {
        var faits = plan && plan.faits ? plan.faits.slice() : [];
        var depuis = null;

        /* Nettement en hausse, ou sorti des objectifs parce qu'atteint :
           l'objectif est validé. */
        if (plan) {
          if (faits.indexOf(plan.cle) < 0) faits.push(plan.cle);
          depuis = plan.nom || null;
        }

        var restants = objs.filter(function (o) { return faits.indexOf(o.cle) < 0; });
        if (!restants.length) {
          /* Tout a été travaillé : nouveau tour, en commençant par le plus
             en retard, sauf celui qu'on vient de valider s'il y a le choix. */
          faits = plan ? [plan.cle] : [];
          restants = objs.filter(function (o) { return faits.indexOf(o.cle) < 0; });
          if (!restants.length) { faits = []; restants = objs; }
        }

        courant = restants[0];
        plan = {
          cle: courant.cle,
          nom: courant.nom,
          role: role,
          depart: courant.actuel,
          n0: games.length,
          faits: faits,
          depuis: depuis,
          t: Date.now()
        };
        writeJson(K_PLAN, plan);
      }

      /* La première non regardée, dans l'ordre. Toutes regardées : la
         dernière reste, et la ligne d'explication apparaît. */
      var mcs = courant.masterclass;
      var idx = 0;
      while (idx < mcs.length - 1 && lpIsMasterclassWatched(mcs[idx].card.id)) idx++;
      var enAttente = lpIsMasterclassWatched(mcs[idx].card.id);

      /* L'annonce du changement d'objectif ne sert qu'au premier contact. */
      if (plan.depuis && (idx > 0 || enAttente)) {
        plan.depuis = null;
        writeJson(K_PLAN, plan);
      }

      var r = mcs[idx];
      var verrou = r.card.dataset.locked === "true";
      var goHtml = verrou
        ? "<svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\"><rect x=\"5\" y=\"11\" width=\"14\" height=\"9\" rx=\"2\"/><path d=\"M8 11V7a4 4 0 0 1 8 0v4\"/></svg>"
        : "→";

      hote.innerHTML =
        '<div class="lp-subsection-title">Ta masterclass à regarder</div>' +
        (plan.depuis
          ? '<p class="lp-plan__news">Ton objectif « ' + esc(plan.depuis) + " » est nettement en hausse : on passe au suivant.</p>"
          : "") +
        '<div class="lp-reco-list">' +
        '<button type="button" class="lp-reco" data-plan-mc>' +
        '<span class="lp-reco__badge">' + (mcs.length > 1 ? idx + 1 + " sur " + mcs.length : "Priorité") + "</span>" +
        '<span class="lp-reco__body"><span class="lp-reco__title">' + esc(r.titre) + "</span><br>" +
        '<span class="lp-reco__why">Objectif principal : ' + esc(courant.nom) + "</span></span>" +
        '<span class="lp-reco__go">' + goHtml + "</span>" +
        "</button>" +
        "</div>" +
        (enAttente
          ? '<p class="lp-plan__note">Elle reste ta priorité tant que ton objectif principal (' + esc(courant.nom) + ") n'est pas nettement en hausse.</p>"
          : "");
      hote.hidden = false;

      /* Même chemin qu'un clic sur la carte : lecture directe, marquée
         comme vue, ou fenêtre de déblocage si elle est réservée. */
      hote.querySelector("[data-plan-mc]").addEventListener("click", function () {
        if (window.lpTrack) window.lpTrack("plan_mc_ouverte", { objectif: courant.cle, etape: idx + 1 });
        if (typeof window.lpOpenVideoFromCard === "function") {
          window.lpOpenVideoFromCard(r.card);
        } else if (verrou) {
          if (window.lpOpenLockModal) window.lpOpenLockModal();
        } else {
          goToCard(r.card);
        }
      });
    }

    /* Une masterclass marquée comme vue, depuis n'importe où : le module
       passe à la suite sans attendre un rechargement. */
    (function () {
      var avant = window.lpRefreshWatchedMasterclassesUI;
      if (typeof avant !== "function") return;
      window.lpRefreshWatchedMasterclassesUI = function () {
        var res = avant.apply(this, arguments);
        if (planDernier) renderPlanMc(planDernier.metrics, planDernier.role, planDernier.games);
        return res;
      };
    })();

    /* ------------------------------------------------------------------
       MENTAL, ce que la suite des résultats dit du joueur.

       Tout se déduit de l'ordre des games, pas de leur contenu : c'est la
       seule chose dont on dispose et c'est justement ce qui parle du
       mental. Les valeurs sont floutées pour les non-élèves ; les intitulés
       restent lisibles pour qu'ils voient ce qui les attend.
       ------------------------------------------------------------------ */

    var MENTAL_MIN = 8; // en dessous, une série ne veut rien dire

    function clamp100(v) {
      return Math.max(0, Math.min(100, v));
    }

    function computeMental(games) {
      var n = games.length;
      var out = { games: n, assez: n >= MENTAL_MIN };
      if (!out.assez) return out;

      var r = games.map(function (g) { return g.w ? 1 : 0; });

      /* Enchaînements : ce qui suit une victoire, une défaite, deux défaites. */
      var apW = { n: 0, w: 0 }, apL = { n: 0, w: 0 }, apLL = { n: 0, w: 0 };
      for (var i = 1; i < n; i++) {
        var box = r[i - 1] ? apW : apL;
        box.n++;
        if (r[i]) box.w++;
        if (i >= 2 && !r[i - 1] && !r[i - 2]) {
          apLL.n++;
          if (r[i]) apLL.w++;
        }
      }
      out.apresWin = apW.n >= 3 ? (apW.w / apW.n) * 100 : null;
      out.apresLose = apL.n >= 3 ? (apL.w / apL.n) * 100 : null;
      out.apres2Lose = apLL.n >= 3 ? (apLL.w / apLL.n) * 100 : null;
      out.tilt = out.apresWin !== null && out.apresLose !== null
        ? out.apresWin - out.apresLose
        : null;

      /* Séries les plus longues + part des games passées dedans. */
      var maxW = 0, maxL = 0, cw = 0, cl = 0;
      r.forEach(function (x) {
        if (x) { cw++; cl = 0; } else { cl++; cw = 0; }
        if (cw > maxW) maxW = cw;
        if (cl > maxL) maxL = cl;
      });
      out.maxWin = maxW;
      out.maxLose = maxL;

      function partEnSerie(cible) {
        var run = 0, dedans = 0;
        for (var j = 0; j <= n; j++) {
          if (j < n && r[j] === cible) run++;
          else { if (run >= 3) dedans += run; run = 0; }
        }
        return (dedans / n) * 100;
      }
      out.serieLose = partEnSerie(0);
      out.serieWin = partEnSerie(1);

      /* Régularité : dispersion des performances game après game, mesurée
         sur la statistique la mieux renseignée du suivi. */
      function serie(f) {
        var v = [];
        games.forEach(function (g) {
          var x = f(g);
          if (x !== null && x !== undefined && !isNaN(x)) v.push(x);
        });
        return v;
      }
      var candidats = [
        serie(function (g) {
          if (g.k === null || g.k === undefined || g.a === null || g.a === undefined || g.d === null || g.d === undefined) return null;
          return (g.k + g.a) / Math.max(1, g.d);
        }),
        serie(function (g) { return g.dpm; }),
        serie(function (g) { return g.cs; })
      ];
      var v = candidats.sort(function (x, y) { return y.length - x.length; })[0];
      if (v && v.length >= 5) {
        var moy = v.reduce(function (s, x) { return s + x; }, 0) / v.length;
        if (moy > 0) {
          var variance = v.reduce(function (s, x) { return s + (x - moy) * (x - moy); }, 0) / v.length;
          out.cv = (Math.sqrt(variance) / moy) * 100;
          out.regularite = Math.round(clamp100(100 - out.cv * 1.6));
        }
      }

      /* Note globale : résistance au tilt, séries subies, régularité. */
      var pts = [];
      if (out.tilt !== null) pts.push(clamp100(100 - out.tilt * 2.5));
      pts.push(clamp100(100 - out.serieLose * 2));
      if (out.regularite !== null && out.regularite !== undefined) pts.push(out.regularite);
      pts.push(clamp100(100 - Math.max(0, out.maxLose - 2) * 18));
      out.score = Math.round(pts.reduce(function (s, x) { return s + x; }, 0) / pts.length);

      return out;
    }

    function mentalTile(nom, valeur, unite, verdict, note) {
      var labels = { good: "Bon", warn: "À travailler", bad: "Point faible", na: "-" };
      var vide = valeur === null || valeur === undefined || (typeof valeur === "number" && isNaN(valeur));
      var texte = vide
        ? "-"
        : (typeof valeur === "number" ? (Math.round(valeur * 10) / 10).toLocaleString("fr-FR") : esc(valeur));
      if (vide) unite = "";
      var flou = LP_IS_SUBSCRIBER ? "" : " lp-blur-val";

      return (
        '<div class="lp-scan">' +
        '<span class="lp-scan__name">' + esc(nom) + "</span>" +
        '<span class="lp-scan__value' + flou + '">' + texte + (unite ? "<small>" + unite + "</small>" : "") + "</span>" +
        '<span class="lp-scan__verdict is-' + verdict + flou + '">' + labels[verdict] + "</span>" +
        (note ? '<span class="lp-scan__trend is-flat' + flou + '">' + esc(note) + "</span>" : "") +
        "</div>"
      );
    }

    function renderMental(games) {
      var grid = document.getElementById("lpMentalGrid");
      if (!grid) return;
      var m = computeMental(games);

      if (!m.assez) {
        grid.innerHTML = state.mode !== "auto" && MAJ_ENDPOINT
          ? '<div class="lp-reco-empty" style="grid-column:1/-1;">Le mental se lit game par game, dans le suivi de stats' +
            (LP_IS_SUBSCRIBER ? "" : " des élèves") + ".</div>"
          : '<div class="lp-reco-empty" style="grid-column:1/-1;">Il faut au moins ' + MENTAL_MIN +
            " games enregistrées pour lire quoi que ce soit dans tes séries.</div>";
        renderScoreCard(document.getElementById("lpMentalScoreCard"), "Score mental", null);
        renderRythme(null);
        return;
      }

      function vPct(x, bon, moyen) {
        if (x === null || x === undefined) return "na";
        return x >= bon ? "good" : x >= moyen ? "warn" : "bad";
      }
      function vInv(x, bon, moyen) {
        if (x === null || x === undefined) return "na";
        return x <= bon ? "good" : x <= moyen ? "warn" : "bad";
      }

      var html = "";
      html += mentalTile("Winrate après une victoire", m.apresWin === null ? null : Math.round(m.apresWin), " %", vPct(m.apresWin, 52, 46));
      html += mentalTile("Winrate après une défaite", m.apresLose === null ? null : Math.round(m.apresLose), " %", vPct(m.apresLose, 50, 44));
      html += mentalTile("Écart de tilt", m.tilt === null ? null : Math.round(m.tilt), " pts", vInv(m.tilt, 5, 15), "victoire vs défaite");
      html += mentalTile("Winrate après 2 défaites", m.apres2Lose === null ? null : Math.round(m.apres2Lose), " %", vPct(m.apres2Lose, 48, 40));
      html += mentalTile("Plus longue série de défaites", m.maxLose, " games", vInv(m.maxLose, 3, 4));
      html += mentalTile("Plus longue série de victoires", m.maxWin, " games", m.maxWin >= 4 ? "good" : m.maxWin >= 3 ? "warn" : "bad");
      html += mentalTile("Games passées en losestreak", Math.round(m.serieLose), " %", vInv(m.serieLose, 15, 30), "séries de 3+");
      html += mentalTile("Régularité des performances", m.regularite === null || m.regularite === undefined ? null : m.regularite, " /100", vPct(m.regularite, 65, 45), "écart-type sur tes games");
      grid.innerHTML = html;

      var verdict = m.score >= 75 ? "Solide" : m.score >= 55 ? "Correct" : m.score >= 35 ? "Fragile" : "À reconstruire";
      renderScoreCard(document.getElementById("lpMentalScoreCard"), "Score mental", m.score, verdict,
        "Résistance au tilt, séries subies et régularité.");

      renderRythme(m);
    }

    /* Rythme conseillé : trois régimes, choisis sur ce que disent les séries.
       Plus le tilt coûte cher, plus la session est courte.

       Non-élèves : la quantité et tout le raisonnement sont floutés, mais la
       forme reste, on voit qu'une prescription existe, pas laquelle. */
    function renderRythme(m) {
      var ry = document.getElementById("lpMentalRythme");
      if (!ry) return;
      ry.style.display = "";

      var qte, unite, tag, pourquoi, regle;

      if (!m || !m.assez) {
        if (LP_IS_SUBSCRIBER) {
          ry.innerHTML = '<p class="lp-rythme__why" style="margin:0;">Ton rythme se calcule à partir de ' +
            MENTAL_MIN + " games enregistrées.</p>";
          return;
        }
        qte = "2"; unite = "games par jour"; tag = "Session courte";
        pourquoi = "Ton rythme est calculé sur tes séries de victoires et de défaites.";
        regle = "Une règle d'arrêt claire, adaptée à ta résistance au tilt.";
      } else {
        var dur = (m.tilt !== null && m.tilt >= 18) || m.serieLose >= 30 || m.maxLose >= 5;
        var moyen = !dur && ((m.tilt !== null && m.tilt >= 8) || m.serieLose >= 18 || m.maxLose >= 4);

        if (dur) {
          qte = "2"; unite = "games par jour"; tag = "Session courte";
          pourquoi = "Tes défaites s'enchaînent : " + Math.round(m.serieLose) +
            " % de tes games se jouent dans une série de 3 défaites ou plus" +
            (m.tilt !== null ? ", et tu perds " + Math.round(m.tilt) + " points de winrate après une défaite" : "") + ".";
          regle = "Tu arrêtes à la deuxième défaite, même si tu as le temps.";
        } else if (moyen) {
          qte = "1"; unite = "Bo3 par jour"; tag = "Session mesurée";
          pourquoi = "Tu encaisses une défaite mais la deuxième te coûte. Trois games suffisent à faire une journée.";
          regle = "Tu arrêtes à 2 victoires ou à 2 défaites.";
        } else {
          qte = "1"; unite = "Bo5 par jour"; tag = "Session longue";
          pourquoi = "Tes résultats ne s'effondrent pas après une défaite : tu peux tenir des sessions plus longues sans te brûler.";
          regle = "Tu arrêtes à 3 victoires ou à 3 défaites.";
        }
      }

      /* Pour un visiteur, l'unité affichée est toujours la même : la révéler
         reviendrait à donner la recommandation. */
      if (!LP_IS_SUBSCRIBER) unite = "games par jour";
      var flou = LP_IS_SUBSCRIBER ? "" : "lp-blur-val";

      ry.innerHTML =
        '<div class="lp-rythme">' +
        '<span class="lp-rythme__value"><span class="' + flou + '">' + esc(qte) + "</span> " + esc(unite) + "</span>" +
        '<span class="lp-rythme__tag ' + flou + '">' + esc(tag) + "</span>" +
        '<p class="lp-rythme__why"><span class="' + flou + '">' + esc(pourquoi) + "</span></p>" +
        '<div class="lp-rythme__rule"><span class="' + flou + '">' + esc(regle) + "</span></div>" +
        "</div>";
    }

    /* Renvoi vers la masterclass de psychologie. */
    (function () {
      var btn = document.getElementById("lpMentalPsycho");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var card = findCardFor({ t: "La psychologie dans l'e-sport", id: "350be0ef-24fa-439e-8e5b-322fabca15f9" });
        if (!card) return;
        if (card.dataset.locked === "true") {
          if (window.lpOpenLockModal) window.lpOpenLockModal();
          return;
        }
        goToCard(card);
      });
    })();

    /* ---------------- Rendus ---------------- */

    function renderLineChart(el, points) {
      if (!el) return;
      if (!points || points.length < 2) {
        el.innerHTML = '<div class="lp-hero__chart-empty">Ta courbe se construit game après game.</div>';
        return;
      }

      var W = 600, H = 190, PADL = 10, PADR = 10, PADT = 12, PADB = 26;
      var min = Infinity, max = -Infinity;
      points.forEach(function (p) { min = Math.min(min, p.s); max = Math.max(max, p.s); });
      if (max - min < 40) { var mid = (max + min) / 2; min = mid - 20; max = mid + 20; }

      var t0 = points[0].t, t1 = points[points.length - 1].t;
      var span = Math.max(1, t1 - t0);

      function x(p) { return PADL + ((p.t - t0) / span) * (W - PADL - PADR); }
      function y(v) { return H - PADB - ((v - min) / (max - min)) * (H - PADT - PADB); }

      var d = "";
      points.forEach(function (p, i) {
        d += (i === 0 ? "M" : "L") + x(p).toFixed(1) + "," + y(p.s).toFixed(1);
      });

      var area = d + "L" + x(points[points.length - 1]).toFixed(1) + "," + (H - PADB) + "L" + x(points[0]).toFixed(1) + "," + (H - PADB) + "Z";

      // Grille horizontale discrète (façon Finary)
      var grid = "";
      [0.25, 0.5, 0.75].forEach(function (f) {
        var gy = (PADT + (H - PADT - PADB) * f).toFixed(1);
        grid += '<line x1="' + PADL + '" y1="' + gy + '" x2="' + (W - PADR) + '" y2="' + gy + '" stroke="rgba(255,255,255,0.06)" stroke-dasharray="3 5"></line>';
      });

      // Dates aux extrémités (et au centre si la période le permet)
      function fmtD(t) {
        var dte = new Date(t);
        return ("0" + dte.getDate()).slice(-2) + "/" + ("0" + (dte.getMonth() + 1)).slice(-2);
      }
      var labels =
        '<text x="' + PADL + '" y="' + (H - 8) + '" font-size="10.5" fill="rgba(244,244,241,0.42)" font-family="inherit">' + fmtD(t0) + "</text>" +
        '<text x="' + (W - PADR) + '" y="' + (H - 8) + '" text-anchor="end" font-size="10.5" fill="rgba(244,244,241,0.42)" font-family="inherit">' + fmtD(t1) + "</text>";
      if (t1 - t0 > 3 * 24 * 3600 * 1000) {
        labels += '<text x="' + (W / 2) + '" y="' + (H - 8) + '" text-anchor="middle" font-size="10.5" fill="rgba(244,244,241,0.42)" font-family="inherit">' + fmtD((t0 + t1) / 2) + "</text>";
      }

      el.innerHTML =
        '<svg viewBox="0 0 ' + W + " " + H + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Courbe de progression">' +
        "<defs>" +
        '<linearGradient id="lpHeroGrad" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="#f0a32e" stop-opacity="0.22"></stop>' +
        '<stop offset="1" stop-color="#f0a32e" stop-opacity="0"></stop>' +
        "</linearGradient>" +
        "</defs>" +
        grid +
        '<path d="' + area + '" fill="url(#lpHeroGrad)"></path>' +
        '<path d="' + d + '" fill="none" stroke="#f0a32e" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"></path>' +
        labels +
        "</svg>";
    }

    function renderAlloc(byChampion, totalGames) {
      var donut = document.getElementById("lpAllocDonut");
      var legend = document.getElementById("lpAllocLegend");
      if (!donut || !legend) return;

      var entries = Object.keys(byChampion || {}).map(function (name) {
        return { name: name, games: byChampion[name].games };
      }).sort(function (a, b) { return b.games - a.games; }).slice(0, 6);

      var counted = entries.reduce(function (a, e) { return a + e.games; }, 0);

      var carte = donut.closest ? donut.closest(".lp-alloc") : null;
      var masquer = (!entries.length || !counted) && state.mode !== "auto" && !!MAJ_ENDPOINT;
      if (carte) carte.style.display = masquer ? "none" : "";
      ajusteColonne();
      if (masquer) return;

      if (!entries.length || !counted) {
        donut.innerHTML = "";
        legend.innerHTML = '<div class="lp-alloc__row">Renseigne ton champion sur tes games pour voir ton pool ici.</div>';
        return;
      }

      var C = 2 * Math.PI * 15.9;
      var offset = 0;
      var circles = "";
      var rows = "";

      entries.forEach(function (e, i) {
        var pct = (e.games / counted) * 100;
        var color = CHAMP_COLORS[i % CHAMP_COLORS.length];
        var dash = (pct / 100) * C;
        circles +=
          '<circle cx="21" cy="21" r="15.9" fill="none" stroke="' + color + '" stroke-width="6" ' +
          'stroke-dasharray="' + dash.toFixed(2) + " " + (C - dash).toFixed(2) + '" stroke-dashoffset="' + (-offset).toFixed(2) + '"></circle>';
        offset += dash;
        rows +=
          '<div class="lp-alloc__row"><i style="background:' + color + '"></i> ' +
          esc(e.name) + " <strong>" + Math.round(pct) + " %</strong></div>";
      });

      donut.innerHTML =
        '<svg viewBox="0 0 42 42">' + circles + "</svg>" +
        '<div class="lp-alloc__center"><strong>' + counted + "</strong><span>parties</span></div>";
      legend.innerHTML = rows;
    }

    function scanTile(name, value, unit, verdict, trend, trente) {
      var labels = { good: "Bon", warn: "À travailler", bad: "Point faible", na: "-" };
      var empty = value === null || value === undefined || (typeof value === "number" && isNaN(value));
      if (empty) unit = "";
      var display = empty
        ? "-"
        : (typeof value === "number" ? (Math.round(value * 100) / 100).toLocaleString("fr-FR") : esc(value));

      var trendHtml = "";
      if (trend || trente) {
        var tLabels = { up: "▲ En hausse", down: "▼ En baisse", flat: "- Stable" };
        /* Une tendance ne dit pas quoi corriger, elle dit seulement que le
           suivi fonctionne. La laisser lisible coûte peu et rend le tableau
           crédible auprès de qui ne s'est pas encore abonné. */
        var morceaux = [];
        if (trend) morceaux.push(tLabels[trend]);
        if (trente) morceaux.push(trente);
        trendHtml = '<span class="lp-scan__trend is-' + (trend || "flat") + '">' + morceaux.join(" · ") + "</span>";
      }

      return (
        '<div class="lp-scan">' +
        '<span class="lp-scan__name">' + esc(name) + "</span>" +
        '<span class="lp-scan__value">' + display + (unit ? "<small>" + unit + "</small>" : "") + "</span>" +
        '<span class="lp-scan__verdict is-' + verdict + '">' + labels[verdict] + "</span>" +
        trendHtml +
        "</div>"
      );
    }

    function renderScans(metrics, role, winrate, trends, trente) {
      var grid = document.getElementById("lpScanGrid");
      if (!grid) return;
      trends = trends || {};
      trente = trente || {};

      function sur30(v, dec, unite) {
        if (typeof v !== "number" || !isFinite(v)) return "";
        var p = Math.pow(10, dec);
        return (Math.round(v * p) / p).toLocaleString("fr-FR") + (unite || "") + " sur 30 j";
      }

      var html = "";
      html += scanTile("Winrate", winrate === null || winrate === undefined ? null : Math.round(winrate), " %",
        winrate === null || winrate === undefined ? "na" : winrate >= 52 ? "good" : winrate >= 48 ? "warn" : "bad", trends.winrate, sur30(trente.winrate, 0, " %"));
      html += scanTile("CS / min", metrics ? metrics.csMin : null, "", verdictFor("csMin", metrics ? metrics.csMin : null, role), trends.csMin, sur30(trente.csMin, 1));
      html += scanTile("KDA", metrics ? metrics.kda : null, "", verdictFor("kda", metrics ? metrics.kda : null, role), trends.kda, sur30(trente.kda, 1));
      html += scanTile("KP", metrics && metrics.kp !== null && metrics.kp !== undefined ? Math.round(metrics.kp) : null, " %", verdictFor("kp", metrics ? metrics.kp : null, role), trends.kp, sur30(trente.kp, 0, " %"));
      html += scanTile("Dégâts / min", metrics && metrics.dpm !== null && metrics.dpm !== undefined ? Math.round(metrics.dpm) : null, "", verdictFor("dpm", metrics ? metrics.dpm : null, role), trends.dpm, sur30(trente.dpm, 0));
      html += scanTile("Golds / min", metrics && metrics.gpm !== null && metrics.gpm !== undefined ? Math.round(metrics.gpm) : null, "", verdictFor("gpm", metrics ? metrics.gpm : null, role), trends.gpm, sur30(trente.gpm, 0));
      html += scanTile("Wins early game", metrics && metrics.early !== null && metrics.early !== undefined ? Math.round(metrics.early) : null, " %", verdictFor("early", metrics ? metrics.early : null, role), trends.early, sur30(trente.early, 0, " %"));
      grid.innerHTML = html;
    }

    function renderPerf(byChampion) {
      var row = document.getElementById("lpPerfRow");
      var block = document.getElementById("lpPerfBlock");
      if (!row) return;

      var entries = Object.keys(byChampion || {}).map(function (name) {
        var c = byChampion[name];
        return {
          name: name,
          games: c.games,
          wr: c.games ? (c.wins / c.games) * 100 : 0,
          kda: c.d > 0 ? (c.k + c.a) / c.d : c.k + c.a,
          results: c.results.slice(-10)
        };
      }).sort(function (a, b) { return b.games - a.games; }).slice(0, 6);

      if (!entries.length) {
        if (block) block.style.display = "none";
        return;
      }
      if (block) block.style.display = "";

      row.innerHTML = entries.map(function (e) {
        var bars = e.results.map(function (r, i) {
          var color = r ? "#2ecc80" : "#f26d6d";
          return '<rect x="' + i * 10 + '" y="' + (r ? 4 : 12) + '" width="7" height="' + (r ? 22 : 14) + '" rx="2" fill="' + color + '" opacity="0.85"></rect>';
        }).join("");

        return (
          '<div class="lp-perf">' +
          '<div class="lp-perf__head">' +
          '<span class="lp-perf__icon"><img src="https://cdn.communitydragon.org/latest/champion/' + encodeURIComponent(e.name) + '/square" alt="" loading="lazy" onerror="this.style.display=\'none\'"></span>' +
          "<span><span class=\"lp-perf__name\">" + esc(e.name) + '</span><br><span class="lp-perf__games">' + e.games + " parties</span></span>" +
          "</div>" +
          '<div class="lp-perf__stats">' +
          '<span class="lp-perf__wr ' + (e.wr >= 50 ? "is-pos" : "is-neg") + '">' + Math.round(e.wr) + " %</span>" +
          '<span class="lp-perf__kda">' + (Math.round(e.kda * 10) / 10).toLocaleString("fr-FR") + " KDA</span>" +
          "</div>" +
          '<div class="lp-perf__spark"><svg viewBox="0 0 100 30" preserveAspectRatio="xMinYMid meet">' + bars + "</svg></div>" +
          "</div>"
        );
      }).join("");
    }

    /* ---------------- Historique + héro ---------------- */

    function pushHistory(score) {
      if (score === null) return;
      var hist = readJson(K_HISTORY, []);
      var last = hist[hist.length - 1];
      var now = Date.now();
      if (last && last.s === score) return;
      hist.push({ t: now, s: score });
      if (hist.length > 300) hist = hist.slice(hist.length - 300);
      writeJson(K_HISTORY, hist);
    }

    function setRankText(el, score) {
      var r = scoreToRank(score);
      el.innerHTML = esc(formatRank(r.tier, r.div, r.lp)) + " <small>· " + r.lp + " LP</small>";
    }

    // Compteur de rank à l'arrivée : les LP et paliers défilent jusqu'à la
    // valeur réelle (une seule fois par chargement de page).
    var heroAnimated = false;
    var heroAnimation = null;

    function animateRank(el, target) {
      // Une animation encore en cours n'a plus rien à écrire.
      if (heroAnimation) heroAnimation.fini = true;
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce || target <= 0 || document.hidden) {
        setRankText(el, target);
        return;
      }
      var etat = { fini: false };
      heroAnimation = etat;
      var start = performance.now();
      var dur = 1400;
      function frame(now) {
        if (etat.fini) return;
        var t = Math.min(1, (now - start) / dur);
        var e = 1 - Math.pow(1 - t, 3);
        setRankText(el, Math.round(target * e));
        if (t < 1) {
          requestAnimationFrame(frame);
        } else {
          etat.fini = true;
        }
      }
      requestAnimationFrame(frame);
      // Filet : si l'onglet est mis en arrière-plan pendant l'animation,
      // requestAnimationFrame s'arrête, on force la valeur finale.
      setTimeout(function () {
        if (!etat.fini) {
          etat.fini = true;
          setRankText(el, target);
        }
      }, dur + 300);
    }

    function renderHero(score) {
      var dateEl = document.getElementById("lpHeroDate");
      var valueEl = document.getElementById("lpHeroValue");
      var deltaEl = document.getElementById("lpHeroDelta");
      var chartEl = document.getElementById("lpHeroChart");
      var chip = document.getElementById("lpRiotChip");
      var chipName = document.getElementById("lpRiotChipName");

      if (dateEl) {
        dateEl.textContent = new Date().toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
      }

      if (valueEl) {
        if (score !== null) {
          if (!heroAnimated) {
            heroAnimated = true;
            animateRank(valueEl, score);
          } else {
            if (heroAnimation) heroAnimation.fini = true;
            setRankText(valueEl, score);
          }
        } else {
          valueEl.textContent = "Non classé";
        }
      }

      if (chip && chipName) {
        chip.classList.remove("is-live", "is-demo");
        if (state.mode === "auto") {
          var n = currentGames().length;
          if (state.synced) {
            chip.classList.add("is-live");
            chipName.textContent = "Synchronisé · " + n + " game" + (n > 1 ? "s" : "");
          } else {
            chipName.textContent = "Suivi de stats";
          }
        } else {
          var compte = MAJ_ENDPOINT ? lireRiot() : null;
          chipName.textContent = compte ? compte.nom + "#" + compte.tag : "Mes stats";
        }
      }

      var hist = readJson(K_HISTORY, []);
      renderLineChart(chartEl, hist);

      if (deltaEl) {
        var month = Date.now() - 30 * 24 * 3600 * 1000;
        var recent = hist.filter(function (p) { return p.t >= month; });
        deltaEl.classList.remove("is-down", "is-flat");
        if (recent.length >= 2) {
          var diff = recent[recent.length - 1].s - recent[0].s;
          if (diff > 0) {
            deltaEl.textContent = "▲ +" + diff + " LP sur 30 jours";
          } else if (diff < 0) {
            deltaEl.classList.add("is-down");
            deltaEl.textContent = "▼ " + diff + " LP sur 30 jours";
          } else {
            deltaEl.classList.add("is-flat");
            deltaEl.textContent = "Stable sur 30 jours";
          }
        } else {
          deltaEl.classList.add("is-flat");
          deltaEl.textContent = score === null ? "Règle ton rank pour commencer" : "";
        }
      }
    }

    /* ---------------- Rendu global ---------------- */

    var connectEl = document.getElementById("lpSynthConnect");
    var dashEl = document.getElementById("lpSynthDash");
    var connectStatus = document.getElementById("lpSynthConnectStatus");
    var settingsPanel = document.getElementById("lpSettingsPanel");
    var gameModal = document.getElementById("lpGameModal");
    var gameModalOpenBtn = document.getElementById("lpGameModalOpen");

    function openGameModal() {
      if (!gameModal) return;
      gameModal.classList.add("is-open");
      gameModal.setAttribute("aria-hidden", "false");
    }

    window.lpCloseGameModal = function () {
      if (!gameModal) return;
      gameModal.classList.remove("is-open");
      gameModal.setAttribute("aria-hidden", "true");
    };

    if (gameModalOpenBtn) gameModalOpenBtn.addEventListener("click", openGameModal);
    if (gameModal) {
      var gameModalClose = document.getElementById("lpGameModalClose");
      if (gameModalClose) gameModalClose.addEventListener("click", window.lpCloseGameModal);
      gameModal.addEventListener("click", function (e) {
        if (e.target === gameModal) window.lpCloseGameModal();
      });
    }

    function showConnect() {
      if (connectEl) connectEl.style.display = "";
      if (dashEl) dashEl.style.display = "none";
    }

    function showDash() {
      if (connectEl) connectEl.style.display = "none";
      if (dashEl) dashEl.style.display = "";
    }

    function renderAll() {
      showDash();

      var games = currentGames();
      var recentMetrics = computeMetrics(games);
      var metrics;
      /* Hors suivi de stats, après une mise à jour : les moyennes affichées
         sont celles de la saison relevée, et elles seules. Le point de
         départ reste la référence des tendances. */
      var saison = saisonReleve();
      if (saison) {
        metrics = combineWithBaseline(computeMetrics([]), saison);
        metrics.byChampion = recentMetrics.byChampion;
        metrics.results = recentMetrics.results;
        recentMetrics = metrics;
      } else {
        metrics = combineWithBaseline(recentMetrics);
      }
      var trends = computeTrends(recentMetrics);
      var winrate = metrics.games > 0 ? (metrics.wins / metrics.games) * 100 : null;
      var score = currentScore();
      if (score !== null) pushHistory(score);

      renderHero(score);
      renderStreak();
      renderAlloc(metrics.byChampion, metrics.games);
      renderScans(metrics, state.role, winrate, trends, stats30(games));

      var perfScore = computePerfScore(metrics, state.role, winrate);
      var perfVerdict = perfScore === null ? "" : perfScore >= 75 ? "Solide" : perfScore >= 55 ? "Correct" : perfScore >= 35 ? "Irrégulier" : "En difficulté";
      /* Seule carte ouverte aux non-élèves : le diagnostic global. */
      renderScoreCardOuverte(document.getElementById("lpPerfScoreCard"), "Scanner de performance", perfScore, perfVerdict,
        "Basé sur tes moyennes et ta régularité.");

      renderPerf(metrics.byChampion);

      var pool = computePoolScore(metrics.byChampion);
      if (!pool) {
        renderScoreCard(document.getElementById("lpPoolScoreCard"), "Cohérence du pool", null);
      } else {
        var poolVerdict = pool.score >= 85 ? "Très cohérent" : pool.score >= 65 ? "Cohérent" : pool.score >= 45 ? "À resserrer" : "Trop dispersé";
        var why;
        if (!pool.mainReason) {
          why = "Pool idéal : 2 champions, même style, même lane.";
        } else if (LP_IS_SUBSCRIBER) {
          why = "Raison principale : <strong>" + esc(pool.mainReason) + "</strong>";
        } else {
          why = 'Raison principale : <strong class="lp-blur-val">' + esc(pool.mainReason) + "</strong>";
        }
        renderScoreCard(document.getElementById("lpPoolScoreCard"), "Cohérence du pool", pool.score, poolVerdict, why);
      }

      renderObjectifs(metrics, state.role, games);
      renderPlanMc(metrics, state.role, games);
      renderRecos(metrics, state.role, winrate);
      renderMental(games);
      renderDepuisLeDebut(recentMetrics);

      // Modes : en auto les games viennent du suivi, pas de saisie
      var isAuto = state.mode === "auto";
      var quickWin = document.getElementById("lpQuickWin");
      var quickLose = document.getElementById("lpQuickLose");
      var syncBtn = document.getElementById("lpSyncRefresh");
      // Saisie à la main : seulement si le relais n'est pas branché.
      var saisie = !isAuto && !MAJ_ENDPOINT;
      if (quickWin) quickWin.style.display = saisie ? "" : "none";
      if (quickLose) quickLose.style.display = saisie ? "" : "none";
      if (syncBtn) syncBtn.style.display = isAuto && !MAJ_ENDPOINT ? "" : "none";
      if (gameModalOpenBtn) gameModalOpenBtn.style.display = saisie ? "" : "none";
      var majBtn = document.getElementById("lpMajBtn");
      if (majBtn) majBtn.style.display = MAJ_ENDPOINT ? "" : "none";

      var meta = document.getElementById("lpGameMeta");
      if (meta && isAuto) meta.textContent = MAJ_ENDPOINT ? majDerniere() : "";
      if (meta && !isAuto && !saisie) meta.textContent = majDerniere();
      if (meta && saisie) {
        var n = state.manualGames.length;
        meta.innerHTML = n === 0
          ? "Aucune game enregistrée."
          : n + " game" + (n > 1 ? "s" : "") + " enregistrée" + (n > 1 ? "s" : "") +
            ' · <button type="button" id="lpGameUndo">annuler la dernière</button>';
        var undo = document.getElementById("lpGameUndo");
        if (undo) {
          undo.addEventListener("click", function () {
            state.manualGames.pop();
            writeJson(K_GAMES, state.manualGames);
            renderAll();
          });
        }
      }

      // Mémo pour le calculateur
      if (score !== null) {
        var r = scoreToRank(score);
        writeJson("lp_synth_last_rank_v1", { tier: r.tier, rank: r.div, lp: r.lp, winrate: winrate, t: Date.now() });
      }
    }

    /* Progression depuis le tout premier relevé : LP gagnés, et la stat qui
       a le plus bougé par rapport au point de départ. */
    function renderDepuisLeDebut(recent) {
      var el = document.getElementById("lpHeroSince");
      if (!el) return;

      var hist = readJson(K_HISTORY, []);
      var bouts = [];

      if (hist.length >= 2) {
        var jours = (hist[hist.length - 1].t - hist[0].t) / 86400000;
        var diff = hist[hist.length - 1].s - hist[0].s;
        if (jours >= 2 && diff !== 0) {
          bouts.push('<span class="lp-since__item ' + (diff > 0 ? "is-pos" : "is-neg") + '">' + (diff > 0 ? "+" : "") + diff + " LP</span>");
        }
      }

      var b = state.baseline;
      if (b && b.games) {
        var champs = [
          ["cs", recent.csMin, "CS/min", 1],
          ["kda", recent.kda, "KDA", 1],
          ["kp", recent.kp, "KP", 0],
          ["dpm", recent.dpm, "dégâts/min", 0],
          ["gpm", recent.gpm, "golds/min", 0]
        ];
        var best = null;
        champs.forEach(function (c) {
          var av = b[c[0]], ap = c[1];
          if (av === null || av === undefined || ap === null || ap === undefined || av <= 0) return;
          var gain = (ap - av) / av;
          if (gain > 0.04 && (!best || gain > best.gain)) {
            best = { gain: gain, libelle: c[2], av: av, ap: ap, dec: c[3] };
          }
        });
        if (best) {
          bouts.push('<span class="lp-since__item is-pos">' + esc(best.libelle) + " " +
            best.av.toFixed(best.dec).replace(".", ",") + " → " +
            best.ap.toFixed(best.dec).replace(".", ",") + "</span>");
        }
      }

      if (!bouts.length) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      el.innerHTML = "<span>Depuis ton premier jour</span>" + bouts.join("");
    }

    /* ---------------- Réglages ---------------- */

    /* ---------------- Point de départ (popup) ---------------- */

    var baselineModal = document.getElementById("lpBaselineModal");

    function updateBaselineSummary() {
      var el = document.getElementById("lpBaselineSummary");
      if (!el) return;
      var b = state.baseline;
      if (!b || !b.games) {
        el.textContent = "Pas encore renseigné.";
        return;
      }
      var parts = [b.games + " games"];
      if (b.wr !== null && b.wr !== undefined) parts.push(Math.round(b.wr) + " % WR");
      if (b.cs !== null && b.cs !== undefined) parts.push(b.cs + " CS/min");
      if (b.kda !== null && b.kda !== undefined) parts.push(b.kda + " KDA");
      el.textContent = parts.join(" · ");
    }

    function openBaselineModal() {
      if (!baselineModal) return;
      var b = state.baseline || {};
      function set(id, v) {
        var el = document.getElementById(id);
        if (el) el.value = v === null || v === undefined ? "" : v;
      }
      set("lpBaseGames", b.games);
      set("lpBaseWr", b.wr);
      set("lpBaseCs", b.cs);
      set("lpBaseKda", b.kda);
      set("lpBaseKp", b.kp);
      set("lpBaseDpm", b.dpm);
      set("lpBaseGpm", b.gpm);
      set("lpBaseEarly", b.early);
      baselineModal.classList.add("is-open");
      baselineModal.setAttribute("aria-hidden", "false");
    }

    window.lpCloseBaselineModal = function () {
      if (!baselineModal) return;
      baselineModal.classList.remove("is-open");
      baselineModal.setAttribute("aria-hidden", "true");
    };

    if (baselineModal) {
      var baselineClose = document.getElementById("lpBaselineModalClose");
      if (baselineClose) baselineClose.addEventListener("click", window.lpCloseBaselineModal);
      baselineModal.addEventListener("click", function (e) {
        if (e.target === baselineModal) window.lpCloseBaselineModal();
      });

      var baselineSkip = document.getElementById("lpBaselineSkip");
      if (baselineSkip) {
        baselineSkip.addEventListener("click", function () {
          window.lpCloseBaselineModal();
          if (!state.base) openSettings();
        });
      }

      var baselineSave = document.getElementById("lpBaselineSave");
      if (baselineSave) {
        baselineSave.addEventListener("click", function () {
          function num(id) {
            var v = parseFloat((document.getElementById(id) || {}).value);
            return isNaN(v) ? null : v;
          }
          var bGames = parseInt((document.getElementById("lpBaseGames") || {}).value, 10);
          if (bGames > 0) {
            state.baseline = {
              games: bGames,
              wr: num("lpBaseWr"),
              cs: num("lpBaseCs"),
              kda: num("lpBaseKda"),
              kp: num("lpBaseKp"),
              dpm: num("lpBaseDpm"),
              gpm: num("lpBaseGpm"),
              early: num("lpBaseEarly")
            };
          } else {
            state.baseline = null;
          }
          writeJson(K_BASELINE, state.baseline);
          window.lpCloseBaselineModal();
          updateBaselineSummary();
          renderAll();
          if (!state.base) openSettings();
        });
      }
    }

    var baselineOpenBtn = document.getElementById("lpBaselineOpenBtn");
    if (baselineOpenBtn) baselineOpenBtn.addEventListener("click", openBaselineModal);

    var NO_DIV = ["MASTER", "GRANDMASTER", "CHALLENGER"];

    function syncSetDiv() {
      var tierEl = document.getElementById("lpSetTier");
      var divEl = document.getElementById("lpSetDiv");
      if (!tierEl || !divEl) return;
      var hidden = NO_DIV.indexOf(tierEl.value) >= 0;
      divEl.disabled = hidden;
      divEl.style.opacity = hidden ? "0.4" : "";
    }

    function openSettings() {
      if (!settingsPanel) return;
      // Pré-remplir avec l'état courant
      function set(id, v) {
        var el = document.getElementById(id);
        if (el && v !== null && v !== undefined) el.value = v;
      }
      var score = currentScore();
      if (score !== null) {
        var r = scoreToRank(score);
        set("lpSetTier", r.tier);
        if (r.div) set("lpSetDiv", r.div);
        set("lpSetLp", r.lp);
      } else if (state.base) {
        set("lpSetTier", state.base.tier);
        set("lpSetDiv", state.base.div);
        set("lpSetLp", state.base.lp);
      }
      set("lpSetRole", state.role);
      set("lpSetGain", state.mmr.gain);
      set("lpSetLoss", state.mmr.loss);
      var compte = MAJ_ENDPOINT ? lireRiot() : null;
      var riotBloc = document.getElementById("lpSetRiotBloc");
      if (riotBloc) riotBloc.hidden = !MAJ_ENDPOINT;
      if (compte) {
        set("lpSetRiot", compte.nom);
        set("lpSetRiotTag", compte.tag);
        set("lpSetRiotRegion", compte.region || "euw");
      }
      /* Tout vient de l'API hors suivi de stats : ni rank, ni LP par game, ni
         moyennes à saisir. Les champs ne réapparaissent que si la
         récupération échoue, comme filet. */
      var viaApi = !!MAJ_ENDPOINT && state.mode !== "auto" && !majEchec;
      var rankAuto = viaApi || !!(compte && compte.rangLu);
      [["lpSetTier", rankAuto], ["lpSetDiv", rankAuto], ["lpSetLp", rankAuto],
       ["lpSetGain", rankAuto], ["lpSetLoss", rankAuto]].forEach(function (x) {
        var el = document.getElementById(x[0]);
        var champ = el && el.closest ? el.closest(".lp-tool-field") : null;
        if (champ) champ.style.display = x[1] ? "none" : "";
      });
      var blocDepart = document.getElementById("lpBaselineOpenBtn");
      blocDepart = blocDepart && blocDepart.closest ? blocDepart.closest(".lp-settings-sep") : null;
      if (blocDepart) blocDepart.style.display = viaApi ? "none" : "";
      updateBaselineSummary();
      updateModeSwitch();
      syncSetDiv();

      settingsPanel.style.display = "";
      settingsPanel.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    var setTierEl = document.getElementById("lpSetTier");
    if (setTierEl) setTierEl.addEventListener("change", syncSetDiv);

    var setSave = document.getElementById("lpSetSave");
    if (setSave) {
      setSave.addEventListener("click", function () {
        var gain = parseInt((document.getElementById("lpSetGain") || {}).value, 10);
        var loss = parseInt((document.getElementById("lpSetLoss") || {}).value, 10);
        state.mmr = { gain: gain > 0 ? gain : 25, loss: loss > 0 ? loss : 20 };
        state.role = (document.getElementById("lpSetRole") || {}).value || "mid";
        state.base = {
          tier: (document.getElementById("lpSetTier") || {}).value || "GOLD",
          div: (document.getElementById("lpSetDiv") || {}).value || "IV",
          lp: parseInt((document.getElementById("lpSetLp") || {}).value, 10) || 0,
          anchor: currentGames().length
        };
        writeJson(K_MMR, state.mmr);
        writeJson(K_ROLE, state.role);
        writeJson(K_BASE, state.base);
        var riotBlocSave = document.getElementById("lpSetRiotBloc");
        if (riotBlocSave && !riotBlocSave.hidden) enregistrerRiot();
        if (settingsPanel) settingsPanel.style.display = "none";
        renderAll();
        if (majApresReglages) {
          majApresReglages = false;
          if (lireRiot()) majRiot();
        }
      });
    }

    var settingsBtn = document.getElementById("lpSettingsBtn");
    if (settingsBtn) settingsBtn.addEventListener("click", openSettings);
    var chipBtn = document.getElementById("lpRiotChip");
    if (chipBtn) chipBtn.addEventListener("click", openSettings);

    /* ---------------- Ajout de games (manuel) ---------------- */

    function addGame(game) {
      state.manualGames.push(game);
      writeJson(K_GAMES, state.manualGames);
      renderAll();
    }

    var quickWinBtn = document.getElementById("lpQuickWin");
    if (quickWinBtn) quickWinBtn.addEventListener("click", function () { addGame({ w: 1, t: Date.now() }); });
    var quickLoseBtn = document.getElementById("lpQuickLose");
    if (quickLoseBtn) quickLoseBtn.addEventListener("click", function () { addGame({ w: 0, t: Date.now() }); });

    var gameAdd = document.getElementById("lpGameAdd");
    if (gameAdd) {
      gameAdd.addEventListener("click", function () {
        function num(id) {
          var v = parseFloat((document.getElementById(id) || {}).value);
          return isNaN(v) ? null : v;
        }
        var earlyRaw = (document.getElementById("lpGameEarly") || {}).value;

        addGame({
          w: (document.getElementById("lpGameResult") || {}).value === "1" ? 1 : 0,
          champ: ((document.getElementById("lpGameChamp") || {}).value || "").trim() || null,
          cs: num("lpGameCs"),
          k: num("lpGameK"), d: num("lpGameD"), a: num("lpGameA"),
          kp: num("lpGameKp"),
          dpm: num("lpGameDpm"),
          gpm: num("lpGameGpm"),
          early: earlyRaw === "1" ? 1 : earlyRaw === "0" ? 0 : null,
          t: Date.now()
        });

        ["lpGameCs", "lpGameK", "lpGameD", "lpGameA", "lpGameKp", "lpGameDpm", "lpGameGpm"].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.value = "";
        });

        window.lpCloseGameModal();
      });
    }

    /* ---------------- Mettre à jour ----------------
       Passe par le relais Legends Tracker déjà en place (LP_TRACKER_ENDPOINT),
       avec la même clé partenaire. L'API donne le rank réel et les moyennes
       de la saison, pas le détail game par game.

       Hors suivi de stats : rank réel + moyennes de la saison, sans aucune
       saisie à la main (elle ne revient que si le relais est retiré).
       Suivi de stats (élèves) : les games viennent toujours du suivi, le
       bouton le resynchronise puis lit le rank réel. Les moyennes de saison
       ne s'y mélangent pas : le suivi a mieux, game par game. */

    var MAJ_ENDPOINT = (typeof LP_TRACKER_ENDPOINT === "string" && /^https:\/\//.test(LP_TRACKER_ENDPOINT)) ? LP_TRACKER_ENDPOINT : "";
    var MAJ_DELAI_MIN = 60 * 1000;   // le quota de l'API est partagé par tous les visiteurs
    var majEnCours = false;
    var majApresReglages = false;
    /* Dernière récupération en échec : les champs à remplir à la main
       reviennent alors dans les réglages, comme filet. */
    var majEchec = false;

    function lireRiot() {
      var compte = readJson(K_RIOT, null);
      if (compte && compte.nom && compte.tag) return compte;
      // Pas encore de mise à jour : le Riot ID donné dans le parcours d'entrée.
      try {
        var ob = JSON.parse(window.lpAccountStorage.getItem("lp_ob_v1") || "{}") || {};
        var nom = String(ob.riotName || "").trim();
        var tag = String(ob.riotTag || "").trim().replace(/^#/, "");
        if (nom && tag) return { nom: nom, tag: tag, region: ob.region || "euw" };
      } catch (e) {}
      return null;
    }

    function saisonReleve() {
      if (!MAJ_ENDPOINT || state.mode === "auto") return null;
      var sn = readJson(K_SAISON, null);
      return sn && sn.games > 0 ? sn : null;
    }

    function enregistrerRiot() {
      var nom = ((document.getElementById("lpSetRiot") || {}).value || "").trim();
      var tag = ((document.getElementById("lpSetRiotTag") || {}).value || "").trim().replace(/^#/, "");
      var region = (document.getElementById("lpSetRiotRegion") || {}).value || "euw";
      if (!nom || !tag) return;
      var actuel = lireRiot();
      if (actuel && actuel.nom.toLowerCase() === nom.toLowerCase() &&
          actuel.tag.toLowerCase() === tag.toLowerCase() && (actuel.region || "euw") === region) return;
      // Autre compte : ses chiffres remplaceront ceux de l'ancien à la prochaine mise à jour.
      writeJson(K_RIOT, { nom: nom, tag: tag, region: region });
    }

    function majMessage(texte) {
      var meta = document.getElementById("lpGameMeta");
      if (meta) meta.textContent = texte;
    }

    function majDerniere() {
      var compte = lireRiot();
      if (!compte || !compte.maj) return "";
      var d = new Date(compte.maj);
      return "À jour le " + d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" }) +
        " à " + d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
    }

    function majNombre(v) {
      var n = Number(v);
      return v !== null && v !== undefined && v !== "" && isFinite(n) ? n : null;
    }

    function nouvellesGames(n) {
      var s = n > 1 ? "s" : "";
      return n + " nouvelle" + s + " game" + s;
    }

    function ouvrirReglagesRiot() {
      majApresReglages = true;
      openSettings();
      var champ = document.getElementById("lpSetRiot");
      if (champ) setTimeout(function () { champ.focus(); }, 350);
    }

    /* Un appel au relais. suite({ statut, j }) ; statut 0 si injoignable. */
    function appelRelais(compte, suite) {
      var url = MAJ_ENDPOINT + "?nom=" + encodeURIComponent(compte.nom) +
        "&tag=" + encodeURIComponent(compte.tag) +
        "&region=" + encodeURIComponent(compte.region || "euw");
      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, 20000);

      fetch(url, { signal: ctrl.signal, credentials: "omit" })
        .then(function (r) {
          clearTimeout(timer);
          return r.json()
            .catch(function () { return {}; })
            .then(function (j) { suite({ statut: r.status, j: j || {} }); });
        })
        .catch(function () {
          clearTimeout(timer);
          suite({ statut: 0, j: {} });
        });
    }

    function messageErreurRelais(statut) {
      if (statut === 404) return "Riot ID introuvable, vérifie-le dans les réglages.";
      if (statut === 429) return "Trop de demandes, réessaie dans une minute.";
      return "Mise à jour indisponible pour le moment.";
    }

    /* Rank réel : remplace l'estimation, les games déjà là sont comptées
       dedans. Renvoie le nombre de games jouées depuis le relevé précédent,
       null si inconnu. */
    function appliqueRang(rg, compte) {
      var tier = rg ? String(rg.tier || "").toUpperCase() : "";
      if (TIERS.indexOf(tier) < 0) return { lu: false, nouvelles: null };

      var premiereLecture = !compte.rangLu;
      var estime = premiereLecture ? currentScore() : null;

      state.base = {
        tier: tier,
        div: TIERS.indexOf(tier) >= 7 ? "" : String(rg.div || "IV").toUpperCase(),
        lp: parseInt(rg.lp, 10) || 0,
        anchor: currentGames().length
      };
      writeJson(K_BASE, state.base);
      compte.rangLu = Date.now();

      /* Premier rank réel : la courbe tenue jusque-là reposait sur une
         estimation. On la décale d'un bloc sur le rank réel, pour que
         « depuis ton premier jour » et « sur 30 jours » ne comptent pas
         l'écart d'estimation comme une progression. */
      if (premiereLecture && estime !== null) {
        var ecart = lpScore(state.base.tier, state.base.div, state.base.lp) - estime;
        if (ecart) {
          var courbe = readJson(K_HISTORY, []);
          if (Array.isArray(courbe) && courbe.length) {
            courbe.forEach(function (p) { p.s = Math.max(0, p.s + ecart); });
            writeJson(K_HISTORY, courbe);
          }
        }
      }

      var nouvelles = null;
      var w = majNombre(rg.wins), l = majNombre(rg.losses);
      if (w !== null && l !== null) {
        if (typeof compte.wins === "number" && typeof compte.losses === "number") {
          nouvelles = Math.max(0, (w - compte.wins) + (l - compte.losses));
        }
        compte.wins = w;
        compte.losses = l;
      }
      return { lu: true, nouvelles: nouvelles };
    }

    function majRiot() {
      if (majEnCours || !MAJ_ENDPOINT) return;
      var auto = state.mode === "auto";
      var compte = lireRiot();

      if (!compte && !auto) return ouvrirReglagesRiot();
      var relaisRecent = !!(compte && compte.maj && Date.now() - compte.maj < MAJ_DELAI_MIN);
      if (!auto && relaisRecent) return majMessage("Déjà à jour.");

      var btn = document.getElementById("lpMajBtn");
      majEnCours = true;
      if (btn) {
        btn.disabled = true;
        btn.textContent = "Mise à jour…";
      }

      function fin(msg) {
        majEnCours = false;
        if (btn) {
          btn.disabled = false;
          btn.textContent = "Mettre à jour";
        }
        renderAll();
        majMessage(msg);
      }

      /* ---- Suivi de stats : le suivi d'abord, le rank ensuite ---- */
      if (auto) {
        var avant = currentGames().length;
        syncSheet(function (err) {
          lastSyncAt = Date.now();
          var n = err ? null : Math.max(0, currentGames().length - avant);
          var msgGames = err
            ? "Synchronisation impossible, vérifie que ton suivi est partagé par lien."
            : n > 0 ? nouvellesGames(n) + "." : "Déjà à jour.";

          if (!compte) {
            fin(msgGames);
            return ouvrirReglagesRiot();
          }
          if (relaisRecent) return fin(msgGames);

          appelRelais(compte, function (res) {
            if (res.statut === 200) {
              majEchec = false;
              appliqueRang(res.j.rang, compte);
              compte.maj = Date.now();
              writeJson(K_RIOT, compte);
              if (window.lpTrack) window.lpTrack("riot_maj", { mode: "suivi", nouvelles: n === null ? -1 : n });
              return fin(msgGames);
            }
            majEchec = true;
            fin(err ? msgGames : messageErreurRelais(res.statut));
          });
        });
        return;
      }

      /* ---- Saisie manuelle : rank + moyennes de la saison ---- */
      appelRelais(compte, function (res) {
        if (res.statut !== 200) {
          majEchec = true;
          return fin(messageErreurRelais(res.statut));
        }
        majEchec = false;

        var j = res.j;
        var st = j.stats || {};
        var aDesStats = majNombre(st.games) > 0;
        var cv = j.couverture || {};
        var enCours = !!cv.enCours;
        // On dit où en est Legends Tracker, chiffres à l'appui.
        var texteAttente = "Legends Tracker n'a pas encore tes parties" +
          (cv.saison ? " (" + (cv.stockees || 0) + " sur " + cv.saison + ")" : "") +
          ". On réessaie tout seul.";

        if (aDesStats) {
          writeJson(K_SAISON, {
            games: majNombre(st.games), wr: majNombre(st.wr), cs: majNombre(st.cs),
            kda: majNombre(st.kda), kp: majNombre(st.kp), dpm: dpmPlausible(majNombre(st.dpm)),
            gpm: majNombre(st.gpm), early: majNombre(st.early),
            t: Date.now()
          });
          noteReleveSaison(j);
          try { window.lpAccountStorage.removeItem("lp_stats_attente_v1"); } catch (e) {}

          /* Premier relevé : il sert aussi de point de départ, pour que la
             progression ait une référence sans rien saisir à la main. */
          if (!state.baseline || !state.baseline.games) {
            state.baseline = {
              games: majNombre(st.games), wr: majNombre(st.wr), cs: majNombre(st.cs),
              kda: majNombre(st.kda), kp: majNombre(st.kp), dpm: dpmPlausible(majNombre(st.dpm)),
              gpm: majNombre(st.gpm), early: majNombre(st.early)
            };
            writeJson(K_BASELINE, state.baseline);
          }
        }

        var rang = appliqueRang(j.rang, compte);

        if (!aDesStats && !rang.lu) {
          return fin(enCours ? texteAttente : "Aucune game classée trouvée sur ce compte.");
        }

        compte.maj = Date.now();
        writeJson(K_RIOT, compte);
        if (window.lpTrack) window.lpTrack("riot_maj", { mode: "manuel", nouvelles: rang.nouvelles === null ? -1 : rang.nouvelles });

        if (!aDesStats) fin(enCours ? "Rank à jour. " + texteAttente : "Rank à jour.");
        else if (!rang.lu) fin("Stats à jour.");
        else if (rang.nouvelles === null) fin("Rank et stats à jour.");
        else if (rang.nouvelles === 0) fin("Déjà à jour.");
        else fin(nouvellesGames(rang.nouvelles) + " depuis la dernière mise à jour.");
      });
    }

    var majBtnEl = document.getElementById("lpMajBtn");
    if (majBtnEl) majBtnEl.addEventListener("click", majRiot);

    /* Stats de saison pas encore prêtes chez Legends Tracker (compte tout
       juste découvert) : on retente tout seul, à l'arrivée puis de temps en
       temps, pour que personne n'ait à les saisir à la main. */
    var K_ATTENTE = "lp_stats_attente_v1";
    var autoEssais = 0;

    function statsManquantes() {
      if (!MAJ_ENDPOINT || state.mode !== "manual") return false;
      var sn = readJson(K_SAISON, null);
      return !(sn && sn.games > 0);
    }

    function relanceAuto() {
      if (majEnCours || autoEssais >= 20 || !statsManquantes() || !lireRiot()) return;
      var marque = readJson(K_ATTENTE, {}) || {};
      if (marque.t && Date.now() - marque.t < 5 * 60 * 1000) return;
      autoEssais++;
      marque.t = Date.now();
      writeJson(K_ATTENTE, marque);
      majRiot();
    }

    setTimeout(relanceAuto, 1500);
    setInterval(relanceAuto, 3 * 60 * 1000);
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) relanceAuto();
    });
    window.lpRelanceStats = relanceAuto;

    /* ---------------- Stats des 30 derniers jours ----------------
       Suivi de stats et saisie à la main : les games datées des 30 derniers
       jours. Hors suivi avec le relais : l'écart entre le relevé de saison
       d'aujourd'hui et celui d'il y a 30 jours. Pas assez de données :
       rien d'affiché plutôt qu'un chiffre faux. */

    var K_SAISON_HIST = "lp_synth_saison_hist_v1";
    var JOUR_MS = 86400000;

    function noteReleveSaison(j) {
      var st = j.stats || {};
      var moy = j.moyennes || {};
      var lb = j.laningBrut || {};
      var point = {
        t: Date.now(),
        games: majNombre(st.games), wr: majNombre(st.wr), cs: majNombre(st.cs),
        kp: majNombre(st.kp), dpm: dpmPlausible(majNombre(st.dpm)), gpm: majNombre(st.gpm),
        dom: majNombre(lb.dominant), domine: majNombre(lb.domine),
        k: majNombre(moy.kills), d: majNombre(moy.deaths), a: majNombre(moy.assists), min: majNombre(moy.minutes),
        complet: !!(j.couverture && j.couverture.complete)
      };
      var hist = readJson(K_SAISON_HIST, []);
      if (!Array.isArray(hist)) hist = [];
      // Un relevé par jour suffit : celui du jour remplace le précédent du même jour.
      var dernier = hist[hist.length - 1];
      if (dernier && jourLocal(new Date(dernier.t)) === jourLocal(new Date(point.t))) hist[hist.length - 1] = point;
      else hist.push(point);
      if (hist.length > 400) hist = hist.slice(hist.length - 400);
      writeJson(K_SAISON_HIST, hist);
    }

    function stats30Saison() {
      var hist = readJson(K_SAISON_HIST, []);
      if (!Array.isArray(hist) || hist.length < 2) return null;
      var s1 = hist[hist.length - 1];
      var cible = s1.t - 30 * JOUR_MS;
      var s0 = null;
      for (var i = hist.length - 2; i >= 0; i--) {
        if (hist[i].t <= cible) { s0 = hist[i]; break; }
      }
      if (!s0 || cible - s0.t > 15 * JOUR_MS || !s0.complet || !s1.complet) return null;
      var n = s1.games - s0.games;
      if (!(n >= 3)) return null;

      function connu(v) { return v !== null && v !== undefined; }
      // Stats par minute : pondérées par la durée des games quand elle est connue.
      function ecart(cle, parMinute) {
        if (!connu(s0[cle]) || !connu(s1[cle])) return null;
        var minutes = parMinute && s0.min > 0 && s1.min > 0;
        var p0 = s0.games * (minutes ? s0.min : 1);
        var p1 = s1.games * (minutes ? s1.min : 1);
        return p1 - p0 > 0 ? (s1[cle] * p1 - s0[cle] * p0) / (p1 - p0) : null;
      }

      var out = {
        winrate: connu(s0.wr) && connu(s1.wr)
          ? ((Math.round(s1.wr * s1.games / 100) - Math.round(s0.wr * s0.games / 100)) / n) * 100
          : null,
        csMin: ecart("cs", true),
        dpm: ecart("dpm", true),
        gpm: ecart("gpm", true),
        kp: ecart("kp", false),
        kda: null,
        early: null
      };
      if (connu(s0.k) && connu(s1.k) && connu(s0.d) && connu(s1.d) && connu(s0.a) && connu(s1.a)) {
        var K = s1.k * s1.games - s0.k * s0.games;
        var D = s1.d * s1.games - s0.d * s0.games;
        var A = s1.a * s1.games - s0.a * s0.games;
        out.kda = D > 0 ? (K + A) / D : K + A;
      }
      if (connu(s0.dom) && connu(s1.dom) && connu(s0.domine) && connu(s1.domine)) {
        var dom = s1.dom * s1.games - s0.dom * s0.games;
        var sub = s1.domine * s1.games - s0.domine * s0.games;
        out.early = dom + sub > 0 ? (dom / (dom + sub)) * 100 : null;
      }

      // Hors de toute plage réaliste : relevé incohérent, on n'affiche rien.
      var bornes = { winrate: [0, 100], csMin: [0, 15], kda: [0, 30], kp: [0, 100], dpm: [0, 5000], gpm: [0, 2000], early: [0, 100] };
      Object.keys(bornes).forEach(function (c) {
        var v = out[c];
        if (v !== null && (!isFinite(v) || v < bornes[c][0] || v > bornes[c][1])) out[c] = null;
      });
      return out;
    }

    function stats30(games) {
      if (state.mode !== "auto" && MAJ_ENDPOINT) return stats30Saison();
      var limite = Date.now() - 30 * JOUR_MS;
      var recentes = (games || []).filter(function (g) {
        var t = g.t || g.vu;
        return t && t >= limite;
      });
      if (recentes.length < 3) return null;
      var m = computeMetrics(recentes);
      m.winrate = m.games ? (m.wins / m.games) * 100 : null;
      return m;
    }

    /* ---------------- Série de jours ----------------
       Comptée et signée par le relais (route /serie), jamais dans la page :
       le navigateur ne garde que le jeton signé et le dernier état reçu.
       Arriver à 30 demande 30 vrais jours d'affilée, et le code de
       réduction n'est envoyé par le relais qu'à ce moment-là.
       Le script de redirection en tête du template fait aussi le passage
       du jour, avec la même fusion que fusionneSerie. */

    var K_SERIE = "lp_serie_v2";
    var SERIE_MAX = 30;
    var seriePrete = false;
    var serieAnimee = false;

    function jourLocal(d) {
      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    }

    function jourParis() {
      try {
        return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
      } catch (e) {
        return "";
      }
    }

    function reduitAnimations() {
      return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    }

    // Même fusion que le script de redirection du template : les deux doivent rester identiques.
    function fusionneSerie(s, j) {
      s.jeton = j.jeton;
      s.n = j.n;
      s.jour = j.jour;
      s.gagne = !!j.gagne;
      if (j.type === "hausse" || j.type === "casse" || j.type === "debut") s.anim = { type: j.type, de: j.avant, a: j.n };
      if (j.recompense) {
        s.recompense = j.recompense;
        s.recompenseVue = false;
        s.mailEnvoye = false;
      }
      return s;
    }

    /* Passage du jour auprès du relais, une fois par jour.
       suite(état, verifie) : verifie vaut false quand le relais n'a pas
       répondu et que l'état rendu vient du dernier passage connu.

       Un onglet restauré en arrière-plan au démarrage du navigateur ne
       compte pas : le jour n'est noté que lorsque la page est vraiment
       regardée. */
    function passeJourSerie(suite, force) {
      if (document.hidden && !force) {
        var lance = false;
        var lancer = function () {
          if (lance) return;
          lance = true;
          document.removeEventListener("visibilitychange", auRetour);
          passeJourSerie(suite, true);
        };
        var auRetour = function () {
          if (!document.hidden) lancer();
        };
        document.addEventListener("visibilitychange", auRetour);
        /* Filet : certains navigateurs annoncent une page masquée alors
           qu'elle est bien à l'écran. On ne bloque donc jamais longtemps. */
        setTimeout(lancer, 10000);
        return;
      }

      var s = readJson(K_SERIE, {}) || {};
      if (s.jeton && s.jour && s.jour === jourParis()) return suite(s, true);

      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, 8000);
      var url = MAJ_ENDPOINT.replace(/\/+$/, "") + "/serie?profil=" + (LP_IS_SUBSCRIBER ? "eleve" : "prospect") +
        "&jeton=" + encodeURIComponent(s.jeton || "");

      fetch(url, { signal: ctrl.signal, credentials: "omit" })
        .then(function (r) {
          clearTimeout(timer);
          return r.ok ? r.json() : null;
        })
        .then(function (j) {
          if (!j || typeof j.jeton !== "string" || typeof j.n !== "number") return suite(s.jeton ? s : null, false);
          var frais = fusionneSerie(readJson(K_SERIE, {}) || {}, j);
          writeJson(K_SERIE, frais);
          suite(frais, true);
        })
        .catch(function () {
          clearTimeout(timer);
          suite(s.jeton ? s : null, false);
        });
    }

    function echelleFlamme(n) {
      return n > 0 ? 0.6 + (Math.min(n, SERIE_MAX) - 1) / (SERIE_MAX - 1) : 0;
    }

    function afficheStreak(carte, n, sansTransition) {
      var flamme = document.getElementById("lpStreakFlamme");
      var nEl = document.getElementById("lpStreakN");
      var unite = document.getElementById("lpStreakUnite");
      if (sansTransition) carte.classList.add("sans-transition");
      if (flamme) flamme.style.setProperty("--lp-flamme", String(echelleFlamme(n)));
      if (nEl) {
        nEl.textContent = String(n);
        // Éclat du chiffre : léger à 1 jour, franc à 30.
        nEl.style.setProperty("--lp-eclat", n > 0 ? Math.pow((Math.min(n, SERIE_MAX) - 1) / (SERIE_MAX - 1), 0.8).toFixed(3) : "0");
      }
      if (unite) unite.textContent = n > 1 ? "jours d'affilée" : "jour d'affilée";
      carte.classList.toggle("is-eteinte", n === 0);
      if (sansTransition) {
        void carte.offsetWidth;
        carte.classList.remove("sans-transition");
      }
    }

    function afficheGain(s) {
      var el = document.getElementById("lpStreakGain");
      if (!el) return;
      var debloque = !!(s && s.gagne && s.recompense);
      el.disabled = !debloque;
      el.classList.toggle("is-gagne", debloque);
      el.textContent = debloque
        ? "Réduction débloquée"
        : LP_IS_SUBSCRIBER
          ? "À 30 jours, -10 % sur ton prochain mois"
          : "À 30 jours, -15 % sur ton premier mois";
    }

    /* Colonne de droite vide (pas de champions, pas de série) : le héro
       prend toute la largeur. */
    function ajusteColonne() {
      var cote = document.querySelector(".lp-synth-side");
      var hero = document.querySelector(".lp-synth-grid > .lp-hero");
      if (!cote || !hero) return;
      var alloc = cote.querySelector(".lp-alloc");
      var serie = document.getElementById("lpStreak");
      var vide = (!alloc || alloc.style.display === "none") && (!serie || serie.hidden);
      cote.style.display = vide ? "none" : "";
      hero.style.gridColumn = vide ? "1 / -1" : "";
    }

    function quandVisible(el, suite) {
      if (!("IntersectionObserver" in window)) {
        setTimeout(suite, 300);
        return;
      }
      var io = new IntersectionObserver(function (entrees) {
        for (var i = 0; i < entrees.length; i++) {
          if (entrees[i].isIntersecting) {
            io.disconnect();
            setTimeout(suite, 250);
            return;
          }
        }
      }, { threshold: 0.6 });
      io.observe(el);
    }

    function joueStreak(carte, anim, apres) {
      if (window.lpTrack) window.lpTrack("serie", { type: anim.type, de: anim.de, a: anim.a });

      if (anim.type !== "casse") {
        if (anim.type === "hausse") carte.classList.add("is-hausse");
        afficheStreak(carte, anim.a, false);
        setTimeout(function () {
          carte.classList.remove("is-hausse");
          apres();
        }, 1100);
        return;
      }

      /* Casse : la flamme vacille et meurt, part en fumée, le compteur tombe
         à zéro. Un temps mort, puis une petite flamme se rallume : le jour
         d'aujourd'hui compte déjà. */
      var nEl = document.getElementById("lpStreakN");
      var unite = document.getElementById("lpStreakUnite");
      carte.classList.add("is-casse");

      setTimeout(function () {
        var v = anim.de;
        var pas = Math.max(1, Math.ceil(anim.de / 12));
        var tic = setInterval(function () {
          v = Math.max(0, v - pas);
          if (nEl) nEl.textContent = String(v);
          if (v === 0) clearInterval(tic);
        }, 55);
      }, 900);

      setTimeout(function () {
        afficheStreak(carte, 0, true);
        if (unite) unite.textContent = "jour d'affilée";
      }, 2300);

      setTimeout(function () {
        carte.classList.remove("is-casse");
      }, 3500);

      setTimeout(function () {
        afficheStreak(carte, anim.a, false);
        setTimeout(apres, 1000);
      }, 4600);
    }

    /* ---- 30 jours : explosion, confettis, popup ---- */

    function confettis(origine) {
      var boite = origine ? origine.getBoundingClientRect() : null;
      var cx = boite ? boite.left + boite.width / 2 : window.innerWidth / 2;
      var cy = boite ? boite.top + boite.height * 0.45 : window.innerHeight / 2;
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext && canvas.getContext("2d");
      if (!ctx) return;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var W = window.innerWidth, H = window.innerHeight;
      canvas.className = "lp-confettis";
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      canvas.setAttribute("aria-hidden", "true");
      document.body.appendChild(canvas);
      ctx.scale(dpr, dpr);

      var couleurs = ["#e3fc02", "#f0a32e", "#ff7a2f", "#2ecc80", "#4cc2ff", "#f4f4f1", "#b78bfa"];
      var morceaux = [];
      for (var i = 0; i < 170; i++) {
        var angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.5;
        var vitesse = 6 + Math.random() * 12;
        morceaux.push({
          x: cx, y: cy,
          vx: Math.cos(angle) * vitesse, vy: Math.sin(angle) * vitesse,
          r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.35,
          w: 5 + Math.random() * 5, h: 8 + Math.random() * 7,
          c: couleurs[i % couleurs.length]
        });
      }

      var debut = null;
      var DUREE = 2800;
      function image(t) {
        if (debut === null) debut = t;
        var e = t - debut;
        ctx.clearRect(0, 0, W, H);
        ctx.globalAlpha = e < DUREE - 700 ? 1 : Math.max(0, (DUREE - e) / 700);
        morceaux.forEach(function (p) {
          p.vy += 0.3;
          p.vx *= 0.985;
          p.vy *= 0.985;
          p.x += p.vx;
          p.y += p.vy;
          p.r += p.vr;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.r);
          ctx.fillStyle = p.c;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, Math.max(1, p.h * Math.abs(Math.cos(p.r * 2))));
          ctx.restore();
        });
        if (e < DUREE) requestAnimationFrame(image);
        else if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
      requestAnimationFrame(image);
    }

    function explose(carte, suite) {
      if (reduitAnimations()) return suite();
      carte.classList.add("is-explose");
      confettis(document.getElementById("lpStreakFlamme"));
      setTimeout(function () {
        // La flamme renaît à sa taille maximale derrière le popup.
        var flamme = document.getElementById("lpStreakFlamme");
        carte.classList.add("sans-transition");
        if (flamme) flamme.style.setProperty("--lp-flamme", "0");
        carte.classList.remove("is-explose");
        void carte.offsetWidth;
        carte.classList.remove("sans-transition");
        if (flamme) flamme.style.setProperty("--lp-flamme", String(echelleFlamme(SERIE_MAX)));
        suite();
      }, 600);
    }

    var serieModal = document.getElementById("lpSerieModal");
    if (serieModal && serieModal.parentNode !== document.body) {
      // Hors des panneaux : un parent masqué ou transformé ne doit pas le cacher.
      document.body.appendChild(serieModal);
    }

    function ouvrePopupSerie(rec) {
      if (!serieModal || !rec) return;
      var eleve = rec.profil === "eleve";
      var texte = document.getElementById("lpSerieTexte");
      var bloc = document.getElementById("lpSerieCodeBloc");
      var code = document.getElementById("lpSerieCode");
      var lien = document.getElementById("lpSerieLien");
      var copier = document.getElementById("lpSerieCopier");

      if (texte) {
        texte.textContent = eleve
          ? "Tu as gagné le droit à -10 % sur ton prochain mois. MP ton coach pour obtenir ton code."
          : "Tu as gagné -15 % sur ton premier mois de coaching.";
      }
      if (bloc) bloc.hidden = eleve || !rec.code;
      if (code) code.textContent = eleve ? "" : rec.code || "";
      if (lien) lien.hidden = eleve;
      if (copier) copier.textContent = "Copier le code";

      serieModal.hidden = false;
      document.documentElement.classList.add("lp-modal-open");
      var focus = eleve || !rec.code ? document.getElementById("lpSerieFermer") : copier;
      if (focus) setTimeout(function () { focus.focus(); }, 60);
    }

    function fermePopupSerie() {
      if (!serieModal || serieModal.hidden) return;
      serieModal.hidden = true;
      document.documentElement.classList.remove("lp-modal-open");
    }

    function copieCode(texte, bouton) {
      function reussi() {
        if (!bouton) return;
        bouton.textContent = "Code copié";
        setTimeout(function () { bouton.textContent = "Copier le code"; }, 2200);
      }
      // Dernier recours : le code est sélectionné, prêt à copier à la main.
      function selectionne() {
        var el = document.getElementById("lpSerieCode");
        if (!el || !window.getSelection) return;
        var plage = document.createRange();
        plage.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(plage);
        if (bouton) bouton.textContent = "Code sélectionné";
      }
      function secours() {
        var zone = document.createElement("textarea");
        zone.value = texte;
        zone.setAttribute("readonly", "");
        zone.style.cssText = "position:fixed;top:-1000px;left:0;opacity:0;";
        document.body.appendChild(zone);
        zone.select();
        var ok = false;
        try {
          ok = document.execCommand("copy");
        } catch (e) {}
        document.body.removeChild(zone);
        if (ok) reussi();
        else selectionne();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texte).then(reussi, secours);
      } else {
        secours();
      }
    }

    if (serieModal) {
      serieModal.addEventListener("click", function (e) {
        if (e.target === serieModal) fermePopupSerie();
      });
      var fermerSerie = document.getElementById("lpSerieFermer");
      if (fermerSerie) fermerSerie.addEventListener("click", fermePopupSerie);
      var copierSerie = document.getElementById("lpSerieCopier");
      if (copierSerie) {
        copierSerie.addEventListener("click", function () {
          var code = (document.getElementById("lpSerieCode") || {}).textContent || "";
          if (code) copieCode(code, copierSerie);
        });
      }
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") fermePopupSerie();
      });
    }

    var gainSerie = document.getElementById("lpStreakGain");
    if (gainSerie) {
      gainSerie.addEventListener("click", function () {
        var s = readJson(K_SERIE, {}) || {};
        if (s.gagne && s.recompense) ouvrePopupSerie(s.recompense);
      });
    }

    /* Récompense reçue du relais : mail à Legends Path pour un élève (une
       seule fois), puis explosion et popup (une seule fois). */
    function traiteRecompense(carte, avecEffet) {
      var s = readJson(K_SERIE, {}) || {};
      if (!s.recompense) return;

      if (s.recompense.profil === "eleve" && LP_IS_SUBSCRIBER && !s.mailEnvoye) {
        var form = document.getElementById("lpSerieMail");
        if (form && window.lpEnvoiFormulaireClient) {
          s.mailEnvoye = true;
          writeJson(K_SERIE, s);
          window.lpEnvoiFormulaireClient(form);
          if (window.lpTrack) window.lpTrack("serie_30_mail", {});
        }
      }

      if (s.recompenseVue) return;
      s.recompenseVue = true;
      writeJson(K_SERIE, s);
      if (window.lpTrack) window.lpTrack("serie_30", { profil: s.recompense.profil });

      var rec = s.recompense;
      if (avecEffet) explose(carte, function () { ouvrePopupSerie(rec); });
      else ouvrePopupSerie(rec);
    }

    function renderStreak() {
      var carte = document.getElementById("lpStreak");
      if (!carte) return;

      if (seriePrete) {
        var connu = readJson(K_SERIE, {}) || {};
        if (!serieAnimee && connu.jeton) {
          afficheStreak(carte, connu.n || 0, false);
          afficheGain(connu);
        }
        ajusteColonne();
        return;
      }
      seriePrete = true;

      if (!MAJ_ENDPOINT) {
        carte.hidden = true;
        ajusteColonne();
        return;
      }

      // Dernier état connu tout de suite, passage du jour ensuite.
      var cache = readJson(K_SERIE, {}) || {};
      if (cache.jeton) {
        carte.hidden = false;
        afficheStreak(carte, cache.anim ? (cache.anim.type === "debut" ? 0 : cache.anim.de) : cache.n || 0, true);
        afficheGain(cache);
      }
      ajusteColonne();
      serieAnimee = true;

      passeJourSerie(function (s, verifie) {
        /* Rien de connu, ou relais injoignable avec un état qui date d'un
           autre jour : on n'affiche pas un compteur périmé, qui laisserait
           croire à une série toujours en cours. */
        if (!s || (!verifie && s.jour !== jourParis())) {
          serieAnimee = false;
          carte.hidden = true;
          ajusteColonne();
          return;
        }
        carte.hidden = false;
        ajusteColonne();

        /* Animation en attente qui ne mène pas au compte du jour : elle vient
           d'une visite précédente et n'a plus de sens, on l'oublie. */
        var anim = s.anim && s.anim.a === s.n ? s.anim : null;
        // Pendant l'animation, la récompense n'est pas encore révélée.
        afficheGain(anim && !reduitAnimations() ? { gagne: false } : s);
        if (!anim || reduitAnimations()) {
          if (anim) {
            var sansAnim = readJson(K_SERIE, {}) || {};
            delete sansAnim.anim;
            writeJson(K_SERIE, sansAnim);
          }
          afficheStreak(carte, s.n || 0, true);
          serieAnimee = false;
          if (s.recompense && !s.recompenseVue) quandVisible(carte, function () { traiteRecompense(carte, false); });
          else traiteRecompense(carte, false);
          return;
        }

        afficheStreak(carte, anim.type === "debut" ? 0 : anim.de, true);

        var demarree = false;
        function demarre(avecAnimation) {
          if (demarree) return;
          demarree = true;
          var frais = readJson(K_SERIE, {}) || {};
          if (frais.anim) {
            delete frais.anim;
            writeJson(K_SERIE, frais);
          }
          if (!avecAnimation) {
            afficheStreak(carte, s.n || 0, true);
            afficheGain(s);
            serieAnimee = false;
            traiteRecompense(carte, false);
            return;
          }
          joueStreak(carte, anim, function () {
            serieAnimee = false;
            /* Le compte affiché est toujours celui du relais, jamais la
               cible de l'animation. */
            var fin = readJson(K_SERIE, {}) || {};
            afficheStreak(carte, typeof fin.n === "number" ? fin.n : s.n || 0, false);
            afficheGain(fin);
            traiteRecompense(carte, true);
          });
        }

        quandVisible(carte, function () { demarre(true); });
        /* Carte jamais amenée à l'écran : au bout de quelques secondes, le
           vrai compteur s'affiche quand même, sans animation. Sinon une
           série cassée resterait affichée à son ancienne valeur. */
        setTimeout(function () { demarre(false); }, 3500);
      });
    }

    /* ---------------- Synchro du suivi (élèves) ---------------- */

    function sheetId() {
      var url = window.lpGetSheetUrl ? window.lpGetSheetUrl() : LP_SHEET_URL;
      var m = String(url || "").match(/\/d\/([a-zA-Z0-9_-]+)/);
      return m ? m[1] : null;
    }

    function parseCsvLine(line) {
      var out = [], cur = "", inQ = false;
      for (var i = 0; i < line.length; i++) {
        var ch = line[i];
        if (inQ) {
          if (ch === '"') {
            if (line[i + 1] === '"') { cur += '"'; i++; } else inQ = false;
          } else cur += ch;
        } else {
          if (ch === '"') inQ = true;
          else if (ch === ",") { out.push(cur); cur = ""; }
          else cur += ch;
        }
      }
      out.push(cur);
      return out;
    }

    function parseNum(v) {
      var s = String(v == null ? "" : v).replace(",", ".").replace("%", "").trim();
      if (!s) return null;
      var n = parseFloat(s);
      return isNaN(n) ? null : n;
    }

    // Colonnes de l'onglet "Games" du template de suivi (index CSV 0-based)
    var COL = { label: 2, result: 3, champ: 6, cs: 14, k: 16, d: 18, a: 20, kp: 22, dpm: 24, gpm: 25, early: 26 };

    function parseSheetGames(csv) {
      var winRe = /^(w|v|oui|win|victoire|gagn)/i;
      var loseRe = /^(l|d|non|lose|loose|défaite|defaite|perd)/i;
      var earlyWinRe = /(gagn|win|oui)/i;
      var earlyLoseRe = /(perd|lose|non)/i;
      var games = [];

      csv.split("\n").forEach(function (line) {
        var c = parseCsvLine(line);
        if (!/^game\s*\d+/i.test((c[COL.label] || "").trim())) return;

        var result = (c[COL.result] || "").trim();
        var w;
        if (winRe.test(result)) w = 1;
        else if (loseRe.test(result)) w = 0;
        else return; // ligne vide ou résultat non renseigné

        var earlyRaw = (c[COL.early] || "").trim();
        games.push({
          w: w,
          champ: (c[COL.champ] || "").trim() || null,
          cs: parseNum(c[COL.cs]),
          k: parseNum(c[COL.k]), d: parseNum(c[COL.d]), a: parseNum(c[COL.a]),
          kp: parseNum(c[COL.kp]),
          dpm: dpmPlausible(parseNum(c[COL.dpm])),
          gpm: parseNum(c[COL.gpm]),
          early: earlyWinRe.test(earlyRaw) ? 1 : earlyLoseRe.test(earlyRaw) ? 0 : null
        });
      });

      return games;
    }

    function syncSheet(onDone) {
      var id = sheetId();
      if (!id) { onDone("no_sheet"); return; }

      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, 10000);

      // &t= casse les caches intermédiaires pour lire la version la plus fraîche
      fetch("https://docs.google.com/spreadsheets/d/" + id + "/gviz/tq?tqx=out:csv&sheet=Games&t=" + Date.now(), { signal: ctrl.signal })
        .then(function (r) {
          clearTimeout(timer);
          if (!r.ok) throw new Error("http");
          return r.text();
        })
        .then(function (csv) {
          updateLedger(parseSheetGames(csv));
          state.synced = true;
          onDone(null);
        })
        .catch(function () {
          clearTimeout(timer);
          onDone("fetch_error");
        });
    }

    /* ------------------------------------------------------------------
       LE COACH, LU DANS LE SUIVI

       Nom       onglet « suivi global », cellule M8
       Objectifs onglet « objectifs », cellules B16 et suivantes

       On demande à gviz une plage précise plutôt que de compter les lignes
       d'un export complet : headers=0 empêche la première ligne d'être prise
       pour un en-tête, ce qui décalerait tout d'un cran.

       La prochaine session n'est pas toujours renseignée dans le suivi :
       l'élève la note lui-même, c'est mémorisé dans son navigateur.
       ------------------------------------------------------------------ */

    var K_COACH_NEXT = "lp_coach_next_v1";

    function litPlage(id, onglet, plage) {
      var url = "https://docs.google.com/spreadsheets/d/" + id +
        "/gviz/tq?tqx=out:csv&headers=0&sheet=" + encodeURIComponent(onglet) +
        "&range=" + encodeURIComponent(plage) + "&t=" + Date.now();
      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, 10000);
      return fetch(url, { signal: ctrl.signal })
        .then(function (r) {
          clearTimeout(timer);
          if (!r.ok) throw new Error("http");
          return r.text();
        })
        .then(function (csv) {
          return csv.split("\n").map(function (l) {
            return parseCsvLine(l).map(function (c) { return String(c || "").trim(); });
          });
        });
    }

    function prochaineSession() {
      try {
        return window.lpAccountStorage.getItem(K_COACH_NEXT) || "";
      } catch (e) {
        return "";
      }
    }

    function renderCoach(nom, objectifs) {
      var el = document.getElementById("lpCoach");
      if (!el || !nom) return;

      var quand = prochaineSession();
      var liste = objectifs.slice(0, 3).map(function (o) {
        return '<li class="lp-coach__obj">' + esc(o) + "</li>";
      }).join("");

      el.innerHTML =
        '<span class="lp-coach__avatar">' + esc(nom.slice(0, 1).toUpperCase()) + "</span>" +
        '<div class="lp-coach__body">' +
        '<span class="lp-coach__name">' + esc(nom) + '<span class="lp-coach__role">ton coach</span></span>' +
        (liste ? '<ul class="lp-coach__objs">' + liste + "</ul>" : "") +
        "</div>" +
        '<span class="lp-coach__next">' +
        (quand
          ? "<b>Prochaine session</b>" + esc(quand) +
            ' <button type="button" class="lp-coach__edit" data-lp-coach-edit>modifier</button>'
          : '<button type="button" class="lp-coach__edit" data-lp-coach-edit>+ Noter la prochaine session</button>') +
        "</span>" +
        '<button type="button" class="lp-coach__btn" id="lpCoachBtn">Réserver</button>';

      el.hidden = false;

      var editer = el.querySelector("[data-lp-coach-edit]");
      if (editer) {
        editer.addEventListener("click", function () {
          var champ = document.createElement("input");
          champ.type = "text";
          champ.className = "lp-coach__input";
          champ.placeholder = "jeudi 4 septembre, 20 h";
          champ.value = quand;
          var zone = el.querySelector(".lp-coach__next");
          zone.innerHTML = "<b>Prochaine session</b>";
          zone.appendChild(champ);
          champ.focus();

          function valider() {
            var v = champ.value.trim();
            try {
              if (v) window.lpAccountStorage.setItem(K_COACH_NEXT, v);
              else window.lpAccountStorage.removeItem(K_COACH_NEXT);
            } catch (e) {}
            renderCoach(nom, objectifs);
          }
          champ.addEventListener("blur", valider);
          champ.addEventListener("keydown", function (e) {
            if (e.key === "Enter") { e.preventDefault(); champ.blur(); }
            if (e.key === "Escape") { champ.value = quand; champ.blur(); }
          });
        });
      }

      var resa = document.getElementById("lpCoachBtn");
      if (resa) {
        resa.addEventListener("click", function () {
          if (window.lpOpenChoiceModal) window.lpOpenChoiceModal();
        });
      }
    }

    function litPremiereVariante(id, noms, plage) {
      var i = 0;
      function suivant() {
        if (i >= noms.length) return Promise.resolve(null);
        var nom = noms[i++];
        return litPlage(id, nom, plage)
          .then(function (lignes) {
            var vide = !lignes.some(function (l) {
              return l.some(function (c) { return c && c.length; });
            });
            return vide ? suivant() : lignes;
          })
          .catch(suivant);
      }
      return suivant();
    }

    var ONGLET_GLOBAL = ["suivi global", "Suivi global", "Suivi Global", "SUIVI GLOBAL"];
    var ONGLET_OBJECTIFS = ["objectifs", "Objectifs", "OBJECTIFS"];

    function chargeCoach() {
      if (!LP_IS_SUBSCRIBER) return;
      var el = document.getElementById("lpCoach");
      if (!el) return;
      var id = sheetId();
      if (!id) return;

      litPremiereVariante(id, ONGLET_GLOBAL, "M8")
        .then(function (lignes) {
          var nom = (((lignes || [])[0] || [])[0] || "").trim();
          if (!nom) return;
          renderCoach(nom, objectifsSuivi);
        })
        .catch(function () {});
    }

    /* Les objectifs du suivi se lisent séparément du nom du coach : ils
       étaient auparavant dans la même chaîne, donc une cellule M8 vide
       les faisait disparaître alors qu'ils étaient bien remplis. */
    var objectifsSuivi = [];

    function chargeObjectifsSuivi() {
      if (!LP_IS_SUBSCRIBER) return;
      var id = sheetId();
      if (!id) return;

      litPremiereVariante(id, ONGLET_OBJECTIFS, "B16:B30")
        .then(function (obj) {
          objectifsSuivi = (obj || [])
            .map(function (l) { return (l[0] || "").trim(); })
            .filter(function (x) { return x.length > 1; });
          renderObjPerso(objectifsSuivi);
          var c = document.getElementById("lpCoach");
          if (c && !c.hidden && objectifsSuivi.length) {
            /* Le nom est déjà affiché : on complète sans tout refaire. */
            var nom = (c.querySelector(".lp-coach__name") || {}).firstChild;
            if (nom && nom.textContent) renderCoach(nom.textContent.trim(), objectifsSuivi);
          }
        })
        .catch(function () {});
    }

    /* ---------------- Boutons d'entrée + resynchro + init ---------------- */

    // Après le point de départ (enregistré ou passé), on enchaîne sur les
    // réglages rank/MMR s'ils n'existent pas encore.
    function afterFirstEntry() {
      if (!state.baseline) {
        openBaselineModal();
      } else if (!state.base) {
        openSettings();
      }
    }

    // Au branchement du suivi, les games déjà présentes sont de l'historique :
    // le rank réglé les inclut déjà. On recale donc le point d'ancrage pour que
    // seules les games ajoutées ensuite fassent bouger les LP.
    function recalibrateAnchor() {
      if (!state.base) return;
      state.base.anchor = currentGames().length;
      writeJson(K_BASE, state.base);
    }

    var manualBtn = document.getElementById("lpSynthManualBtn");
    if (manualBtn) {
      manualBtn.addEventListener("click", function () {
        state.mode = "manual";
        writeJson(K_MODE, "manual");
        renderAll();
        if (MAJ_ENDPOINT) {
          majRiot();
        } else if (!state.baseline) {
          openBaselineModal();
        } else {
          openSettings();
        }
      });
    }

    var autoBtn = document.getElementById("lpSynthAutoBtn");
    if (autoBtn) {
      autoBtn.addEventListener("click", function () {
        if (!LP_IS_SUBSCRIBER) {
          if (window.lpOpenLockModal) window.lpOpenLockModal();
          return;
        }
        if (!sheetId()) {
          if (connectStatus) connectStatus.textContent = "Ton suivi n'est pas encore relié à ton compte, demande à ton coach.";
          return;
        }
        if (connectStatus) connectStatus.textContent = "Synchronisation…";
        syncSheet(function (err) {
          if (err) {
            if (connectStatus) connectStatus.textContent = "Synchronisation impossible, vérifie que ton suivi est partagé par lien.";
            return;
          }
          state.mode = "auto";
          writeJson(K_MODE, "auto");
          recalibrateAnchor();
          renderAll();
          afterFirstEntry();
        });
      });
    }

    // Resynchronisation du suivi : bouton ↻ + retour sur l'onglet Synthèse
    var lastSyncAt = 0;

    function refreshSync(force) {
      if (state.mode !== "auto" || !sheetId()) return;
      if (!force && Date.now() - lastSyncAt < 60 * 1000) return;

      var btn = document.getElementById("lpSyncRefresh");
      if (btn) btn.textContent = "Synchronisation…";

      syncSheet(function (err) {
        lastSyncAt = Date.now();
        if (btn) btn.textContent = "Actualiser";
        if (!err) renderAll();
      });
    }

    var syncRefreshBtn = document.getElementById("lpSyncRefresh");
    if (syncRefreshBtn) {
      syncRefreshBtn.addEventListener("click", function () { refreshSync(true); });
    }

    document.querySelectorAll('.lp-tab[data-target="lpPanelSynthese"]').forEach(function (tab) {
      tab.addEventListener("click", function () { refreshSync(false); });
    });

    // Bascule manuel ↔ automatique (élèves), depuis les réglages
    function updateModeSwitch() {
      var btn = document.getElementById("lpModeSwitch");
      var hint = document.getElementById("lpModeSwitchHint");
      if (!btn || !hint) return;
      if (state.mode === "auto") {
        hint.textContent = "Tes games sont lues automatiquement depuis ton suivi de stats.";
        btn.textContent = "Repasser en saisie manuelle";
      } else {
        hint.textContent = "Tes games sont saisies à la main.";
        btn.textContent = "Synchroniser avec mon suivi de stats";
      }
    }

    var modeSwitchBtn = document.getElementById("lpModeSwitch");
    if (modeSwitchBtn) {
      modeSwitchBtn.addEventListener("click", function () {
        var st = document.getElementById("lpModeSwitchStatus");

        if (state.mode === "auto") {
          state.mode = "manual";
          writeJson(K_MODE, "manual");
          if (st) st.textContent = "";
          updateModeSwitch();
          renderAll();
          return;
        }

        if (!sheetId()) {
          if (st) st.textContent = "Ton suivi n'est pas encore relié, demande à ton coach.";
          return;
        }
        if (st) st.textContent = "Synchronisation…";
        syncSheet(function (err) {
          if (err) {
            if (st) st.textContent = "Synchronisation impossible, vérifie que ton suivi est partagé par lien.";
            return;
          }
          state.mode = "auto";
          writeJson(K_MODE, "auto");
          lastSyncAt = Date.now();
          recalibrateAnchor();
          if (st) st.textContent = "Synchronisé.";
          updateModeSwitch();
          renderAll();
        });
      });
    }

    // CTA masterclass offerte (non connectés)
    document.querySelectorAll(".lp-free-mc-cta").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (typeof window.lpActivateDashboardTab === "function") {
          window.lpActivateDashboardTab("lpPanelMasterclass");
        }
        setTimeout(function () {
          var target = document.getElementById("lpFreeUnlockBanner") ||
            document.querySelector('#lpMasterclassCards .card[data-free-masterclass="true"]');
          if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 200);
      });
    });

    /* Le parcours d'entrée écrit rank, rôle et moyennes dans le même
       stockage : ce point d'entrée relit tout et redessine, sans recharger
       la page. */
    window.lpSynthRefresh = function () {
      state.mode = readJson(K_MODE, null);
      state.base = readJson(K_BASE, null);
      state.mmr = readJson(K_MMR, { gain: 25, loss: 20 });
      state.role = readJson(K_ROLE, "mid");
      state.baseline = readJson(K_BASELINE, null);
      state.manualGames = readJson(K_GAMES, []);
      if (state.base || state.baseline || state.manualGames.length) renderAll();
      /* Sortie du parcours : si les stats n'étaient pas prêtes, on retente
         tout de suite plutôt que d'attendre la prochaine visite. */
      setTimeout(function () {
        if (window.lpRelanceStats) window.lpRelanceStats();
      }, 1200);
    };

    // Utilitaires exposés pour le calculateur (onglet Outils)
    window.lpRankUtils = { score: lpScore, format: formatRank, TIERS: TIERS, TIER_FR: TIER_FR, GM_LP: LP_GM_OFFSET, CHALL_LP: LP_CHALL_OFFSET };

    // Init
    chargeCoach();
    chargeObjectifsSuivi();
    if (state.mode === "auto" && LP_IS_SUBSCRIBER && sheetId()) {
      renderAll(); // affiche l'état local pendant la synchro
      syncSheet(function (err) {
        if (!err) renderAll();
      });
    } else if (state.mode === "manual" && (state.base || state.manualGames.length)) {
      renderAll();
    } else {
      showConnect();
      /* Le panneau Mental vit indépendamment de la synthèse : il montre son
         état vide même quand aucune source de games n'est encore choisie. */
      renderMental(currentGames());
    }
  })();


  /* ==========================================================================
     OUTILS, calculateur d'objectif de rank.
     Réponse simple : réaliste OUI / NON + le temps nécessaire.
     Se pré-remplit depuis la Synthèse quand les stats y sont renseignées.
     ========================================================================== */
  (function () {
    function readJson(key, fallback) {
      try {
        var raw = window.lpAccountStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (e) {
        return fallback;
      }
    }

    var calcBtn = document.getElementById("lpCalcRun");
    if (!calcBtn) return;

    var calcStatus = document.getElementById("lpCalcStatus");
    var calcResult = document.getElementById("lpRankCalcResult");
    var NO_DIV = ["MASTER", "GRANDMASTER", "CHALLENGER"];

    function num(id) {
      var v = parseFloat((document.getElementById(id) || {}).value);
      return isNaN(v) ? null : v;
    }

    function setVal(id, v) {
      var el = document.getElementById(id);
      if (el && v !== null && v !== undefined) el.value = v;
    }

    // Master+ : pas de division
    function syncDivSelect(tierId, divId) {
      var tierEl = document.getElementById(tierId);
      var divEl = document.getElementById(divId);
      if (!tierEl || !divEl) return;
      function sync() {
        var hidden = NO_DIV.indexOf(tierEl.value) >= 0;
        divEl.disabled = hidden;
        divEl.style.opacity = hidden ? "0.4" : "";
      }
      tierEl.addEventListener("change", sync);
      sync();
    }

    syncDivSelect("lpCalcTier", "lpCalcDiv");
    syncDivSelect("lpCalcGoalTier", "lpCalcGoalDiv");

    // Pré-remplissage depuis la Synthèse
    (function prefill() {
      var last = readJson("lp_synth_last_rank_v1", null);
      if (last) {
        if (last.tier) {
          setVal("lpCalcTier", String(last.tier).toUpperCase());
          if (last.rank) setVal("lpCalcDiv", String(last.rank).toUpperCase());
          setVal("lpCalcLp", last.lp);
        }
        if (last.winrate !== null && last.winrate !== undefined) {
          setVal("lpCalcWr", Math.round(last.winrate * 10) / 10);
        }
        var tierEl = document.getElementById("lpCalcTier");
        if (tierEl) tierEl.dispatchEvent(new Event("change"));
      }

      var dateEl = document.getElementById("lpCalcDate");
      if (dateEl && !dateEl.value) {
        var d = new Date(Date.now() + 60 * 24 * 3600 * 1000);
        dateEl.value = d.toISOString().slice(0, 10);
      }
    })();

    function fmtDuration(days) {
      if (days <= 14) return days + " jour" + (days > 1 ? "s" : "");
      var weeks = Math.round(days / 7);
      if (weeks < 9) return "environ " + weeks + " semaines";
      return "environ " + Math.round(days / 30) + " mois";
    }

    function fmtDateFr(d) {
      return d.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
    }

    function showResult(verdictClass, verdictText, rows) {
      if (!calcResult) return;
      calcResult.className = "lp-tool-result is-visible";
      calcResult.innerHTML =
        '<span class="lp-tool-result__verdict is-' + verdictClass + '">' + verdictText + "</span>" +
        '<div class="lp-tool-result__rows">' +
        rows.map(function (r) { return "<div>" + r + "</div>"; }).join("") +
        "</div>";
    }

    calcBtn.addEventListener("click", function () {
      if (calcStatus) calcStatus.textContent = "";
      if (!window.lpRankUtils) return;

      var wrPct = num("lpCalcWr");
      var gain = num("lpCalcGain");
      var loss = num("lpCalcLoss");
      var lp = num("lpCalcLp") || 0;
      var gpd = num("lpCalcGamesDay");
      var tier = (document.getElementById("lpCalcTier") || {}).value;
      var div = (document.getElementById("lpCalcDiv") || {}).value;
      var goalTier = (document.getElementById("lpCalcGoalTier") || {}).value;
      var goalDiv = (document.getElementById("lpCalcGoalDiv") || {}).value;
      var dateStr = (document.getElementById("lpCalcDate") || {}).value;

      if (wrPct === null || gain === null || loss === null || gpd === null || !dateStr) {
        if (calcStatus) calcStatus.textContent = "Remplis tous les champs.";
        return;
      }

      var currentScore = window.lpRankUtils.score(tier, div, lp);
      var goalScore = window.lpRankUtils.score(goalTier, goalDiv, 0);
      var lpNeeded = goalScore - currentScore;

      // Précision affichée dès qu'un palier Maître+ entre dans le calcul
      var masterNote = null;
      if (NO_DIV.indexOf(tier) > -1 || NO_DIV.indexOf(goalTier) > -1) {
        masterNote = "Repères utilisés : Grand Maître à " + window.lpRankUtils.GM_LP +
          " LP, Challenger à " + window.lpRankUtils.CHALL_LP + " LP (au-dessus de Maître 0 LP).";
      }

      if (lpNeeded <= 0) {
        var doneRows = ["Ton rank actuel est au niveau (ou au-dessus) de ton objectif. Vise plus haut !"];
        if (masterNote) doneRows.push(masterNote);
        showResult("good", "Ton objectif est déjà atteint", doneRows);
        return;
      }

      var wr = wrPct / 100;
      var net = wr * gain - (1 - wr) * loss;

      if (net <= 0) {
        var minWr = Math.ceil((loss / (gain + loss)) * 1000) / 10;
        showResult("bad", "NON", [
          "À " + wrPct + " % de winrate, tu perds des LP sur la durée.",
          "Il te faut au moins <strong>" + minWr + " % de winrate</strong> pour monter."
        ]);
        return;
      }

      var gamesNeeded = Math.ceil(lpNeeded / net);
      var daysNeeded = Math.ceil(gamesNeeded / gpd);
      var estDate = new Date(Date.now() + daysNeeded * 24 * 3600 * 1000);
      var daysAvail = Math.floor((new Date(dateStr).getTime() - Date.now()) / (24 * 3600 * 1000));

      if (daysAvail <= 0) {
        if (calcStatus) calcStatus.textContent = "Choisis une date dans le futur.";
        return;
      }

      var rows = [
        "Il te faut <strong>≈ " + gamesNeeded + " games</strong>, soit <strong>" + fmtDuration(daysNeeded) + "</strong> à ton rythme.",
        "Date estimée : <strong>" + fmtDateFr(estDate) + "</strong>."
      ];
      if (masterNote) rows.push(masterNote);

      if (daysNeeded <= daysAvail) {
        showResult("good", "OUI, c'est réaliste", rows);
      } else {
        var gpdRequired = Math.ceil((gamesNeeded / daysAvail) * 10) / 10;
        showResult("bad", "NON, pas à ce rythme", rows.concat([
          "Pour y arriver pour le " + fmtDateFr(new Date(dateStr)) + ", il faudrait <strong>" + gpdRequired + " games par jour</strong>, ou un meilleur winrate."
        ]));
      }
    });
  })();


  /* ==========================================================================
     RELIER SON SUIVI, quand aucun metafield n'est posé par le coach, l'élève
     colle lui-même le lien de son Google Sheets. Le lien est vérifié (lecture
     réelle de l'onglet Games) avant d'être mémorisé dans son navigateur.
     ========================================================================== */
  (function () {
    var linkArea = document.getElementById("lpSheetLinkArea");
    var linkedArea = document.getElementById("lpSheetLinkedArea");
    var modal = document.getElementById("lpSheetLinkModal");
    if (!linkArea || !linkedArea || !modal) return;

    var wrap = document.getElementById("lpSheetLinkedWrap");
    var input = document.getElementById("lpSheetLinkInput");
    var statusEl = document.getElementById("lpSheetLinkStatus");
    var saveBtn = document.getElementById("lpSheetLinkSave");

    function idFrom(url) {
      var m = String(url || "").match(/\/d\/([a-zA-Z0-9_-]+)/);
      return m ? m[1] : null;
    }

    function embedUrl(url) {
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "rm=minimal";
    }

    function render() {
      var url = window.lpGetSheetUrl ? window.lpGetSheetUrl() : "";
      if (url && idFrom(url)) {
        linkArea.style.display = "none";
        linkedArea.style.display = "";
        if (wrap && !wrap.querySelector("iframe")) {
          var f = document.createElement("iframe");
          f.src = embedUrl(url);
          f.loading = "lazy";
          f.title = "Suivi de stats personnalisé";
          wrap.appendChild(f);
        }
      } else {
        linkArea.style.display = "";
        linkedArea.style.display = "none";
      }
    }

    function openModal() {
      var current = window.lpGetSheetUrl ? window.lpGetSheetUrl() : "";
      if (input) input.value = current || "";
      if (statusEl) statusEl.textContent = "";
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
    }

    window.lpCloseSheetLinkModal = function () {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
    };

    var openBtn = document.getElementById("lpSheetLinkOpen");
    if (openBtn) openBtn.addEventListener("click", openModal);

    var closeBtn = document.getElementById("lpSheetLinkClose");
    if (closeBtn) closeBtn.addEventListener("click", window.lpCloseSheetLinkModal);

    modal.addEventListener("click", function (e) {
      if (e.target === modal) window.lpCloseSheetLinkModal();
    });

    var unlinkBtn = document.getElementById("lpSheetUnlink");
    if (unlinkBtn) {
      unlinkBtn.addEventListener("click", function () {
        try {
          window.lpAccountStorage.removeItem(LP_SHEET_KEY);
        } catch (e) {}
        if (wrap) wrap.innerHTML = "";
        render();
        openModal();
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener("click", function () {
        var url = (input && input.value ? input.value : "").trim();
        var id = idFrom(url);

        if (!id) {
          if (statusEl) statusEl.textContent = "Ce lien n'est pas un lien Google Sheets valide.";
          return;
        }

        saveBtn.disabled = true;
        if (statusEl) statusEl.textContent = "Vérification…";

        var ctrl = new AbortController();
        var timer = setTimeout(function () { ctrl.abort(); }, 10000);

        fetch("https://docs.google.com/spreadsheets/d/" + id + "/gviz/tq?tqx=out:csv&sheet=Games&t=" + Date.now(), { signal: ctrl.signal })
          .then(function (r) {
            clearTimeout(timer);
            if (!r.ok) throw new Error("http");
            return r.text();
          })
          .then(function (csv) {
            // Un suivi valide contient les lignes "Game N" de l'onglet Games
            if (!/"game\s*\d+"/i.test(csv)) {
              throw new Error("no_games_tab");
            }
            try {
              window.lpAccountStorage.setItem(LP_SHEET_KEY, url);
            } catch (e) {}
            saveBtn.disabled = false;
            if (statusEl) statusEl.textContent = "Suivi relié.";
            setTimeout(function () {
              window.lpCloseSheetLinkModal();
              render();
            }, 700);
          })
          .catch(function (err) {
            clearTimeout(timer);
            saveBtn.disabled = false;
            if (!statusEl) return;
            statusEl.textContent = String(err && err.message) === "no_games_tab"
              ? "Lien lu, mais aucun onglet « Games » trouvé, vérifie que c'est bien ton suivi Legends Path."
              : "Impossible de lire ce suivi. Vérifie qu'il est partagé avec « Tous les utilisateurs disposant du lien ».";
          });
      });
    }

    render();
  })();


  /* ==========================================================================
     Confort mobile + première porte du tunnel.
     Ce bloc ne remplace aucun comportement existant : il s'ajoute par-dessus.
     ========================================================================== */

  /* --------------------------------------------------------------------------
     0. Aucun envoi natif depuis les modales à formulaire

     Shopify redirige vers l'accueil après un envoi natif du formulaire client :
     l'élève perdait la page au moment de saisir ses stats. Cette garde est
     posée en capture sur document, donc elle s'applique même si l'écoute
     propre à un formulaire n'a pas pu s'attacher (id inattendu, ordre de
     chargement). Les envois passent tous par fetch, en arrière-plan.
     -------------------------------------------------------------------------- */
  /* Un envoi que NOUS déclenchons porte ce drapeau : la garde le laisse
     passer, sinon elle annulerait notre propre soumission. */
  document.addEventListener(
    "submit",
    function (e) {
      var f = e.target;
      if (!f) return;
      if (f.getAttribute("data-lp-native") === "1") return;
      var action = (f.getAttribute && f.getAttribute("action")) || "";
      var dansModale = f.closest && f.closest("#lpOnboard, #lpFreeUnlockModal");
      if (dansModale || action.indexOf("/contact") > -1) e.preventDefault();
    },
    true
  );

  /* --------------------------------------------------------------------------
     Envoi des formulaires client de Shopify

     La boutique a la protection anti-spam activée. Le script de Shopify
     s'accroche à l'ÉVÉNEMENT submit du formulaire : il l'intercepte, va
     chercher un jeton reCAPTCHA, l'ajoute au formulaire, puis laisse partir
     l'envoi. Construire un FormData et le poster soi-même avec fetch ne
     déclenche jamais cet événement : le jeton manque, et Shopify répond
     « 400 Missing CAPTCHA token ». Aucun contact n'était créé, aucun tag
     posé, et l'erreur passait inaperçue puisque la réponse n'était pas lue.

     On repasse donc par un envoi natif, le seul que Shopify accepte, mais
     dirigé vers un cadre masqué, pour que la page ne soit pas quittée.
     C'était tout l'objet de la garde ci-dessus.

     requestSubmit() déclenche l'événement submit, contrairement à submit()
     qui l'ignorerait et nous ramènerait au même problème.
     -------------------------------------------------------------------------- */
  window.lpEnvoiFormulaireClient = function (form) {
    if (!form) return false;

    var cadre = document.getElementById("lpFormSink");
    if (!cadre) {
      cadre = document.createElement("iframe");
      cadre.id = "lpFormSink";
      cadre.name = "lpFormSink";
      cadre.setAttribute("aria-hidden", "true");
      cadre.setAttribute("tabindex", "-1");
      cadre.style.cssText =
        "position:absolute;width:1px;height:1px;opacity:0;border:0;pointer-events:none;left:-9999px;top:-9999px;";
      document.body.appendChild(cadre);
    }

    function envoyer() {
      form.target = "lpFormSink";
      form.setAttribute("data-lp-native", "1");
      try {
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          /* Sans requestSubmit, un bouton temporaire produit le même
             événement submit, donc le même passage par hCaptcha. */
          var b = document.createElement("button");
          b.type = "submit";
          b.style.display = "none";
          form.appendChild(b);
          b.click();
          form.removeChild(b);
        }
      } catch (e) {}
      /* hCaptcha renvoie le formulaire lui-même une fois le jeton obtenu :
         le drapeau doit survivre à ce second passage. */
      setTimeout(function () { form.removeAttribute("data-lp-native"); }, 15000);
    }

    /* Shopify n'attache PAS automatiquement sa protection à ce formulaire :
       son dataset reste vide au chargement. Il faut la demander nous-mêmes.
       protect() insère le champ h-captcha-response et lie le formulaire ;
       le jeton, lui, n'est produit qu'au moment de l'envoi natif, c'est
       pourquoi les deux étapes sont nécessaires, dans cet ordre. */
    var protect = window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect;
    if (typeof protect !== "function" || form.dataset.cptcha === "true") {
      envoyer();
      return true;
    }

    var fait = false;
    var suite = function () {
      if (fait) return;
      fait = true;
      envoyer();
    };
    /* Si la protection ne répond pas, on envoie quand même : un refus du
       serveur vaut mieux qu'un formulaire qui ne part jamais. */
    setTimeout(suite, 6000);
    try { protect(form, suite); } catch (e) { suite(); }
    return true;
  };

  /* --------------------------------------------------------------------------
     1. Modales : hauteur réelle, défilement propre, champ visible au clavier

     Le clavier mobile recouvre le bas de l'écran sans réduire 100vh : le bas
     des formulaires devenait inatteignable. On suit visualViewport pour donner
     à la modale la hauteur réellement visible, on bloque le défilement du fond,
     et on ramène le champ actif dans la zone visible après l'ouverture du
     clavier. Un MutationObserver écoute la classe « is-open » : aucun point
     d'ouverture existant n'a besoin d'être modifié.
     -------------------------------------------------------------------------- */
  (function () {
    var ROOTS = ".lp-lock-modal, .lp-free-unlock-modal, .lp-choice-modal, .lp-riot-modal";
    var OPEN =
      ".lp-lock-modal.is-open, .lp-free-unlock-modal.is-open," +
      ".lp-choice-modal.is-open, .lp-riot-modal.is-open";
    var vv = window.visualViewport || null;
    var bound = false;

    function applyViewport() {
      if (!vv) return;
      var st = document.documentElement.style;
      st.setProperty("--lp-vvh", vv.height + "px");
      st.setProperty("--lp-vv-top", (vv.offsetTop || 0) + "px");
    }

    function clearViewport() {
      var st = document.documentElement.style;
      st.removeProperty("--lp-vvh");
      st.removeProperty("--lp-vv-top");
    }

    function bind() {
      if (bound || !vv) return;
      bound = true;
      vv.addEventListener("resize", applyViewport);
      vv.addEventListener("scroll", applyViewport);
    }

    function unbind() {
      if (!bound || !vv) return;
      bound = false;
      vv.removeEventListener("resize", applyViewport);
      vv.removeEventListener("scroll", applyViewport);
    }

    function update() {
      var open = document.querySelector(OPEN);
      document.documentElement.classList.toggle("lp-modal-open", !!open);
      if (open) {
        applyViewport();
        bind();
      } else {
        unbind();
        clearViewport();
      }
    }

    function watch() {
      var obs = new MutationObserver(update);
      var seen = [];
      Array.prototype.forEach.call(document.querySelectorAll(ROOTS), function (m) {
        if (seen.indexOf(m) > -1) return;
        seen.push(m);
        obs.observe(m, { attributes: true, attributeFilter: ["class"] });
      });
      update();
    }

    /* Le champ qui prend le focus est ramené au centre une fois le clavier
       déplié, le délai laisse à l'animation du clavier le temps de finir. */
    document.addEventListener("focusin", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest(".lp-lock-modal, .lp-free-unlock-modal, .lp-choice-modal")) return;
      setTimeout(function () {
        try {
          t.scrollIntoView({ block: "center", behavior: "smooth" });
        } catch (err) {}
      }, 280);
    });

    if (document.readyState === "loading") {
      lpWhenDomReady(watch);
    } else {
      watch();
    }
  })();

  /* --------------------------------------------------------------------------
     2. Suivi de stats : la zone s'active au clic ou au doigt

     Un iframe servi par un autre domaine renvoie son défilement à la page dès
     qu'il atteint sa fin, et aucune propriété côté parent ne peut l'en
     empêcher, c'est une limite du navigateur, pas un réglage oublié. On rend
     donc l'activation explicite, comme le font les cartes embarquées : tant
     que la zone n'est pas activée elle ne capte rien, la page défile
     normalement. Une fois activée, le tableau reste pleinement modifiable et
     un bouton « Terminer » rend la main.
     -------------------------------------------------------------------------- */
  (function () {
    var coarse = false;
    try {
      coarse = window.matchMedia("(pointer: coarse)").matches;
    } catch (e) {}
    var label = coarse ? "Appuie pour modifier ton suivi" : "Clique pour modifier ton suivi";

    function arm() {
      Array.prototype.forEach.call(document.querySelectorAll(".lp-sheet-wrap"), function (wrap) {
        if (wrap.getAttribute("data-lp-guard") === "1") return;
        if (!wrap.querySelector("iframe")) return;
        wrap.setAttribute("data-lp-guard", "1");

        var guard = document.createElement("button");
        guard.type = "button";
        guard.className = "lp-sheet-guard";
        guard.setAttribute("aria-label", label);
        var pill = document.createElement("span");
        pill.className = "lp-sheet-guard__pill";
        pill.textContent = label;
        guard.appendChild(pill);

        var release = document.createElement("button");
        release.type = "button";
        release.className = "lp-sheet-release";
        release.textContent = "Terminer";

        guard.addEventListener("click", function () {
          wrap.classList.add("is-live");
          if (window.lpTrack) window.lpTrack("sheet_activate", {});
        });
        release.addEventListener("click", function () {
          wrap.classList.remove("is-live");
        });

        wrap.appendChild(guard);
        wrap.appendChild(release);
      });
    }

    /* Un clic ailleurs rend la main : on ne reste pas piégé dans le tableau. */
    document.addEventListener("click", function (e) {
      Array.prototype.forEach.call(document.querySelectorAll(".lp-sheet-wrap.is-live"), function (w) {
        if (!w.contains(e.target)) w.classList.remove("is-live");
      });
    });

    function start() {
      arm();
      /* Le tableau relié par l'élève est injecté après coup : on réarme. */
      var panel = document.getElementById("lpPanelStats");
      if (panel && window.MutationObserver) {
        new MutationObserver(arm).observe(panel, { childList: true, subtree: true });
      }
    }

    if (document.readyState === "loading") {
      lpWhenDomReady(start);
    } else {
      start();
    }
  })();

  /* --------------------------------------------------------------------------
     3. Parcours d'entrée : six écrans, une question par écran

     Visiteurs non connectés, première visite. Les réponses partent en tags
     client (role-, rank-, source-, objectif-) via le formulaire client
     Shopify, posté en arrière-plan, la page ne recharge jamais et aucun
     bouton n'est de type submit.

     Les réponses sont enregistrées à chaque écran : un visiteur qui ferme
     et revient reprend là où il s'était arrêté, et son email part quand
     même si le parcours n'a pas été terminé.
     -------------------------------------------------------------------------- */
  (function () {
    var K = "lp_ob_v1";
    var ob = document.getElementById("lpOnboard");
    if (!ob) return;

    /* 8 écrans depuis que la provenance est posée après l'analyse.
       La valeur vient du template quand elle y est définie. */
    var SCREENS = (typeof LP_OB_SCREENS === "number" && LP_OB_SCREENS > 0) ? LP_OB_SCREENS : 9;
    var RIOT_REQUIS = (typeof LP_OB_RIOT_REQUIS === "boolean") ? LP_OB_RIOT_REQUIS : true;
    var screens = Array.prototype.slice.call(ob.querySelectorAll("[data-ob-screen]"));
    var bar = document.getElementById("lpObBar");
    var count = document.getElementById("lpObCount");
    var next = document.getElementById("lpObNext");
    var back = document.getElementById("lpObBack");
    var err = document.getElementById("lpObErr");
    var nameEl = document.getElementById("lpObName");
    var mailEl = document.getElementById("lpObMail");
    var qMail = document.getElementById("lpObQMail");
    var discordEl = document.getElementById("lpObDiscordUsername");
    var discordErr = document.getElementById("lpObDiscordError");
    if (discordEl) {
      discordEl.value = window.lpAccountStorage.getItem("lp_discord_username_v1") || "";
      discordEl.addEventListener("input", function () {
        var ok = lpValidDiscordUsername(discordEl.value);
        if (discordErr) discordErr.textContent = ok ? "" : "Utilise ton nom d’utilisateur Discord exact, sans email.";
        if (ok) lpUpdateDiscordUsername(discordEl.value);
        if (next) next.disabled = !valid(step);
      });
      discordEl.addEventListener("blur", function () { if (lpUpdateDiscordUsername(discordEl.value)) discordEl.value = lpNormaliseDiscordUsername(discordEl.value); });
      window.addEventListener("lp-discord-username-change", function (event) { discordEl.value = event.detail.value; });
    }

    /* Téléphone (classe posée en tête du template, sous 768 px) : parcours
       court. Le prénom devient facultatif, l'email et le rôle déjà donnés
       dans le parcours guidé sont sautés, et le Riot ID peut attendre.
       Le bureau garde ses 8 écrans à l'identique. */
    var MOBILE = document.documentElement.classList.contains("lp-m");
    var debut = 0;

    function read() {
      try {
        return JSON.parse(window.lpAccountStorage.getItem(K) || "{}") || {};
      } catch (e) {
        return {};
      }
    }

    function write() {
      try {
        window.lpAccountStorage.setItem(K, JSON.stringify(data));
      } catch (e) {}
    }

    var data = read();
    var step = 0;
    var autoTimer = null;
    var AUTO = ["role", "rank", "source", "objectif"];

    bar.style.gridTemplateColumns = "repeat(" + SCREENS + ",minmax(0,1fr))";
    for (var i = 0; i < SCREENS; i++) {
      var seg = document.createElement("i");
      bar.appendChild(seg);
    }
    var segs = Array.prototype.slice.call(bar.children);

    /* ---- Validation par écran ---- */

    function riotDonne() {
      return !!((data.riotName || "").trim() && (data.riotTag || "").trim());
    }

    function valid(s) {
      if (s === 8) return lpValidDiscordUsername(discordEl ? discordEl.value : window.lpAccountStorage.getItem("lp_discord_username_v1"));
      if (s === 0) return MOBILE || !!(data.name && data.name.trim());
      if (s === 1) {
        var m = (data.email || "").trim();
        return m.indexOf("@") > 0 && m.indexOf(".", m.indexOf("@")) > 0;
      }
      if (s === 2) return !!data.role;
      if (s === 3) return !!data.rank;
      /* Division, LP et LP par game ont des valeurs par défaut : l'écran
         ne bloque pas, il précise. */
      if (s === 4) return true;
      if (s === 5) return !!data.objectif;
      /* Riot ID : requis, parce qu'il conditionne la récupération des stats.
         L'interrupteur LP_OB_RIOT_REQUIS, posé dans le template, permet de
         revenir à l'ancien comportement facultatif sans toucher à ce code. */
      if (s === 6) {
        if (!RIOT_REQUIS || MOBILE) return true;
        return riotDonne();
      }
      /* Les moyennes restent facultatives : on n'y bloque personne. */
      return true;
    }

    function paint() {
      screens.forEach(function (sc) {
        sc.classList.toggle("is-on", Number(sc.getAttribute("data-ob-screen")) === step);
      });
      segs.forEach(function (sg, i) {
        sg.classList.toggle("is-done", i <= step);
      });
      count.textContent = step + 1 + " sur " + SCREENS;
      if (MOBILE) {
        /* Compteur et barre comptés depuis le premier écran vraiment
           montré : « Étape 1 sur 5 », pas « 4 sur 8 ». */
        segs.forEach(function (sg, i) { sg.style.display = i < debut ? "none" : ""; });
        bar.style.gridTemplateColumns = "repeat(" + (SCREENS - debut) + ",minmax(0,1fr))";
        count.textContent = "Étape " + (step - debut + 1) + " sur " + (SCREENS - debut) +
          (step === SCREENS - 1 ? "" : " · ton analyse arrive");
      }
      var opt = document.getElementById("lpObOpt");
      /* Seul l'écran des moyennes reste facultatif. */
      if (opt) opt.hidden = step !== 7 && step !== 8;
      if (step === 4) syncDivs();
      if (step === 7) buildOpgg();
      back.hidden = step === 0 || (MOBILE && step <= debut);
      next.textContent = step === SCREENS - 1 ? "Accéder à mon analyse" : "Suivant";
      if (MOBILE && step === 6 && !riotDonne()) next.textContent = "Suivant";
      next.disabled = !valid(step);
      if (err) err.textContent = "";
      if (step === 1 && qMail && data.name) {
        qMail.textContent = "Enchanté " + data.name.trim() + ", ton email ?";
      }
      var focusable = screens[step].querySelector("input");
      if (focusable && !isCoarse()) setTimeout(function () { focusable.focus(); }, 60);
    }

    function isCoarse() {
      try {
        return window.matchMedia("(pointer: coarse)").matches;
      } catch (e) {
        return false;
      }
    }

    /* ---- Master et au-dessus n'ont pas de division ---- */
    function syncDivs() {
      var wrap = document.getElementById("lpObDivWrap");
      if (!wrap) return;
      var sansDiv = ["MASTER", "GRANDMASTER", "CHALLENGER"].indexOf(data.rank) > -1;
      wrap.style.display = sansDiv ? "none" : "";
      if (sansDiv) { data.div = ""; write(); }
    }

    /* ---- Lien OP.GG ----
       OP.GG interdit l'affichage dans un cadre et je ne peux pas cadrer la
       page d'un autre domaine sur une ligne précise : le lien s'ouvre donc
       dans un onglet, avec les stats sous les yeux à côté du formulaire. */
    function buildOpgg() {
      var a = document.getElementById("lpObOpgg");
      if (!a) return;
      var n = (data.riotName || "").trim();
      var t = (data.riotTag || "").trim().replace(/^#/, "");
      if (n && t) {
        a.href = "https://op.gg/lol/summoners/" + (data.region || "euw") +
          "/" + encodeURIComponent(n) + "-" + encodeURIComponent(t) + "/champions";
      } else {
        a.href = "https://op.gg";
      }
    }

    /* ---- Envoi en arrière-plan ---- */

    function send() {
      var form = document.getElementById("lpObForm") || ob.querySelector("form");
      if (!form || !data.email) return;
      /* Jamais d'adresse incomplète vers Shopify : fermer le parcours au
         milieu de la saisie envoyait ce qui était tapé, avec le tag
         newsletter. Même contrôle que la fenêtre masterclass. */
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(data.email).trim())) return;

      var tags = ["newsletter", "utilise-dashboard"];
      if (data.role) tags.push("role-" + data.role);
      if (data.rank) tags.push("rank-" + String(data.rank).toLowerCase());
      if (data.source) tags.push("source-" + data.source);
      if (data.objectif) tags.push("objectif-" + data.objectif);

      var set = function (id, v) {
        var el = document.getElementById(id);
        if (el) el.value = v;
      };
      set("lpObTags", tags.join(","));
      set("lpObFirst", (data.name || "").trim());
      set("lpObEmail", (data.email || "").trim());

      data.sent = 1;
      write();

      if (window.lpEnvoiFormulaireClient) {
        window.lpEnvoiFormulaireClient(form);
      }

      if (window.lpTrack) {
        window.lpTrack("onboarding_submit", { role: data.role, rank: data.rank, source: data.source, objectif: data.objectif });
      }
    }

    /* ---- Ouverture / fermeture ---- */

    function open() {
      ob.hidden = false;
      void ob.offsetHeight;
      ob.classList.add("is-on");
      document.documentElement.classList.add("lp-modal-open");
      paint();
      if (window.lpTrack) window.lpTrack("onboarding_open", {});
    }

    function close() {
      ob.classList.remove("is-on");
      document.documentElement.classList.remove("lp-modal-open");
      setTimeout(function () { ob.hidden = true; }, 260);
    }

    function finish() {
      send();
      data.done = 1;
      write();

      /* Rank, rôle et moyennes sont écrits dans l'état de la synthèse :
         l'élève arrive sur un tableau de bord déjà réglé, sans ressaisie. */
      var put = function (k, v) {
        try { window.lpAccountStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
      };
      if (data.role) put("lp_synth_role_v2", data.role);
      if (data.rank) {
        put("lp_synth_mode_v2", "manual");
        put("lp_synth_base_v2", {
          tier: data.rank,
          div: data.div || "IV",
          lp: data.lp > 0 ? data.lp : 0,
          anchor: 0
        });
        put("lp_synth_mmr_v2", {
          gain: data.gain > 0 ? data.gain : 25,
          loss: data.loss > 0 ? data.loss : 20
        });
      }
      var st = data.stats || {};
      if (st.games > 0) {
        put("lp_synth_baseline_v2", {
          games: st.games, wr: st.wr == null ? null : st.wr, cs: st.cs == null ? null : st.cs,
          kda: st.kda == null ? null : st.kda, kp: st.kp == null ? null : st.kp,
          dpm: st.dpm == null ? null : st.dpm, gpm: st.gpm == null ? null : st.gpm,
          early: st.early == null ? null : st.early
        });
      }
      if (window.lpSynthRefresh) window.lpSynthRefresh();
      greet();

      /* L'email donné vaut accès à la masterclass offerte. */
      try {
        if (typeof lpSetLocalFreeUnlock === "function") lpSetLocalFreeUnlock();
      } catch (e) {}
      if (window.lpRefreshFreeMasterclassAccessUI) window.lpRefreshFreeMasterclassAccessUI();

      close();
      if (typeof window.lpActivateDashboardTab === "function") {
        window.lpActivateDashboardTab("lpPanelSynthese");
      }
    }

    /* ---- Interactions ---- */

    if (nameEl) {
      nameEl.addEventListener("input", function () {
        data.name = nameEl.value;
        write();
        next.disabled = !valid(step);
      });
    }

    if (mailEl) {
      mailEl.addEventListener("input", function () {
        data.email = mailEl.value;
        write();
        next.disabled = !valid(step);
      });
    }

    [["lpObRiot", "riotName"], ["lpObTag", "riotTag"], ["lpObRegion", "region"]].forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (!el) return;
      /* Depuis que cet ecran peut bloquer, la saisie doit reevaluer le
         bouton : sans cette ligne, il reste desactive meme une fois le
         pseudo et le tag remplis, et le parcours s arrete la. */
      el.addEventListener("input", function () {
        data[pair[1]] = el.value;
        write();
        next.disabled = !valid(step);
        libelleRiot();
      });
      el.addEventListener("change", function () {
        data[pair[1]] = el.value;
        write();
        next.disabled = !valid(step);
        libelleRiot();
      });
    });

    /* Mobile : le bouton dit ce qu'il fera, passer ou continuer. */
    function libelleRiot() {
      if (!MOBILE || step !== 6) return;
      next.textContent = "Suivant";
    }

    [["lpObLp", "lp"], ["lpObGain", "gain"], ["lpObLoss", "loss"]].forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (!el) return;
      el.addEventListener("input", function () {
        var v = parseInt(el.value, 10);
        data[pair[1]] = isNaN(v) ? null : v;
        write();
      });
    });

    var STAT_FIELDS = [["lpObGames", "games"], ["lpObWr", "wr"], ["lpObCs", "cs"], ["lpObKda", "kda"],
                       ["lpObKp", "kp"], ["lpObDpm", "dpm"], ["lpObGpm", "gpm"], ["lpObEarly", "early"]];
    STAT_FIELDS.forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (!el) return;
      el.addEventListener("input", function () {
        data.stats = data.stats || {};
        var v = parseFloat(el.value);
        data.stats[pair[1]] = isNaN(v) ? null : v;
        write();
      });
    });

    ob.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      e.preventDefault();
      if (!next.disabled) next.click();
    });

    Array.prototype.forEach.call(ob.querySelectorAll("[data-ob-pick]"), function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-ob-pick");
        data[key] = btn.getAttribute("data-value");
        write();
        var group = btn.parentElement;
        Array.prototype.forEach.call(group.children, function (b) {
          b.classList.toggle("is-on", b === btn);
        });
        next.disabled = false;
        /* Un choix suffit : on enchaîne sans faire cliquer deux fois -
           sauf sur l'écran du rank exact, qui porte aussi les LP. */
        if (AUTO.indexOf(key) < 0) return;
        clearTimeout(autoTimer);
        autoTimer = setTimeout(function () {
          if (step < SCREENS - 1) { step++; paint(); }
        }, 190);
      });
    });

    next.addEventListener("click", function () {
      clearTimeout(autoTimer);
      if (!valid(step)) {
        if (step === 1 && err) err.textContent = "Cet email ne semble pas valide.";
        return;
      }
      if (step === SCREENS - 1) { finish(); return; }
      /* Mobile sans Riot ID : l'écran des moyennes demanderait une saisie
         à la main depuis OP.GG. On va directement à l'analyse. */
      if (MOBILE && step === 6 && !riotDonne()) { step = 8; paint(); return; }
      /* L'email est envoyé dès qu'il est connu : un abandon plus loin dans
         le parcours ne fait pas perdre le contact. */
      if (step === 1 && !data.sent) send();
      step++;
      paint();
    });

    back.addEventListener("click", function () {
      clearTimeout(autoTimer);
      if (step > 0) { step = MOBILE && step === 8 && !riotDonne() ? 6 : step - 1; paint(); }
    });

    document.getElementById("lpObClose").addEventListener("click", function () {
      data.closed = 1;
      write();
      if (!data.sent) send();
      close();
      if (window.lpTrack) window.lpTrack("onboarding_close", { step: step + 1 });
    });

    /* ---- Salutation en haut du tableau de bord ---- */
    function greet() {
      var el = document.getElementById("lpHello");
      if (!el) return;
      var who = (data.riotName || data.name || "").trim();
      if (!who) { el.hidden = true; return; }
      el.textContent = "Bonjour, " + who;
      el.hidden = false;
    }

    /* ---- Reprise + ouverture initiale ---- */

    Array.prototype.forEach.call(ob.querySelectorAll("[data-ob-pick]"), function (btn) {
      var key = btn.getAttribute("data-ob-pick");
      if (data[key] === btn.getAttribute("data-value")) btn.classList.add("is-on");
    });
    if (nameEl && data.name) nameEl.value = data.name;
    if (mailEl && data.email) mailEl.value = data.email;
    [["lpObRiot", "riotName"], ["lpObTag", "riotTag"], ["lpObRegion", "region"]].forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (el && data[pair[1]]) el.value = data[pair[1]];
    });
    [["lpObLp", "lp"], ["lpObGain", "gain"], ["lpObLoss", "loss"]].forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (el && data[pair[1]] !== null && data[pair[1]] !== undefined) el.value = data[pair[1]];
    });
    if (data.stats) {
      STAT_FIELDS.forEach(function (pair) {
        var el = document.getElementById(pair[0]);
        var v = data.stats[pair[1]];
        if (el && v !== null && v !== undefined) el.value = v;
      });
    }
    greet();

    /* Premier écran sans réponse. Sur mobile, le Riot ID n'est pas sauté
       en silence : il est facultatif, mais on le propose. */
    function premierEcran() {
      var s = 0;
      while (s < SCREENS - 1 && valid(s) && !(MOBILE && s === 6 && !riotDonne())) s++;
      return s;
    }

    step = premierEcran();
    if (MOBILE) debut = step;

    /* Pont avec la fenêtre masterclass, qui passe désormais avant le
       formulaire et l'ouvre au clic sur « continuer ». */
    window.lpParcours = {
      /* L'email donné pour débloquer la masterclass pré-remplit celui du
         formulaire, pour ne pas le faire retaper. Le parcours guidé du
         mobile transmet aussi le rôle déjà choisi (extra.role). */
      ouvrir: function (email, extra) {
        if (MOBILE) {
          /* Réponses du parcours guidé (rôle, email), s'il a été suivi. */
          try {
            var guide = JSON.parse(window.lpAccountStorage.getItem("lp_guide_v1") || "{}") || {};
            if (!(extra && extra.role) && guide.role) extra = { role: guide.role };
            if (!email && guide.email) email = guide.email;
          } catch (e) {}
        }
        if (typeof email === "string" && email && !data.email) {
          data.email = email;
          if (mailEl) mailEl.value = email;
        }
        if (extra && extra.role && !data.role) {
          data.role = extra.role;
          Array.prototype.forEach.call(ob.querySelectorAll('[data-ob-pick="role"]'), function (b) {
            b.classList.toggle("is-on", b.getAttribute("data-value") === data.role);
          });
        }
        data.closed = 0;
        write();
        if (MOBILE) {
          /* Les réponses déjà connues sont sautées : on repart du premier
             écran qui manque. */
          step = premierEcran();
          debut = step;
        }
        open();
      },
      fermer: function () {
        data.closed = 1;
        write();
        if (!data.sent) send();
      }
    };

    /* Tant que la fenêtre est à l'écran, c'est elle qui ouvrira le
       formulaire. Sans elle dans la page, tout se passe comme avant. */
    var mcPresente = !!document.getElementById("lpMasterclassOffert");
    var mcVue = false;
    try { mcVue = window.lpAccountStorage.getItem("lp_mc_vue") === "1"; } catch (e) {}

    if (window.__lpMcOuvrirParcours) {
      /* Clic sur « continuer » avant que ce fichier soit chargé. */
      var emailEnAttente = window.__lpMcOuvrirParcours;
      window.__lpMcOuvrirParcours = false;
      window.lpParcours.ouvrir(typeof emailEnAttente === "string" ? emailEnAttente : "");
    } else if (window.__lpMcFermerParcours) {
      window.__lpMcFermerParcours = false;
      window.lpParcours.fermer();
    } else if (!data.done && !data.closed && (!mcPresente || mcVue) &&
               !document.documentElement.classList.contains("lp-m-guide")) {
      /* Parcours guidé du mobile en cours : c'est lui qui ouvrira. */
      open();
    } else if (!data.done && !data.sent && data.email) {
      /* Parcours abandonné à une visite précédente : on envoie ce qu'on a. */
      send();
    }

    /* Un visiteur qui a fermé sans finir peut reprendre depuis la synthèse. */
    document.addEventListener("click", function (e) {
      if (data.done) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest("#lpSynthManualBtn")) return;
      e.preventDefault();
      e.stopPropagation();
      /* Mobile : même entrée que le parcours guidé, réponses connues sautées. */
      if (MOBILE) { window.lpParcours.ouvrir(""); return; }
      data.closed = 0;
      write();
      open();
    }, true);
  })();

  /* --------------------------------------------------------------------------
     4. Le rôle et le rank donnés à l'entrée pré-remplissent les réglages,
        pour que le visiteur ne les ressaisisse pas deux fois.
     -------------------------------------------------------------------------- */
  (function () {
    function prefill() {
      var role = null;
      var tier = null;
      try {
        role = window.lpAccountStorage.getItem("lp_lead_role");
        tier = window.lpAccountStorage.getItem("lp_lead_tier");
      } catch (e) {
        return;
      }
      if (!role && !tier) return;

      var roleEl = document.getElementById("lpSetRole");
      var tierEl = document.getElementById("lpSetTier");
      if (role && roleEl && !roleEl.getAttribute("data-lp-touched")) {
        roleEl.value = role;
        roleEl.setAttribute("data-lp-touched", "1");
      }
      if (tier && tierEl && !tierEl.getAttribute("data-lp-touched")) {
        tierEl.value = tier;
        tierEl.setAttribute("data-lp-touched", "1");
      }
    }

    if (document.readyState === "loading") {
      lpWhenDomReady(prefill);
    } else {
      prefill();
    }
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (t && t.closest && t.closest("#lpSettingsBtn, #lpSynthManualBtn")) setTimeout(prefill, 60);
    });
  })();

  /* --------------------------------------------------------------------------
     5. L'objectif déclaré à l'entrée pilote ce qu'on met en avant

     Il était collecté, envoyé en tag, puis ignoré. Quatre réponses, quatre
     personnes différentes : autant leur montrer ce qu'elles sont venues
     chercher.

     La destination des CTA n'est pas modifiée, elle doit rester figée
     pendant le test du hero. Seul l'accent change.
     -------------------------------------------------------------------------- */
  (function () {
    var carte = document.getElementById("lpGoalCard");
    if (!carte) return;

    var objectif = null;
    try {
      objectif = (JSON.parse(window.lpAccountStorage.getItem("lp_ob_v1") || "{}") || {}).objectif || null;
    } catch (e) {
      return;
    }
    if (!objectif) return;

    var CARTES = {
      "etre-coache": {
        titre: "Tu veux être coaché.",
        sous: "Deux sessions privées par mois, ton coach analyse tes games en direct.",
        bouton: "Voir les formules",
        href: "/pages/tableau-offres",
        cta: "objectif-coache"
      },
      "monter-rank": {
        titre: "Ton objectif de rank est-il réaliste ?",
        sous: "Le calculateur te donne le nombre de games et la date.",
        bouton: "Ouvrir le calculateur",
        onglet: "lpPanelOutils",
        ancre: "lpToolCalc"
      },
      "comprendre-jeu": {
        titre: "Commence par le starter pack de ton rôle.",
        sous: "Les masterclass à regarder en priorité, dans l'ordre.",
        bouton: "Voir les masterclass",
        onglet: "lpPanelMasterclass"
      }
      /* « Jouer sans prise de tête » : rien. Insister n'aurait pas de sens. */
    };

    var c = CARTES[objectif];
    if (!c) return;

    var action = c.href
      ? '<a class="lp-goal__btn" href="' + c.href + '" data-lp-offers-cta="' + c.cta + '">' + c.bouton + "</a>"
      : '<button type="button" class="lp-goal__btn" id="lpGoalBtn">' + c.bouton + "</button>";

    carte.innerHTML =
      '<div class="lp-goal__body">' +
      '<span class="lp-goal__title">' + c.titre + "</span>" +
      '<span class="lp-goal__sub">' + c.sous + "</span>" +
      "</div>" +
      action;
    carte.hidden = false;

    var btn = document.getElementById("lpGoalBtn");
    if (btn) {
      btn.addEventListener("click", function () {
        if (typeof window.lpActivateDashboardTab === "function") {
          window.lpActivateDashboardTab(c.onglet);
        }
        if (c.ancre) {
          setTimeout(function () {
            var a = document.getElementById(c.ancre);
            if (a) a.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 180);
        }
      });
    }

    if (window.lpTrack) window.lpTrack("goal_card_shown", { objectif: objectif });
  })();

  /* --------------------------------------------------------------------------
     6. Le bouton du bloc coach ouvre le même choix de format que le CTA haut.
     -------------------------------------------------------------------------- */
  (function () {
    var btn = document.getElementById("lpCoachBtn");
    if (!btn) return;
    btn.addEventListener("click", function () {
      if (window.lpOpenChoiceModal) window.lpOpenChoiceModal();
    });
  })();



/* ============================================================================
   LOT 3, Provenance posée après l'analyse, et point d'entrée pour le
   remplissage automatique des moyennes.
   ============================================================================ */

/* --- Provenance ------------------------------------------------------------
   La question sortait du parcours d'entrée, où elle retardait le résultat
   sans rien apporter au visiteur. Elle est désormais posée sous les
   recommandations, une fois l'analyse rendue.
   La réponse part dans les analytics (lpTrack), pas dans les tags client :
   le compte est créé dès l'écran email, donc bien avant. Si le compte n'a
   pas encore été envoyé, la réponse est quand même stockée et le tag partira
   avec l'envoi différé.
   -------------------------------------------------------------------------- */
(function () {
  var CLE = "lp_ob_v1";
  var carte = document.getElementById("lpSourceCard");
  if (!carte) return;

  function lire() {
    try { return JSON.parse(window.lpAccountStorage.getItem(CLE) || "{}") || {}; }
    catch (e) { return {}; }
  }
  function ecrire(o) {
    try { window.lpAccountStorage.setItem(CLE, JSON.stringify(o)); } catch (e) {}
  }

  function afficher() {
    var d = lire();
    /* On ne la montre qu'à qui a terminé le parcours et n'a pas déjà répondu. */
    carte.hidden = !(d.done && !d.source);
  }

  Array.prototype.forEach.call(carte.querySelectorAll("[data-lp-source]"), function (btn) {
    btn.addEventListener("click", function () {
      var valeur = btn.getAttribute("data-lp-source");
      var d = lire();
      d.source = valeur;
      ecrire(d);

      Array.prototype.forEach.call(carte.querySelectorAll("[data-lp-source]"), function (b) {
        b.classList.toggle("is-on", b === btn);
      });

      var merci = document.getElementById("lpSourceThanks");
      if (merci) merci.hidden = false;

      if (window.lpTrack) window.lpTrack("onboarding_source", { source: valeur });

      setTimeout(function () { carte.hidden = true; }, 1400);
    });
  });

  afficher();
  /* Le parcours se termine sans rechargement : on repasse après sa fermeture. */
  document.addEventListener("click", function () { setTimeout(afficher, 400); }, true);
})();

/* --- Remplissage automatique des moyennes ----------------------------------
   Rien n'est branché ici : la source des stats n'est pas encore décidée.
   Ce point d'entrée existe pour que le branchement ne demande qu'un appel,
   sans retoucher au parcours. Il remplit les 8 champs, déclenche les
   événements input pour que la sauvegarde locale suive, et rend la main.

   Usage, une fois l'API disponible :
     window.lpRemplirStats({ games: 561, wr: 53, cs: 8.1, kda: 2.79,
                             kp: 49, dpm: 908, gpm: 495, early: 51 });

   Les clés absentes sont ignorées, les champs correspondants restent
   modifiables à la main.
   -------------------------------------------------------------------------- */
window.lpRemplirStats = function (stats) {
  if (!stats || typeof stats !== "object") return 0;

  var CHAMPS = {
    games: "lpObGames", wr: "lpObWr", cs: "lpObCs", kda: "lpObKda",
    kp: "lpObKp", dpm: "lpObDpm", gpm: "lpObGpm", early: "lpObEarly"
  };

  var remplis = 0;
  Object.keys(CHAMPS).forEach(function (cle) {
    var valeur = stats[cle];
    if (valeur === null || valeur === undefined || valeur === "") return;
    var el = document.getElementById(CHAMPS[cle]);
    if (!el) return;
    el.value = valeur;
    /* L'événement input est ce qui alimente lp_ob_v1 : sans lui, la valeur
       serait affichée mais jamais enregistrée. */
    el.dispatchEvent(new Event("input", { bubbles: true }));
    remplis++;
  });

  if (remplis && window.lpTrack) window.lpTrack("stats_remplies_auto", { champs: remplis });
  return remplis;
};

/* ============================================================================
   DERNIER ÉCRAN DU PARCOURS  /  RÉCUPÉRATION ET RESTITUTION DES STATS
   ============================================================================

   Le Riot ID vient d'être donné à l'écran précédent : l'appel part seul, on
   ne redemande rien.

   POURQUOI UNE BOUCLE. Sur un compte jamais vu, Legends Tracker l'inscrit et
   ne rapatrie qu'une partie de la saison, puis complète en arrière-plan.
   Chaque appel en ramène davantage. Un appel unique rendrait donc un bilan
   calculé sur 40 parties au lieu de 220, c'est-à-dire un bilan faux. On
   boucle tant que le compteur monte, dans une limite de temps, et on
   n'affiche qu'à la fin.

   LA BARRE N'EST PAS DÉCORATIVE : sa largeur vaut parties stockées sur
   parties de la saison. Elle n'avance que quand le rapatriement avance.

   BORNES. Vingt tentatives espacées de 1,6 seconde, soit une trentaine de
   secondes au pire. On s'arrête avant si la saison est complète, ou si trois
   appels d'affilée n'apportent plus rien : au-delà, c'est le cron de Legends
   Tracker qui prend le relais, toutes les dix minutes, et attendre devant un
   écran ne sert plus à rien. L'API tolère 120 requêtes par minute et par IP,
   or tous les visiteurs passent par le même relais : d'où l'espacement.
   ========================================================================= */
(function () {
  var ecran = document.querySelector('[data-ob-screen="7"]');
  if (!ecran) return;

  var ENDPOINT = (typeof LP_TRACKER_ENDPOINT === "string") ? LP_TRACKER_ENDPOINT.trim() : "";

  var load = document.getElementById("lpFetchLoad");
  var res = document.getElementById("lpFetchRes");
  var grid = document.getElementById("lpFetchGrid");
  var msg = document.getElementById("lpFetchMsg");
  var credit = document.getElementById("lpFetchCredit");
  var manuel = document.getElementById("lpObManual");
  var attente = document.getElementById("lpFetchAttente");
  var attenteTitre = document.getElementById("lpFetchAttenteTitre");
  var attenteManuel = document.getElementById("lpFetchManuelAttente");
  var K_ATTENTE = "lp_stats_attente_v1";
  var lienManuel = document.getElementById("lpFetchManual");
  var titre = document.getElementById("lpObStatsTitre");
  var etape = document.getElementById("lpFetchStep");
  var barre = document.getElementById("lpFetchBar");
  var barreWrap = document.getElementById("lpFetchBarWrap");
  var compteur = document.getElementById("lpFetchCount");

  var boutonSuivant = document.getElementById("lpObNext");

  var CLE = "lp_ob_v1";
  /* Legends Tracker rapatrie la saison en arrière-plan : on l'attend
     réellement, barre à l'appui, au lieu de couper au bout de quelques
     secondes. Trois minutes de patience, puis l'écran « tes stats arrivent »
     prend le relais et le tableau de bord continue tout seul. */
  var MAX_TENTATIVES = 60;
  var DELAI = 3000;

  var etat = "attente";

  /* La barre se lit en deux temps.
     Première moitié : la récupération des parties, affichée au double du
     ratio réel pour qu'elle ne semble jamais figée. Le compteur sous la
     barre, lui, reste exact.
     Seconde moitié : le traitement, déroulé une fois les parties en main. */
  var ANALYSE = [
    "Analyse de ton profil",
    "Comparaison aux repères de ton rôle",
    "Application des recommandations des coachs",
    "Construction de ton tableau de bord",
    "Génération de tes recommandations"
  ];

  function lireLocal() {
    try { return JSON.parse(window.lpAccountStorage.getItem(CLE) || "{}") || {}; }
    catch (e) { return {}; }
  }

  function attendre(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function poser(pct, texte) {
    pct = Math.max(0, Math.min(100, Math.round(pct)));
    if (barre) barre.style.width = pct + "%";
    if (barreWrap) barreWrap.setAttribute("aria-valuenow", String(pct));
    if (texte && etape) etape.textContent = texte;
  }

  /* Récupération : la barre occupe la première moitié, au double du ratio
     réel. Le compteur affiche le vrai nombre de parties. */
  var departRecup = 0;

  function avancer(ratio, stockees, saison) {
    if (saison && stockees) {
      poser(Math.min(50, ratio * 2 * 50), "Récupération de tes parties");
      if (compteur) compteur.textContent = stockees + " parties analysées sur " + saison;
      return;
    }
    /* Saison encore inconnue : la barre suit le temps d'attente, sans jamais
       prétendre que c'est fini. */
    var ecoule = departRecup ? (Date.now() - departRecup) / 1000 : 0;
    poser(Math.min(42, 6 + ecoule * 0.25), "Legends Tracker récupère tes parties");
    if (compteur) {
      compteur.textContent = saison
        ? "0 partie analysée sur " + saison + ", ça peut prendre quelques minutes"
        : "Première analyse de ton compte, ça peut prendre quelques minutes";
    }
  }

  /* Traitement : la seconde moitié, une fois les parties en main. */
  async function derouler(stockees) {
    if (compteur) compteur.textContent = stockees + " parties analysées";
    for (var i = 0; i < ANALYSE.length; i++) {
      poser(50 + ((i + 1) / ANALYSE.length) * 50, ANALYSE[i]);
      await attendre(420);
    }
  }

  /* Legends Tracker vient de découvrir ce compte : sa saison arrive dans les
     minutes qui suivent. Personne ne saisit rien, le tableau de bord ira la
     chercher tout seul (voir relanceAuto dans la synthèse). */
  function montrerAttente(texte) {
    if (load) load.hidden = true;
    if (res) res.hidden = true;
    if (manuel) manuel.hidden = true;
    if (attente) attente.hidden = false;
    if (attenteTitre && texte) attenteTitre.textContent = texte;
    if (titre) titre.textContent = "Tes stats arrivent";
    var d = lireLocal();
    try {
      window.lpAccountStorage.setItem(K_ATTENTE, JSON.stringify({
        nom: (d.riotName || "").trim(),
        tag: (d.riotTag || "").trim().replace(/^#/, ""),
        region: d.region || "euw",
        t: 0
      }));
    } catch (e) {}
    if (window.lpTrack) window.lpTrack("stats_auto_attente", {});
  }

  if (attenteManuel) {
    attenteManuel.addEventListener("click", function () {
      if (attente) attente.hidden = true;
      montrerManuel("");
    });
  }

  function montrerManuel(texte) {
    if (load) load.hidden = true;
    if (res) res.hidden = true;
    if (attente) attente.hidden = true;
    if (manuel) manuel.hidden = false;
    if (titre) titre.textContent = "Tes moyennes de la saison";
    if (msg) {
      msg.textContent = texte || "";
      msg.className = "lp-fetch__msg" + (texte ? " is-ko" : "");
    }
  }

  /* Les huit valeurs récupérées, toutes restituées. La liste doit rester
     alignée sur les huit champs du formulaire : en restituer moins revient
     à masquer des stats qu'on a pourtant analysées. */
  var TUILES = [
    { cle: "games", nom: "Parties", suffixe: "" },
    { cle: "wr", nom: "Winrate", suffixe: " %" },
    { cle: "cs", nom: "CS / min", suffixe: "" },
    { cle: "kda", nom: "KDA", suffixe: "" },
    { cle: "kp", nom: "Participation", suffixe: " %" },
    { cle: "dpm", nom: "Dégâts / min", suffixe: "" },
    { cle: "gpm", nom: "Golds / min", suffixe: "" },
    { cle: "early", nom: "Lanes gagnées", suffixe: " %" }
  ];

  function afficher(valeurs, couverture, attribution) {
    if (load) load.hidden = true;
    if (manuel) manuel.hidden = true;
    if (attente) attente.hidden = true;
    try { window.lpAccountStorage.removeItem(K_ATTENTE); } catch (e) {}
    if (msg) { msg.textContent = ""; msg.className = "lp-fetch__msg"; }
    if (titre) titre.textContent = "Voilà où tu en es";

    var html = "";
    TUILES.forEach(function (tu) {
      var v = valeurs[tu.cle];
      if (v === null || v === undefined) return;
      var aff = (typeof v === "number") ? v.toLocaleString("fr-FR") : v;
      html += '<div class="lp-fetch__tile"><b>' + aff + tu.suffixe + "</b><span>" + tu.nom + "</span></div>";
    });
    if (grid) grid.innerHTML = html;

    if (credit && attribution && attribution.url) {
      credit.href = attribution.url;
      credit.textContent = attribution.label || "via Legends Tracker";
    }

    if (res) res.hidden = false;
  }

  async function unAppel(url) {
    var ctrl = ("AbortController" in window) ? new AbortController() : null;
    var minuteur = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    try {
      var r = await fetch(url, { method: "GET", cache: "no-store", signal: ctrl ? ctrl.signal : undefined });
      var data = null;
      try { data = await r.json(); } catch (e) { data = null; }
      return { statut: r.status, ok: r.ok, data: data };
    } finally {
      if (minuteur) clearTimeout(minuteur);
    }
  }

  async function recuperer() {
    if (etat !== "attente") return;

    var d = lireLocal();
    var nom = (d.riotName || "").trim();
    var tag = (d.riotTag || "").trim().replace(/^#/, "");

    if (!ENDPOINT || !nom || !tag) { etat = "fini"; montrerManuel(""); return; }

    etat = "encours";
    /* Rien à valider tant que l'analyse tourne : laisser le bouton actif
       enverrait le visiteur sur un tableau de bord encore vide. */
    if (boutonSuivant) boutonSuivant.disabled = true;
    if (manuel) manuel.hidden = true;
    if (res) res.hidden = true;
    if (load) load.hidden = false;
    if (titre) titre.textContent = "On récupère tes stats";
    departRecup = Date.now();
    poser(3, "Récupération de tes parties");

    var url = ENDPOINT + (ENDPOINT.indexOf("?") > -1 ? "&" : "?") +
      "nom=" + encodeURIComponent(nom) +
      "&tag=" + encodeURIComponent(tag) +
      "&region=" + encodeURIComponent(d.region || "euw");

    var dernier = null;
    var meilleurStock = -1;
    var debut = Date.now();

    try {
      for (var i = 0; i < MAX_TENTATIVES; i++) {
        var r = await unAppel(url);

        if (r.statut === 404) {
          montrerManuel("Compte introuvable sur cette région. Vérifie ton pseudo et ta région, ou renseigne tes moyennes ici.");
          return;
        }
        /* Une limite atteinte n'est pas un échec : on patiente et on reprend. */
        if (r.statut === 429) { await attendre(3000); continue; }
        if (!r.ok || !r.data || !r.data.stats) {
          if (dernier) break;   /* on a déjà quelque chose d'exploitable */
          montrerManuel("On n'a pas pu récupérer tes stats. Renseigne-les ici, ça prend une minute.");
          return;
        }

        dernier = r.data;
        var c = r.data.couverture || {};
        var stock = c.stockees || 0;
        var saison = c.saison || 0;

        avancer(saison ? (stock / saison) : 0.08, stock, saison);

        if (c.complete) { avancer(1, stock, saison); break; }
        if (stock > meilleurStock) meilleurStock = stock;

        await attendre(DELAI);
      }

      if (!dernier) {
        montrerManuel("On n'a pas pu récupérer tes stats. Renseigne-les ici, ça prend une minute.");
        return;
      }

      var s = dernier.stats;
      var cf = dernier.couverture || {};

      /* Saison vide au bout de la boucle : rien à afficher, et surtout pas
         les zéros renvoyés, qui fausseraient toute l'analyse. */
      if (!s.games || cf.stockees === 0) {
        montrerAttente("Legends Tracker analyse ta saison");
        return;
      }

      var arrondi = function (v, n) {
        if (v === null || v === undefined || !isFinite(v)) return null;
        var f = Math.pow(10, n);
        return Math.round(v * f) / f;
      };

      var valeurs = {
        games: s.games,
        wr: arrondi(s.wr, 1),
        cs: arrondi(s.cs, 1),
        kda: arrondi(s.kda, 2),
        kp: arrondi(s.kp, 0),
        dpm: arrondi(s.dpm, 0),
        gpm: arrondi(s.gpm, 0),
        early: arrondi(s.early, 0)
      };

      var n = (typeof window.lpRemplirStats === "function") ? window.lpRemplirStats(valeurs) : 0;
      if (!n) { montrerManuel("Aucune stat exploitable pour ce compte. Renseigne tes moyennes ici."); return; }

      /* Les parties sont en main : on déroule la seconde moitié, celle du
         traitement. Le compteur reste exact, il dit sur combien de parties
         l'analyse est faite. */
      await derouler(cf.stockees || s.games);
      afficher(valeurs, cf, dernier.attribution);

      if (window.lpTrack) {
        window.lpTrack("stats_auto_ok", { champs: n, complete: !!cf.complete, parties: cf.stockees || s.games });
      }
    } catch (e) {
      montrerManuel(e && e.name === "AbortError"
        ? "La récupération a mis trop de temps. Renseigne tes moyennes ici."
        : "On n'a pas pu récupérer tes stats. Renseigne-les ici, ça prend une minute.");
      if (window.lpTrack) window.lpTrack("stats_auto_ko", {});
    } finally {
      etat = "fini";
      if (load) load.hidden = true;
      if (boutonSuivant) boutonSuivant.disabled = false;
    }
  }

  /* Le visiteur garde la main sur ce qu'on a trouvé. */
  if (lienManuel) {
    lienManuel.addEventListener("click", function () {
      if (manuel) manuel.hidden = false;
      lienManuel.hidden = true;
      if (manuel && manuel.scrollIntoView) manuel.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  }

  /* Départ dès que l'écran devient visible. La classe is-on est posée par
     paint() : on l'observe plutôt que de dupliquer la logique de navigation. */
  if ("MutationObserver" in window) {
    new MutationObserver(function () {
      if (ecran.classList.contains("is-on")) recuperer();
    }).observe(ecran, { attributes: true, attributeFilter: ["class"] });
  }
  if (boutonSuivant) boutonSuivant.addEventListener("click", function () {
    setTimeout(function () { if (ecran.classList.contains("is-on")) recuperer(); }, 80);
  });
  if (ecran.classList.contains("is-on")) recuperer();
})();

/* ============================================================================
   SUIVI DE STATS  /  ACCÈS AU TABLEAU HORS DU CADRE
   ============================================================================

   Le tableau est encastré avec rm=minimal, ce qui masque les menus de
   Google : bon pour consulter, insuffisant pour trier, filtrer ou chercher,
   et étroit sur mobile. Ce bloc donne à l'élève le lien de son suivi.

   Deux sources possibles, une seule lecture : lpGetSheetUrl renvoie le lien
   du metafield quand le coach l'a posé, sinon celui que l'élève a relié
   lui-même. Le lien ouvert est l'URL d'origine, sans rm=minimal, pour que
   Google Sheets s'ouvre avec tous ses outils.
   ========================================================================= */
(function () {
  var zone = document.getElementById("lpSheetActions");
  if (!zone) return;

  var lien = document.getElementById("lpSheetOpen");
  var copier = document.getElementById("lpSheetCopy");
  var fait = document.getElementById("lpSheetCopied");
  var minuteur = null;

  function url() {
    try { return (window.lpGetSheetUrl ? window.lpGetSheetUrl() : "") || ""; }
    catch (e) { return ""; }
  }

  /* Le cadre ajoute rm=minimal pour masquer les menus. Ici on veut
     l'inverse : le tableau complet, avec ses outils. */
  function propre(u) {
    return String(u).replace(/([?&])rm=minimal(&|$)/, function (m, avant, apres) {
      return apres === "&" ? avant : "";
    }).replace(/[?&]$/, "");
  }

  function rafraichir() {
    var u = propre(url());
    var valide = /^https?:\/\//i.test(u);
    zone.hidden = !valide;
    if (valide && lien) lien.href = u;
  }

  if (copier) {
    copier.addEventListener("click", async function () {
      var u = propre(url());
      if (!u) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(u);
        } else {
          /* Navigateurs sans presse-papiers moderne, ou page non sécurisée. */
          var champ = document.createElement("textarea");
          champ.value = u;
          champ.setAttribute("readonly", "");
          champ.style.position = "fixed";
          champ.style.opacity = "0";
          document.body.appendChild(champ);
          champ.select();
          document.execCommand("copy");
          document.body.removeChild(champ);
        }
        if (fait) fait.textContent = "Lien copié";
      } catch (e) {
        /* Copie refusée : on montre quand même le lien, l'élève le prend. */
        if (fait) fait.textContent = "Copie refusée par le navigateur, utilise le bouton d'ouverture.";
      }
      clearTimeout(minuteur);
      minuteur = setTimeout(function () { if (fait) fait.textContent = ""; }, 2600);
      if (window.lpTrack) window.lpTrack("suivi_lien_copie", {});
    });
  }

  if (lien) {
    lien.addEventListener("click", function () {
      if (window.lpTrack) window.lpTrack("suivi_ouvert", {});
    });
  }

  /* L'élève peut relier ou changer son suivi sans recharger la page : on
     repasse après chaque action de cette zone. */
  ["lpSheetLinkSave", "lpSheetUnlink", "lpSheetLinkOpen"].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener("click", function () { setTimeout(rafraichir, 300); });
  });

  rafraichir();
})();


/* ============================================================================
   PAGE D'OFFRES  /  AIGUILLAGE DES LIENS DU TABLEAU DE BORD
   ============================================================================

   Tous les liens de cette page vers /pages/tableau-offres passent par ici
   au moment du clic, d'où qu'ils viennent : gabarit, blocs générés,
   fenêtres, vidéos d'intro.

     Formule recommandée connue : la page d'offres, avec cette formule
     mise en avant (?formule=…). Le visiteur a déjà répondu au parcours
     d'entrée, il n'a rien à ressaisir.
     Rang connu sans recommandation : la page d'offres telle quelle.
     Profil inconnu : le quiz de la home (/#offres), qui pose les
     questions que le tableau de bord n'a pas pu poser.

   Les élèves gardent la page d'offres sans changement.
   La redirection automatique du gabarit (une visite sur cinq) applique la
   même règle avec sa propre copie de ce calcul : à garder identiques.
   ========================================================================= */
(function () {
  var PAGE = "/pages/tableau-offres";
  var QUIZ = "/#offres";
  var FORMULES = ["novice", "intermediaire", "excellence"];

  function lire(cle) {
    try {
      return JSON.parse(window.lpAccountStorage.getItem(cle) || "null");
    } catch (e) {
      return null;
    }
  }

  function destination(source) {
    if (LP_IS_SUBSCRIBER) return PAGE;
    var depuis = "&from=" + encodeURIComponent(("dashboard-" + (source || "lien")).slice(0, 40));
    var reco = lire("lp_offre_reco_v1");
    if (reco && FORMULES.indexOf(reco.cle) > -1) return PAGE + "?formule=" + reco.cle + depuis;
    var base = lire("lp_synth_base_v2");
    if (base && base.tier) return PAGE + "?" + depuis.slice(1);
    return QUIZ;
  }
  window.lpDestinationOffres = destination;

  /* Un lien déjà aiguillé garde sa marque : s'il a été envoyé vers le
     quiz puis que le profil se complète, le clic suivant le réaiguille. */
  function versOffres(lien) {
    if (!lien) return false;
    if (lien.getAttribute("data-lp-vers-offres") === "1") return true;
    var href = lien.getAttribute("href") || "";
    return href === PAGE || href.indexOf(PAGE + "?") === 0 || href.indexOf(PAGE + "#") === 0;
  }

  function aiguiller(e) {
    var lien = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!versOffres(lien)) return;
    var source = lien.getAttribute("data-lp-offers-cta") || lien.getAttribute("data-lp-offre") || lien.id || "lien";
    var vers = destination(source);
    lien.setAttribute("data-lp-vers-offres", "1");
    lien.setAttribute("href", vers);
    /* Le menu contextuel prépare seulement le lien (ouvrir dans un onglet,
       copier l'adresse) : rien à mesurer tant qu'on n'y va pas. */
    if (e.type !== "contextmenu" && window.lpTrack) {
      window.lpTrack("offres_aiguillage", { source: source, vers: vers === QUIZ ? "quiz" : vers.indexOf("formule=") > -1 ? "offres-formule" : "offres" });
    }
  }

  /* Phase de capture : le lien est réécrit avant la navigation, qu'on
     clique, qu'on l'ouvre à la molette ou par le menu contextuel. */
  document.addEventListener("click", aiguiller, true);
  document.addEventListener("auxclick", aiguiller, true);
  document.addEventListener("contextmenu", aiguiller, true);
})();

  /* ==========================================================================
     NOTES DES MASTERCLASS (1 à 5 étoiles)
     - Moyenne et nombre de notes sur chaque carte (visibles par tous).
     - Sous le titre du lecteur : l'élève connecté note la masterclass ouverte.
       Recliquer sur sa note la retire.
     - Données : Worker via le proxy Shopify /apps/lp-dashboard/ratings
       (table D1 lp_masterclass_rating). Sans réponse du serveur, rien ne s'affiche.
     ========================================================================== */
  lpWhenDomReady(function () {
    var ENDPOINT = "/apps/lp-dashboard/ratings";
    var PLAYER_PREFIX = "https://iframe.mediadelivery.net/embed/381804/";
    var GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
    var config = window.lpAccountStorageConfig || {};
    var connecte = !!(config.enabled && config.customerId);
    var ratings = {};
    var mine = {};
    var charge = false;
    var videoOuverte = null;
    var envoiEnCours = {};

    var player = document.getElementById("videoPlayer");
    var titre = document.getElementById("videoInfoTitle");
    if (!player || !titre) return;

    function videoId(valeur) {
      var m = String(valeur || "").match(GUID);
      return m ? m[0].toLowerCase() : null;
    }
    function moyenne(n) {
      return Number(n).toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    }
    function notes(n) { return n + (n > 1 ? " notes" : " note"); }

    var style = document.createElement("style");
    style.id = "lpRatingStyles";
    style.textContent =
      ".card-rating-badge{position:absolute;left:10px;bottom:10px;z-index:4;display:inline-flex;align-items:center;gap:4px;padding:4px 9px;border-radius:999px;font-size:11px;font-weight:700;line-height:1.1;background:#121214c7;border:1px solid var(--lp-line-strong);color:var(--lp-ink);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}" +
      ".card-rating-badge__star{color:var(--lp-amber)}" +
      ".card-rating-badge__count{color:var(--lp-ink-faint);font-weight:600}" +
      ".lp-rate{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px 12px;margin-top:10px;color:var(--lp-ink-dim);font-size:14px}" +
      ".lp-rate[hidden],.lp-rate [hidden]{display:none}" +
      ".lp-rate__stars{display:inline-flex;gap:2px}" +
      ".lp-rate__star{width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:8px;background:transparent;color:var(--lp-ink-faint);font-size:28px;line-height:1;cursor:pointer;transition:color .12s ease,transform .12s ease}" +
      ".lp-rate__star.is-on{color:var(--lp-amber)}" +
      ".lp-rate__star:focus-visible{outline:2px solid #e3fc02;outline-offset:2px}" +
      ".lp-rate__star:disabled{cursor:default}" +
      "@media(hover:hover){.lp-rate__star:hover{transform:scale(1.12)}}" +
      ".lp-rate__avg{color:var(--lp-ink-faint);font-size:13px}" +
      ".lp-rate__msg{width:100%;font-size:12px;color:var(--lp-ink-faint)}" +
      "@media(max-width:767px){.card-rating-badge{left:8px;bottom:8px;padding:3px 7px;font-size:10px}}";
    document.head.appendChild(style);

    /* Bloc de notation sous le titre du lecteur. */
    var bloc = document.createElement("div");
    bloc.className = "lp-rate";
    bloc.id = "lpRate";
    bloc.hidden = true;
    bloc.innerHTML =
      (connecte ? '<span class="lp-rate__label" id="lpRateLabel">Ta note</span>' +
        '<div class="lp-rate__stars" role="group" aria-labelledby="lpRateLabel"></div>' : "") +
      '<span class="lp-rate__avg" aria-live="polite"></span>' +
      '<span class="lp-rate__msg" aria-live="polite"></span>';
    titre.insertAdjacentElement("afterend", bloc);
    var etoiles = [];
    var zone = bloc.querySelector(".lp-rate__stars");
    var moyenneEl = bloc.querySelector(".lp-rate__avg");
    var messageEl = bloc.querySelector(".lp-rate__msg");
    if (zone) {
      for (var i = 1; i <= 5; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "lp-rate__star";
        b.setAttribute("data-note", String(i));
        b.setAttribute("aria-label", "Noter " + i + " sur 5");
        b.textContent = "★";
        zone.appendChild(b);
        etoiles.push(b);
      }
      zone.addEventListener("mouseover", function (e) {
        var s = e.target.closest(".lp-rate__star");
        if (s) peindre(+s.getAttribute("data-note"));
      });
      zone.addEventListener("mouseleave", function () { peindre(mine[videoOuverte] || 0); });
      zone.addEventListener("click", function (e) {
        var s = e.target.closest(".lp-rate__star");
        if (s) noter(+s.getAttribute("data-note"));
      });
    }

    function peindre(n) {
      etoiles.forEach(function (s, idx) { s.classList.toggle("is-on", idx < n); });
    }

    function majBloc() {
      if (!videoOuverte || !charge) { bloc.hidden = true; return; }
      var agg = ratings[videoOuverte];
      var maNote = mine[videoOuverte] || 0;
      if (!connecte && !(agg && agg.count)) { bloc.hidden = true; return; }
      bloc.hidden = false;
      peindre(maNote);
      etoiles.forEach(function (s, idx) {
        s.setAttribute("aria-pressed", idx + 1 === maNote ? "true" : "false");
        s.disabled = !!envoiEnCours[videoOuverte];
      });
      moyenneEl.textContent = agg && agg.count
        ? "Moyenne " + moyenne(agg.average) + " / 5 · " + notes(agg.count)
        : "Pas encore de note : donne la tienne";
    }

    /* Pastille « ★ 4,6 · 12 » sur chaque carte notée. */
    function majCartes() {
      if (!charge) return;
      document.querySelectorAll("#lpMasterclassCards .card, #lpStarterCards .card").forEach(function (card) {
        var wrap = card.querySelector(".card-image");
        if (!wrap) return;
        var agg = ratings[videoId(card.id)];
        var badge = wrap.querySelector(".card-rating-badge");
        if (!agg || !agg.count) { if (badge) badge.remove(); return; }
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "card-rating-badge";
          badge.innerHTML = '<span class="card-rating-badge__star" aria-hidden="true">★</span><span class="card-rating-badge__avg"></span><span class="card-rating-badge__count"></span>';
          wrap.appendChild(badge);
        }
        badge.querySelector(".card-rating-badge__avg").textContent = moyenne(agg.average);
        badge.querySelector(".card-rating-badge__count").textContent = "· " + agg.count;
        badge.setAttribute("aria-label", "Note moyenne " + moyenne(agg.average) + " sur 5, " + notes(agg.count));
        badge.title = "Note moyenne des élèves : " + moyenne(agg.average) + " / 5 (" + notes(agg.count) + ")";
      });
    }

    function noter(n) {
      var id = videoOuverte;
      if (!connecte || !id || envoiEnCours[id]) return;
      var avant = mine[id] || 0;
      var note = n === avant ? 0 : n;
      if (note) mine[id] = note; else delete mine[id];
      envoiEnCours[id] = true;
      messageEl.textContent = "";
      majBloc();
      fetch(ENDPOINT, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ videoId: id, stars: note })
      }).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      }).then(function (data) {
        ratings[id] = { count: data.count, average: data.average };
        if (data.mine) mine[id] = data.mine; else delete mine[id];
        if (window.lpTrack) window.lpTrack("masterclass_note", { video_id: id, titre: titre.textContent || "", note: note, note_avant: avant });
        if (videoOuverte === id) messageEl.textContent = note ? "Merci, ta note est enregistrée." : "Ta note est retirée.";
      }).catch(function () {
        if (avant) mine[id] = avant; else delete mine[id];
        if (videoOuverte === id) messageEl.textContent = "Ta note n'a pas pu être enregistrée. Réessaie dans un instant.";
      }).then(function () {
        delete envoiEnCours[id];
        majBloc();
        majCartes();
      });
    }

    /* La vidéo ouverte se lit sur le src du lecteur : couvre la bibliothèque,
       le starter pack, les recommandations et les objectifs. */
    function surLecteur() {
      var src = player.getAttribute("src") || "";
      videoOuverte = src.indexOf(PLAYER_PREFIX) === 0 ? videoId(src.slice(PLAYER_PREFIX.length)) : null;
      messageEl.textContent = "";
      majBloc();
    }
    new MutationObserver(surLecteur).observe(player, { attributes: true, attributeFilter: ["src"] });

    /* Les cartes sont retriées ou recopiées (starter pack) : on repose les pastilles. */
    var planifie = false;
    function planifierCartes() {
      if (planifie) return;
      planifie = true;
      requestAnimationFrame(function () { planifie = false; majCartes(); });
    }
    ["lpMasterclassCards", "lpStarterCards"].forEach(function (cid) {
      var el = document.getElementById(cid);
      if (el) new MutationObserver(planifierCartes).observe(el, { childList: true });
    });

    fetch(ENDPOINT, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        ratings = (data && data.ratings) || {};
        mine = (data && data.mine) || {};
        if (!data || data.mine === null) {
          connecte = false;
          bloc.querySelectorAll(".lp-rate__label, .lp-rate__stars").forEach(function (el) { el.hidden = true; });
        }
        charge = true;
        majCartes();
        surLecteur();
      })
      .catch(function () { /* Worker pas encore déployé ou indisponible : la page reste comme avant. */ });
  });


  function lpRunDomReady() { lpDomReadyCallbacks.forEach(function (callback) { callback(); }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", lpRunDomReady, { once: true });
  else lpRunDomReady();
});
